import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import { alpha } from '@mui/material/styles';
import {
    Box,
    Typography,
    Button,
    TextField,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, 
    TablePagination, 
    Alert, 
    Checkbox,
    Card,
    CardContent ,
    Divider,
    ListItemText,
    Tooltip,
    FormGroup,
    Collapse
} from "@mui/material";
import ChecklistIcon from '@mui/icons-material/Checklist';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Grid from "@mui/material/Grid";
import Chip from '@mui/material/Chip';
import CheckIcon from "@mui/icons-material/Check";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import EditIcon from '@mui/icons-material/Edit';
import ContactsIcon from '@mui/icons-material/Contacts';
import ReceiptIcon from '@mui/icons-material/Receipt';
import Avatar from "@mui/material/Avatar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
// Import your MUI controller hook
import { useMaterialUIController } from "../../context";
import AsyncSearch from "../../components/AsyncSearch";
 import PaymentsIcon from '@mui/icons-material/Payments';
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import { getCurrentUser } from 'aws-amplify/auth';
import Snackbar from "@mui/material/Snackbar";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { Tabs, Tab } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MaterialReactTable } from 'material-react-table';
import * as XLSX from "xlsx";
import {Stack} from "@mui/system";
import {PopupContext} from "../../context/popupContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import LeadSourcePie from "./leadSourceChart";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import BarChartIcon from '@mui/icons-material/BarChart';
const getEventTypeColor = (type, darkMode, defaultColor) => {
    switch (type) {
        case 'ברחן': return 'blue';
        case 'נזק': return 'orange';
        case 'תאונה': return 'red';
        default: return defaultColor;
    }
};
const raf = (fn) => requestAnimationFrame(fn);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function getHeaderCells(containerEl) {
    if (!containerEl) return [];
    const thead = containerEl.querySelector("thead");
    if (!thead) return [];
    return Array.from(thead.querySelectorAll("th"));
}

function getFirstFullyVisibleIndex(containerEl, headerCells) {
    if (!containerEl || headerCells.length === 0) return 0;
    const left = containerEl.scrollLeft;
    // find the first header whose left edge is >= current scrollLeft (with a small tolerance)
    const idx = headerCells.findIndex((th) => th.offsetLeft >= left - 2);
    return Math.max(0, idx === -1 ? 0 : idx);
}

function getColumnsPerPage(containerEl, headerCells, startIdx) {
    if (!containerEl || headerCells.length === 0) return 1;
    const viewport = containerEl.clientWidth;
    let sum = 0;
    let count = 0;
    for (let i = startIdx; i < headerCells.length; i++) {
        const w = headerCells[i].offsetWidth;
        if (sum + w <= viewport || count === 0) {
            sum += w;
            count++;
        } else {
            break;
        }
    }
    return Math.max(1, count);
}

function scrollToColumn(containerEl, headerCells, idx) {
    if (!containerEl || !headerCells[idx]) return;
    containerEl.scrollTo({ left: headerCells[idx].offsetLeft, behavior: "smooth" });
}
const renderLeadMini = (lead) => {
    if (!lead) return '—';
    const initials = (lead.full_name || lead.email || '?')[0].toUpperCase();
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar sx={{ width: 24, height: 24 }}>{initials}</Avatar>
            <Box>
                <Typography variant="body2" noWrap>{lead.full_name || lead.email}</Typography>
                <Typography variant="caption" noWrap>{lead.phone_number}</Typography>
            </Box>
        </Box>
    );
};

const getNowLocal = () => {
    const now = new Date();
    const tzOffset = now.getTimezoneOffset() * 60000;      // ms offset
    const localISO = new Date(now.getTime() - tzOffset)   // UTC→local
        .toISOString()
        .slice(0, 16);                                       // "YYYY-MM-DDTHH:mm"
    return localISO;
};

const handling_agents = ['מאיר', 'עומרי', 'רועי', 'עומרי/רועי', 'משה'];
const STATUS_OPTIONS = [
    'קבלה',
    'שיחת בירור ראשונית',
    'נקבעה פגישה',
    'נשלחה הצעת מחיר',
    'נדחה',
    'נסגר',
    'לא רלוונטי',
];
const LEAD_SOURCE_OPTIONS = [
    'פנימי',
    'הפניה /המלצה',
    'דיגיטל',
    'אפ סייל',
];
// Safe filter for multi-select on string cell values
const multiSelectStringFilter = (row, columnId, filterValue) => {
    const selected = Array.isArray(filterValue)
        ? filterValue
        : (filterValue ? [filterValue] : []);
    if (!selected.length) return true;
    const val = String(row.getValue(columnId) ?? '').trim();
    return selected.some(s => String(s ?? '').trim() === val);
};
function HandlingAgentFilter({ column }) {
    const value = column.getFilterValue();
    const arr = Array.isArray(value) ? value : (value ? [value] : []);
    return (
        <FormControl size="small" fullWidth variant="standard">
            <InputLabel id="handling-agent-filter-label">סוכן מטפל</InputLabel>
            <Select
                labelId="handling-agent-filter-label"
                multiple
                value={arr}
                onChange={(e) => {
                    const v = e.target.value;
                    column.setFilterValue(Array.isArray(v) ? v : (v ? [v] : []));
                }}
                renderValue={(sel) => (sel && sel.length ? sel.join(', ') : 'All')}
            >
                {handling_agents.map((opt) => (
                    <MenuItem key={opt} value={opt} sx={{ py: 0.5, minHeight: 28 }}>
                        <Checkbox size="small" checked={arr.includes(opt)} />
                        <ListItemText primary={opt} primaryTypographyProps={{ fontSize: 13 }} />
                    </MenuItem>
                ))}
            </Select>
            {arr.length > 0 && (
                <Button size="small" onClick={() => column.setFilterValue([])} sx={{ mt: 0.5 }}>
                    נקה
                </Button>
            )}
        </FormControl>
    );
}
// Keep only one column filter in state and normalize its value


export const makeVideoThumb = (file, max = 200) =>
    new Promise((resolve) => {
        const video = document.createElement("video");
        video.src = URL.createObjectURL(file);
        video.preload = "metadata";
        video.muted = true;                 // iOS/Safari needs this
        video.playsInline = true;

        // Grab something ≈1 s in – avoids black first frame
        video.onloadeddata = () => {
            video.currentTime = Math.min(1, video.duration / 2);
        };

        video.onseeked = () => {
            const cvs = document.createElement("canvas");
            const scale = Math.min(max / video.videoWidth, max / video.videoHeight);
            cvs.width  = Math.round(video.videoWidth  * scale);
            cvs.height = Math.round(video.videoHeight * scale);
            cvs.getContext("2d").drawImage(video, 0, 0, cvs.width, cvs.height);

            cvs.toBlob((blob) => {
                resolve(
                    new File(
                        [blob],
                        `thumb-${file.name.replace(/\.[^.]+$/, ".jpg")}`,
                        { type: "image/jpeg" }
                    )
                );
            }, "image/jpeg", 0.8);
        };
    });

const guessIcon = (mime) => {
    if (mime.includes("spreadsheet"))           return "xlsx";
    if (mime === "application/pdf")             return "pdf";
    if (mime.includes("zip"))                   return "zip";
    return "generic"; // fallback
};

// ...existing code...


function convertToMySQLDatetime(datetimeStr) {
    if (!datetimeStr) return null;
    // Split the string at the "T" character
    const parts = datetimeStr.split("T");
    if (parts.length !== 2) return datetimeStr; // Return original if unexpected format

    let datePart = parts[0];
    let timePart = parts[1];

    // If timePart does not include seconds (i.e. only one colon is present), add ":00"
    if ((timePart.match(/:/g) || []).length === 1) {
        timePart = `${timePart}:00`;
    }
    console.log(`${datePart} ${timePart}`);
    return `${datePart} ${timePart}`;
}

function toMySQLDateTime(dateObj) {
    // helper: pad single-digit numbers to two digits
    const pad = (n) => String(n).padStart(2, "0");

    const Y  = dateObj.getFullYear();
    const M  = pad(dateObj.getMonth() + 1);
    const D  = pad(dateObj.getDate());
    const h  = pad(dateObj.getHours());
    const m  = pad(dateObj.getMinutes());
    const s  = pad(dateObj.getSeconds());

    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}

const formatDuration = (seconds) => {
    const secNum = parseInt(seconds, 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor((secNum % 3600) / 60);
    const secs = secNum % 60;
    // Pad with zeros if needed.
    const pad = (num) => (num < 10 ? "0" + num : num);
    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
};

const formatTimestamp = (isoString) => {
    if (!isoString) return "";
    const dateObj = new Date(isoString);
    // Using the timeZone "Europe/Athens" for GMT+2.
    // Adjust locale or timeZone if needed.
    const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Athens" };
    const optionsTime = { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZone: "Europe/Athens" };
    const formattedDate = dateObj.toLocaleDateString("en-GB", optionsDate);
    const formattedTime = dateObj.toLocaleTimeString("en-GB", optionsTime);
    return (
        <>
            {formattedDate}
            <br />
            {formattedTime}
        </>
    );
};


const makeImageThumb = (file, max = 200) => new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
        const scale = Math.min(max / img.width, max / img.height);
        const cvs   = document.createElement("canvas");
        cvs.width   = Math.round(img.width  * scale);
        cvs.height  = Math.round(img.height * scale);
        cvs.getContext("2d").drawImage(img, 0, 0, cvs.width, cvs.height);
        cvs.toBlob((blob) => {
            resolve(new File([blob], `thumb-${file.name.replace(/\.[^.]+$/, '.jpg')}`, {
                type: "image/jpeg"
            }));
        }, "image/jpeg", 0.8);
    };
});


async function processAttachment(file) {
    const isTS = file.type === "video/vnd.dlna.mpeg-tts"
        || /\.ts$/i.test(file.name)

    if (file.type.startsWith("image/")) {
        const thumb = await makeImageThumb(file, 200);
        return { original: file, thumbnail: thumb };
    }

    // only thumbnail “real” videos browsers support
    if (!isTS && file.type.startsWith("video/")) {
        const thumb = await makeVideoThumb(file, 200);
        return { original: file, thumbnail: thumb };
    }

    // fallback for TS or any other unknown type
    return { original: file, icon: guessIcon(file.type) };
}

const getImageSrc = (att) => {
    if (att.thumbUrl) return att.thumbUrl;
    if (att.type.startsWith("image/")) {
        // fallback: add a resize query param (if CDN/S3 signed URLs support it)
        return `${att.url}?w=80&h=80&fit=crop`;
    }
    return att.url;
};
const HOT_MAP = {
    0: { label: 'Low',    color: '#4CAF50' },  // green
    1: { label: 'Medium', color: '#FFC107' },  // yellow (amber)
    2: { label: 'High',    color: '#F44336' },  // red
};

const PROGRESS_MAP = {
    30: 'נשלחה הצעה',
    50: 'נחתם ע"י הלקוח',
    100: 'נחתם ע"י 2 הצדדים'
};

const PROGRESS_OPTIONS = [
    { value: 30, label: 'נשלחה הצעה' },
    { value: 50, label: 'נחתם ע"י הלקוח' },
    { value: 100, label: 'נחתם ע"י 2 הצדדים' }
];

const eventTypeOptions = ['ברחן','תאונה','נזק','אחר'];
const MasterSales = () => {
    const [leads, setLeads] = useState([]);
    const [showEditSaleModal, setShowEditSaleModal] = useState(false);
    const [editSaleFormData, setEditSaleFormData]   = useState(null);
    const [monthlyTouched, setMonthlyTouched] = useState(false);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [alertMsg, setAlertMsg] = useState("");
    const [confirmDelete, setConfirmDelete] = useState({
        open: false,
        event: null,
    });
    const [globalFilter, setGlobalFilter] = useState("");
    const [showGlobalFilter, setShowGlobalFilter] = useState(false);
    const [columnFilters, setColumnFilters] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // <=600px
    const tableRef = useRef(null);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const tableContainerRef = useRef(null);
    const [nav, setNav] = useState({ canLeft: false, canRight: false, startIdx: 0 });
    const [showChartModal, setShowChartModal] = useState(false);
    const [salesCases, setSalesCases] = useState([]);
    const [salesCasesLoading, setSalesCasesLoading] = useState(false);
    const [salesCasesErr, setSalesCasesErr] = useState(null);
    const [quotesExpanded, setQuotesExpanded] = useState({});
    const [salesExpanded, setSalesExpanded] = useState({});
    const [saleComments, setSaleComments] = useState([]);
    const [saleCommentsLoading, setSaleCommentsLoading] = useState(false);
    const [newSaleComment, setNewSaleComment] = useState('');
    // MENTIONS AUTOCOMPLETE
    const [mentionActive, setMentionActive] = useState(false);
    const [mentionQuery, setMentionQuery] = useState('');
    const [mentionSuggestions, setMentionSuggestions] = useState([]);
    const [leadComments, setLeadComments] = useState([]);
    const [leadCommentsLoading, setLeadCommentsLoading] = useState(false);
    const [newLeadComment, setNewLeadComment] = useState('');
    const mentionFetchTimer = useRef(null);
    const [leadReturnEnabled, setLeadReturnEnabled] = useState(false);
    const [leadReturnDate, setLeadReturnDate] = useState(getNowLocal());
    const [leadReturnSaving, setLeadReturnSaving] = useState(false);
    const [showCreateCaseModal, setShowCreateCaseModal] = useState(false);
    const [saleSourceRow, setSaleSourceRow] = useState(null);
    const [createCaseForm, setCreateCaseForm] = useState({
        CaseName: "",
        CompanyName: "",
        Nickname: "",
        ContactPersonName: "",
        ContactPersonPhone: "",
        ContactEmail: "",
        SecondaryContactPersonName: "",
        SecondaryContactEmail: "",
        SecondaryContactPersonPhone: "",
        CaseDescription: "",
        Address: "",
    });
    const [showCreateProjectModal, setShowCreateProjectModal] = useState(false);
    const [createProjectForm, setCreateProjectForm] = useState({
        CaseId: null,
        ProjectName: '',
        ParkingFullName: '',
        ParkingEmail: '',
        ParkingAddress: '',
        ParkingPhoneNumber: '',
    });
    const [showEditCaseModal, setShowEditCaseModal] = useState(false);
    const [editCaseForm, setEditCaseForm] = useState(null);
    const handlingAgents = ['מאיר','עומרי','רועי','עומרי/רועי','משה'];
    // Separate filter states for each tab
    const [selectedAgentsLeads, setSelectedAgentsLeads] = useState([]);
    const [selectedAgentsQuotes, setSelectedAgentsQuotes] = useState([]);
    const [selectedAgentsSales, setSelectedAgentsSales] = useState([]);
    const [showEditProjectModal, setShowEditProjectModal] = useState(false);
    const [editProjectForm, setEditProjectForm] = useState(null);
    const [showMyToday, setShowMyToday] = useState(false);
    const [showChecklistModal, setShowChecklistModal] = useState(false);
    const [saleChecklist, setSaleChecklist] = useState({
        SaleId: null,
        ProjectId: '',
        ProjectName: '',
        CompanyName: '',
        ChargePermission: false,
        DepositRequired: false,
        ClearingAgreementSigned: false,
        ParkingCreatedInFinance: false,
        FinanceRowCreated: false,
        MeirApproved: false,
        ApprovedForExecution: false,
        AdvanceAmount: null, // for 50% advance
    });
    const [financeCreated, setFinanceCreated] = useState(false);

    const handleCreateCaseChange = (e) => {
        const { name, value } = e.target;
        setCreateCaseForm(prev => ({ ...prev, [name]: value }));
    };
    async function handleCreateFinanceRow() {
        // Example: gather data from saleChecklist or other relevant state
        const addPlacepayload = {
            clientNum: null,
            placeName: saleChecklist.ProjectName || saleChecklist.CompanyName || null,
            placeId: null,
            companyName: saleChecklist.CompanyName || null,
            pangoCommissionPercentage: 0.0100,
            celloCommissionPercentage:  0.0100,
            ccardCommissionPercentage:  0.0100,
            bluePayCommissionPercentage:  0.0220,
            stationsNum: 0,
            contractType: null,
            monthlyDigitalPrice: 0,
            monthlyTerminalPrice: 0,
            DCODE: null,
            contractStartDate: null,
            contractEndDate: null,
            contractNotActive: 0,
            notActiveFrom: null,
            pango: 0,
            cello: 0,
            credit: 0,
            bluepay: 0,
            prevPango: 0,
            prevCello: 0,
            prevCredit: 0,
            prevBluepay: 0,
            attachments: null,
            pay_condition: null,
            ProjectId: saleChecklist.ProjectId
        };

        const priorityReceiptsPayload = {
            placeId: null,
            clientNumber: null,
            clientName:  null,
            placeName: saleChecklist.ProjectName || saleChecklist.CompanyName || null,
            email: null,
            phone: null,
            access: null,                // set as needed
            accessLimit: null,           // set as needed
            accessLastDate: null,        // set as needed
            accountNumber: null,         // set as needed
            bankNumber: null,            // set as needed
            bankName: null,              // set as needed
            companyNumber: null,         // set as needed
            branchNum: null,             // set as needed
            accessGrantDate: null,       // set as needed
            sentFirstRequest: null,      // set as needed
            disconnectedCloud: null,     // set as needed
            sentRequest: null,           // set as needed
            needsFullDisconnection: null,// set as needed
            clientNotes: null,           // set as needed
            clientHandle: null,          // set as needed
            attachments: [],             // or null, or array of files/URLs
            dateSentFirstRequest: null,  // set as needed
            dateSentSecondRequest: null, // set as needed
            dateSentThirdRequest: null,  // set as needed
            sentFinanceFirst: null,      // set as needed
            sentFinanceSecond: null,     // set as needed
            sentFinanceThird: null       // set as needed
            };

        try {
            const res = await fetch('https://blue-parking-invite.bluept.dev/api/add-place-comissions', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(addPlacepayload)
            });
            if (!res.ok) throw new Error('Failed to create finance row');
            // Optionally show a success message or update UI

             const priorityRes = await fetch('https://blue-parking-invite.bluept.dev/api/priority-receipts', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(priorityReceiptsPayload) 
            });
            if (!priorityRes.ok) throw new Error('Failed to create priority receipt');

            setSaleChecklist(c => ({ ...c, FinanceRowCreated: true }));
        } catch (err) {
            alert('Error creating finance row: ' + err.message);
        }
    }
    const emailToAgent = {
        'royi@blueparking.co.il': 'רועי',
        'omri@blueparking.co.il': 'עומרי',
        'meir@blueparking.co.il': 'מאיר',
        'moshed@blueparking.co.il': 'משה',
        'vladimir@blueparking.co.il': 'ולדימיר',
    };

    const getAgentNameByEmail = (email) => {
        const clean = String(email).trim().toLowerCase();
        const bothAgents = 'עומרי/רועי';
        if (clean === 'royi@blueparking.co.il') {
            return ['רועי', bothAgents];
        }
        if (clean === 'omri@blueparking.co.il') {
            return ['עומרי', bothAgents];
        }
        return emailToAgent[clean] ? [emailToAgent[clean]] : null;
    }

    const saleMatchesAgents = useCallback((s, currentTabIndex) => {
        const selectedAgents = currentTabIndex === 0 ? selectedAgentsLeads : 
                              currentTabIndex === 1 ? selectedAgentsQuotes : 
                              selectedAgentsSales;
        if (!selectedAgents.length) return true;
        const saleAgent = String(s.HandlingAgent ?? s.handling_agent ?? '').trim();
        if (saleAgent && selectedAgents.includes(saleAgent)) return true;
        const leadAgent = leads.find(l => l.id === s.LeadId)?.handling_agent ?? '';
        return selectedAgents.includes(String(leadAgent).trim());
    }, [selectedAgentsLeads, selectedAgentsQuotes, selectedAgentsSales, leads]);

    const handleSubmitCreateCase = async () => {
        try {
            const resp = await fetch("https://blue-parking-invite.bluept.dev/api/add-case", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(createCaseForm),
            });
            const json = await resp.json();
            if (!resp.ok || !json.ok) throw new Error(json.error || "Failed to create case");
            setShowCreateCaseModal(false);
            await refreshSalesCases(); // reload cases
        } catch (e) {
            console.error(e);
        }
    };

    const handleOpenCreateProject = (caseRow) => {
        setCreateProjectForm({
            CaseId: caseRow.CaseId,
            ProjectName: '',
            ParkingFullName: caseRow.ParkingFullName || '',
            ParkingEmail: caseRow.ParkingEmail || '',
            ParkingAddress: caseRow.ParkingAddress || '',
            ParkingPhoneNumber: caseRow.ParkingPhoneNumber || ''
        });
        setShowCreateProjectModal(true);
    };
    const handleCreateProjectChange = (e) => {
        const { name, value } = e.target;
        setCreateProjectForm(prev => ({ ...prev, [name]: value }));
    };

    const handleOpenEditCaseModal = (caseObj) => {
        setEditCaseForm({
            CaseId: caseObj.CaseId,
            CaseName: caseObj.CaseName ?? '',
            CompanyName: caseObj.CompanyName ?? '',
            Nickname: caseObj.Nickname ?? '',
            Address: caseObj.Address ?? '',
            ContactPersonName: caseObj.ContactPersonName ?? '',
            ContactPersonPhone: caseObj.ContactPersonPhone ?? '',
            ContactEmail: caseObj.ContactEmail ?? '',
            SecondaryContactPersonName: caseObj.SecondaryContactPersonName ?? '',
            SecondaryContactPersonPhone: caseObj.SecondaryContactPersonPhone ?? '',
            SecondaryContactEmail: caseObj.SecondaryContactEmail ?? ''
        });
        setShowEditCaseModal(true);
    };

    const handleOpenEditProjectModal = (projectObj) => {
        setEditProjectForm({
            ProjectId: projectObj.ProjectId,
            CaseId: projectObj.CaseId,
            ProjectName: projectObj.ProjectName ?? '',
            ParkingFullName: projectObj.ParkingFullName ?? '',
            ParkingEmail: projectObj.ParkingEmail ?? '',
            ParkingPhoneNumber: projectObj.ParkingPhoneNumber ?? '',
            ParkingAddress: projectObj.ParkingAddress ?? '',
            ParkingCasualQty: projectObj.ParkingCasualQty ?? 0,
            ParkingSubscriberQty: projectObj.ParkingSubscriberQty ?? 0,
            ParkingDisabledQty: projectObj.ParkingDisabledQty ?? 0,
            SubscriberPricingRecommendation: projectObj.SubscriberPricingRecommendation ?? 'none',
            SubscriberRecommendedPrice: projectObj.SubscriberRecommendedPrice ?? '',
            CasualPricingRecommendation: projectObj.CasualPricingRecommendation ?? 'none',
            CasualRecommendedPrice: projectObj.CasualRecommendedPrice ?? '',
        });
        setShowEditProjectModal(true);
    };

    const handleEditCaseChange = (e) => {
        const { name, value } = e.target;
        setEditCaseForm(prev => ({ ...prev, [name]: value }));
    };

    const handleEditProjectChange = (e) => {
        const { name, value } = e.target;
        setEditProjectForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmitEditCase = async () => {
        try {
            const resp = await fetch('https://blue-parking-invite.bluept.dev/api/update-case', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(editCaseForm),
            });
            const json = await resp.json();
            if (!resp.ok || !json.ok) throw new Error(json.error || 'update case failed');
            setShowEditCaseModal(false);
            await refreshSalesCases();
        } catch (e) { console.error(e); }
    };

    const handleSubmitEditProject = async () => {
        try {
            const resp = await fetch('https://blue-parking-invite.bluept.dev/api/update-project', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(editProjectForm),
            });
            const json = await resp.json();
            if (!resp.ok || !json.ok) throw new Error(json.error || 'update project failed');
            setShowEditProjectModal(false);
            await refreshSalesCases();
        } catch (e) { console.error(e); }
    };
    const handleSubmitCreateProject = async () => {
        try {
            const resp = await fetch('https://blue-parking-invite.bluept.dev/api/add-project', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(createProjectForm),
            });
            const json = await resp.json();
            if (!resp.ok || !json.ok) throw new Error(json.error || 'Failed to create project');
            setShowCreateProjectModal(false);
            await refreshSalesCases(); // reload cases/projects
        } catch (e) {
            console.error(e);
        }
    };

    const handleSaveChecklist = async () => {
        console.log('saleChecklist.ProjectId:', saleChecklist.ProjectId);
        if (!saleChecklist.ProjectId) {
            setAlertMsg("ProjectId חסר");
            setOpenErrorAlert(true);
            return;
        }
        try {
            const payload = {
                ...saleChecklist,
                ChecklistCompletedAt: new Date().toISOString().replace('T', ' ').replace('Z', '').split('.')[0],
                ChecklistCompletedBy: userEmail,
            };
            const res = await fetch(
                `https://blue-parking-invite.bluept.dev/api/sales-project/${saleChecklist.ProjectId}/checklist`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );
            if (!res.ok) throw new Error("Checklist save failed");
            setAlertMsg("Checklist saved!");
            setOpenSuccessAlert(true);
            setShowChecklistModal(false);
            await refreshSalesCases();
            // Optionally refresh project/sales data here
        } catch (err) {
            setAlertMsg("Checklist save failed");
            setOpenErrorAlert(true);
        }
    };
    const recomputeNav = () => {
        const el = tableContainerRef.current;
        if (!el) return;
        const headerCells = getHeaderCells(el);
        const startIdx = getFirstFullyVisibleIndex(el, headerCells);
        const perPage = getColumnsPerPage(el, headerCells, startIdx);
        const maxStartIdx = Math.max(0, headerCells.length - perPage);
        setNav({
            startIdx,
            canLeft: startIdx > 0,
            canRight: startIdx < maxStartIdx,
        });
    };

    function extractMentionEmails(text) {
        if (!text) return [];
        const raw = [];
        // allow full emails and simple names; stop on whitespace or separators
        const re = /@([^\s,;:()<>]+)\b/g;
        let m;
        while ((m = re.exec(text))) {
            let tok = m[1].trim();               // without leading @
            // strip trailing punctuation
            tok = tok.replace(/[.,;:!?)\]]+$/, '');
            if (tok.includes('@')) {             // only keep real emails
            raw.push(tok);
            }
        }
        return [...new Set(raw)];
    }
    function highlightMentions(text) {
        const mentionColor = darkMode ? theme.palette.info.light : theme.palette.primary.dark;
        const re = /(@[^\s,;:()<>]+)\b/g;
        const parts = [];
        let lastIdx = 0;
        let m;
        while ((m = re.exec(text || ''))) {
            if (m.index > lastIdx) {
                parts.push(text.slice(lastIdx, m.index));
            }
            parts.push(
                <Box component="span" key={m.index} sx={{ color: mentionColor, fontWeight: 700 }}>
                    {m[1]}
                </Box>
            );
            lastIdx = m.index + m[0].length;
        }
        parts.push((text || '').slice(lastIdx));
        return parts;
    }

    // Open "Create Sale" modal from a Project row (Quotes tab)
function handleOpenCreateSaleForProject(projectRow) {
  const caseRow = projectRow.getParentRow()?.original || null;
  const projectOrig = projectRow.original;

  setSelectedLeadId(null);
  setSaleSourceRow(null);
  setSaleFormData(prev => ({
    ...prev,
    CaseId: caseRow?.CaseId ?? '',
    ProjectId: projectOrig?.ProjectId ?? '',
    ProjectName: projectOrig?.ProjectName ?? '',
    CompanyName: caseRow?.CompanyName ?? projectOrig?.CompanyName ?? '',
    Address: caseRow?.Address ?? projectOrig?.Address ?? '',
    ContactPersonName: caseRow?.ContactPersonName ?? '',
    ContactPersonPhone: caseRow?.ContactPersonPhone ?? '',
    ContactEmail: caseRow?.ContactEmail ?? '',
    Lanes: 1,
    TotalAmountInSale: 0,
    MonthlyAmountLeasing: 0,
    QuoteDate: new Date().toISOString().slice(0, 10),
    QuoteValidDate: '',
    SaleDate: '',
    ParkingAddress: caseRow?.ParkingAddress ?? '',
    ParkingFullName: caseRow?.ParkingFullName ?? '',
    ParkingEmail: caseRow?.ParkingEmail ?? '',
    ParkingPhoneNumber: caseRow?.ParkingPhoneNumber ?? '',
    SecondaryContactPersonName: caseRow?.SecondaryContactPersonName ?? '',
    SecondaryContactEmail: caseRow?.SecondaryContactEmail ?? '',
    SecondaryContactPersonPhone: caseRow?.SecondaryContactPersonPhone ?? '',
    items: [],
    attachments: [],
    LeadType: '',
    LeadSource: '',
    Progress: 0,
    Notes: '',
    Nickname: caseRow?.Nickname ?? ''
  }));
  setShowCreateSaleModal(true);
}

    function handleNewSaleCommentChange(e) {
        const v = e.target.value;
        setNewSaleComment(v);

        // detect last-typed @mention fragment (at end of input)
        const m = v.match(/(^|\s)@([^\s@]*)$/);
        if (m) {
            const q = m[2] || '';
            setMentionActive(true);
            setMentionQuery(q);

            // debounce fetch
            if (mentionFetchTimer.current) clearTimeout(mentionFetchTimer.current);
            mentionFetchTimer.current = setTimeout(async () => {
                try {
                    if (!q) { setMentionSuggestions([]); return; }
                    const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/users/suggest?q=${encodeURIComponent(q)}`)
                    const users = await resp.json();
                    const opts = (users || []).map(u => ({
                        label: u.email || [u.given_name, u.family_name].filter(Boolean).join(' '),
                        email: u.email || '',
                        name: [u.given_name, u.family_name].filter(Boolean).join(' ')
                    }));
                    setMentionSuggestions(opts.slice(0, 6));
                } catch {
                    setMentionSuggestions([]);
                }
            }, 180);
        } else {
            setMentionActive(false);
            setMentionQuery('');
            setMentionSuggestions([]);
        }
    }

    function insertMention(email) {
        setNewSaleComment(prev =>
            prev.replace(/(^|\s)@([^\s@]*)$/, (_, p1) => `${p1}@${email} `)
        );
        setMentionActive(false);
        setMentionQuery('');
        setMentionSuggestions([]);
    }
    // NEW: lead mention insertion
    function insertLeadMention(email) {
        setNewLeadComment(prev =>
            prev.replace(/(^|\s)@([^\s@]*)$/, (_, p1) => `${p1}@${email} `)
        );
        setMentionActive(false);
        setMentionQuery('');
        setMentionSuggestions([]);
    }
    // observe scroll + resize
    useEffect(() => {
        const el = tableContainerRef.current;
        if (!el) return;
        const handleScroll = () => raf(recomputeNav);
        const ro = new ResizeObserver(() => raf(recomputeNav));
        el.addEventListener("scroll", handleScroll, { passive: true });
        ro.observe(el);
        // initial
        raf(recomputeNav);
        return () => {
            el.removeEventListener("scroll", handleScroll);
            ro.disconnect();
        };
    }, []);

    const handlePage = (dir) => {
        const el = tableContainerRef.current;
        if (!el) return;
        const headerCells = getHeaderCells(el);
        const startIdx = getFirstFullyVisibleIndex(el, headerCells);
        const perPage = getColumnsPerPage(el, headerCells, startIdx);
        const nextIdx = Math.max(
            0,
            Math.min(
                headerCells.length - 1,
                dir === "right" ? startIdx + perPage : startIdx - perPage
            )
        );
        scrollToColumn(el, headerCells, nextIdx);
    };

    const checkCanScrollRight = () => {
        const el = tableRef.current;
        if (!el) return;
        const atEnd = Math.ceil(el.scrollLeft + el.clientWidth) >= el.scrollWidth;
        setCanScrollRight(!atEnd);
    };

    useEffect(() => {
        const el = tableRef.current;
        if (!el) return;
        checkCanScrollRight();
        const onScroll = () => checkCanScrollRight();
        el.addEventListener('scroll', onScroll);
        const ro = new ResizeObserver(() => checkCanScrollRight());
        ro.observe(el);
        return () => {
            el.removeEventListener('scroll', onScroll);
            ro.disconnect();
        };
    }, []);



// 2) handlers
    const { showPopup } = useContext(PopupContext);

    const [showCallHistoryModal, setShowCallHistoryModal] = useState(false);
    const [callHistoryList,       setCallHistoryList]   = useState([]);
    const [selectedLeadForCalls,  setSelectedLeadForCalls] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [openViewPaymentsModal, setOpenViewPaymentsModal] = useState(null);
    const [showCreateSaleModal, setShowCreateSaleModal] = useState(false);
    const [selectedLeadId,     setSelectedLeadId]     = useState(null);
    const [saleFormData, setSaleFormData] = useState({
        LeadType: "", LeadSource: "", Lanes: 1, TotalAmountInSale: 0,
        MonthlyAmountLeasing: 0, RevShareThreshold: 0,
        RevShareRatio: "",ContactEmail: "", Progress: 0, Notes: "", attachments: [], Address: "", CompanyName: "", ContactPersonName: "", ContactPersonPhone: "", SaleDate: undefined, ProjectName: "", ProjectId: "",
        QuoteDate: undefined,         // YYYY-MM-DD
        QuoteValidDate: undefined,    // YYYY-MM-DD
        items: [],             // will be an array of { itemNumber, itemName, quantity, price }
        callHistory: [],
          // NEW: prefilled from lead
        ParkingAddress: "",
        ParkingFullName: "",
        ParkingEmail: "",
        ParkingPhoneNumber: "",
        SecondaryContactPersonName: "",
        SecondaryContactEmail: "",
        SecondaryContactPersonPhone: "",
        Nickname: "",
        HandlingAgent: ""
    });

    const [sales, setSales] = useState([]); // This state is not used in the current code, consider removing it if unnecessary.
    // Use your controller to detect dark mode
    const [backupRow, setBackupRow] = useState(null);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const shownLeadsRef = useRef(new Set());

    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [createProgressError, setCreateProgressError] = useState(false);
    // FILTER STATE
    const [dateRange, setDateRange] = useState({ from: "", to: "" });
    const [carIdFilter, setCarIdFilter] = useState("");
    const [placeFilter, setPlaceFilter] = useState("");
    const [eventTypeFilter, setEventTypeFilter] = useState("");
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [mediaPreview, setMediaPreview] = useState({ url: "", type: "" });
    const [progressError, setProgressError] = useState(false);
    // logs modal states
    const [showLogsModal, setShowLogsModal] = useState(false);
    const [selectedLogs, setSelectedLogs] = useState([]);
    const [logsPage, setLogsPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const [showAll, setShowAll] = useState(false);
    const [showIrrelevant, setShowIrrelevant] = useState(false);
    const [salesPage, setSalesPage] = useState(0);
    const [callsHistory, setCallsHistory] = useState([]);
    const salesRowsPerPage = 10;
        const [quoteFrom, setQuoteFrom] = useState("");
    const [quoteTo, setQuoteTo] = useState("");
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [selectedLeadSources, setSelectedLeadSources] = useState([]);
    // Separate return date filters for each tab
    const [returnFromLeads, setReturnFromLeads] = useState("");
    const [returnToLeads, setReturnToLeads] = useState("");
    const [returnFromQuotes, setReturnFromQuotes] = useState("");
    const [returnToQuotes, setReturnToQuotes] = useState("");
    const [returnFromSales, setReturnFromSales] = useState("");
    const [returnToSales, setReturnToSales] = useState("");

    const handleColumnFiltersChange = useCallback((updater) => {
        setColumnFilters(prev => {
            const next = typeof updater === 'function' ? updater(prev) : updater;
            const entry = Array.isArray(next) ? next.find(f => f.id === 'handling_agent') : null;
            if (!entry) return []; // clear others
            const v = entry.value;
            const arr = Array.isArray(v) ? v : (v ? [v] : []);
            const unique = Array.from(new Set(arr.filter(Boolean)));
            return unique.length ? [{ id: 'handling_agent', value: unique }] : [];
        });
    }, []);
    const logsPerPage = 6;
    const handleOpenMedia = (attachment) => {
        setMediaPreview(attachment);
        setShowMediaModal(true);
    };

    const addCallEntry = () => {
        setFormData(prev => ({
            ...prev,
            callHistory: [
                ...prev.callHistory,
                { talked_with: '', call_date: getNowLocal(), return_date: '', notes: '' }
            ]
        }));
    };
    // useEffect(() => {
    //     const oneWeekMs = 7 * 24 * 60 * 60 * 1000;

    //     const checkAndPopup = () => {
    //         const now = Date.now();

    //         (filteredEvents || []).forEach((lead) => {
    //             const callsForLead = callsHistory.filter(c => c.lead_id === lead.id);

    //             // 2) get the timestamp of the last call (or 0 if none)
    //             const lastCallTs = callsForLead.length > 0
    //                 ? new Date(callsForLead[callsForLead.length - 1].call_date).getTime()
    //                 : 0;

    //             const lastReturnCallTs = callsForLead.length > 0
    //                 ? new Date(callsForLead[callsForLead.length - 1].return_date).getTime()
    //                 : 0;

    //             // 3) get the timestamp of last_contact
    //             const lastContactTs = new Date(lead.last_contact).getTime();

    //             // 4) referenceTs = the later of the two
    //             const referenceTs = Math.max(lastContactTs, lastCallTs);
    //             const reference2Ts = Math.max(referenceTs, lastReturnCallTs);
    //             // if older than a week, not "לא רלוונטי" and we haven't shown it before
    //             if (
    //                 now - reference2Ts > oneWeekMs &&
    //                 !lead.status?.includes('לא רלוונטי')
    //                 && callsHistory.filter(c=>c.lead_id===lead.id && now < new Date(c.return_date).getTime()).length===0 // no calls for this lead
    //                 && !shownLeadsRef.current.has(lead.id)
    //                 && filteredSales.filter(s=>s.LeadId === lead.id).length === 0 // no sales for this lead
    //             ) {


    //                 const dateStr = new Date(reference2Ts)
    //                     .toLocaleDateString('he-IL', {
    //                         day:   'numeric',
    //                         month: 'long',
    //                         year:  'numeric',
    //                     });
    //                 // call your popup
    //                 const companyPart = lead.company_name
    //                     ? ` (${lead.company_name})`
    //                     : '';



    //                 showPopup(
    //                     `לא נוצר קשר עם הליד ${lead.full_name}${companyPart} מאז ${dateStr}`,
    //                     () => handleOpenEditModal(lead)
    //                 );                    // mark as shown
    //                 shownLeadsRef.current.add(lead.id);
    //             }
    //         });
    //     };

    //     // run immediately…
    //     checkAndPopup();
    //     // …and every minute
    //     const intervalId = setInterval(checkAndPopup, 60_000);

    //     return () => clearInterval(intervalId);
    // }, [filteredEvents, showPopup]);

    useEffect(() => {
        const oneWeekMs = 7 * 24 * 60 * 60 * 1000;
        const oneHourMs = 60 * 60 * 1000; // 1 hour

        const latestTsFromRow = (row) => {
            if (!row) return 0;

            const caseTs = row.ReturnDate ? new Date(row.ReturnDate).getTime() : 0;
            const projects = row.projects || row.subRows || [];
            const sales = projects.flatMap(p => p.sales || p.subRows || []);

            const salesMax = sales.reduce((max, s) => {
                const t = s.ReturnDate ? new Date(s.ReturnDate).getTime() : 0;
                return Math.max(max, t);
            }, 0);

            return Math.max(caseTs, salesMax);
        };

        const checkAndPopup = () => {
            const now = Date.now();
            (salesCases || []).forEach((c) => {
                const refTs = latestTsFromRow(c);
                if (!refTs) return; // skip cases with no ReturnDate anywhere
                if (now - refTs > oneWeekMs && !shownLeadsRef.current.has(`case-${c.CaseId}`)) {
                    const dateStr = new Date(refTs).toLocaleDateString('he-IL', { day: 'numeric', month: 'long', year: 'numeric' });
                    showPopup(`אין תאריך חזרה בתיק "${c.CaseName || '—'}" מאז ${dateStr}`, () => handleOpenEditCaseModal(c));
                    shownLeadsRef.current.add(`case-${c.CaseId}`);
                }
            });
        };

        // Run immediately on mount
        checkAndPopup();

        // Run every hour
        const intervalId = setInterval(checkAndPopup, oneHourMs);

        return () => clearInterval(intervalId);
    }, [salesCases, showPopup]);

    const handleCallEntryChange = (idx, field, value) => {
        setFormData(prev => {
            const ch = prev.callHistory.map((c,i) =>
                i===idx ? { ...c, [field]: value } : c
            );
            return { ...prev, callHistory: ch };
        });
    };

    const removeCallEntry = idx => {
        setFormData(prev => ({
            ...prev,
            callHistory: prev.callHistory.filter((_,i) => i!==idx)
        }));
    };

    const [paymentSale,        setPaymentSale]        = useState(null);   // row that was clicked
    const [payments,           setPayments]           = useState([]);     // data from GET
    const [loadingPayments,    setLoadingPayments]    = useState(false);
    const [editingIdx,         setEditingIdx]         = useState(null);   // row that is currently being edited
    const [newPayment,         setNewPayment]         = useState(null);   // {type, date}
    const SALE_TYPES_MAP = {        // % required for מכירה
        'מכירה': [0.5, 0.4, 0.1],
    };
    const [showEditModal, setShowEditModal] = useState(false);
    const [editFormData, setEditFormData] = useState(null);
    const handleCloseMediaModal = () => {
        setShowMediaModal(false);
        setMediaPreview({ url: "", type: "" });
    };
// Logs Modal handlers
    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (_, newIndex) => setTabIndex(newIndex);

    const quotesByLeadId = useMemo(() => {
        const map = new Map();
        (salesCases || []).forEach(c =>
            (c.projects || []).forEach(p =>
                (p.sales || []).forEach(s => {
                    map.set(String(s.LeadId), s);
                })
            )
        );
        return map;
    }, [salesCases]);

    const leadColumns = useMemo(
        () => [
                        {
                accessorKey: 'handling_agent',
                header: 'סוכן מטפל',
                size: 20,
                enableColumnFilter: false, // hide per-column filter UI for this column
            },
                        {
                accessorKey: 'ReturnDate',
                header: 'תאריך חזרה',
                size: 20,
                sortingFn: (a, b) => {
                    const ta = new Date((a.original.ReturnDate || '').replace(' ', 'T')).getTime() || 0;
                    const tb = new Date((b.original.ReturnDate || '').replace(' ', 'T')).getTime() || 0;
                    return ta - tb;
                },
                Cell: ({ cell }) => {
                    const raw = cell.getValue();
                    if (!raw) return '';
                    const norm = raw.includes(' ') ? raw.replace(' ', 'T') : raw;
                    // support YYYY-MM-DD and full ISO
                    const iso = /^\d{4}-\d{2}-\d{2}$/.test(norm) ? `${norm}T00:00:00` : norm;
                    const d = new Date(iso);
                    if (isNaN(d.getTime())) return '';
                    // match quotes/sales: date only
                    return d.toLocaleDateString('he-IL');
                },
            },
            {
                accessorKey: 'parking_address',
                header: 'כתובת חניון',
                size: 20,
            },

            // NEW: Parking full name
            {
                accessorKey: 'parking_full_name',
                header: 'שם חניון',
                size: 20,
            },

            // NEW: Nickname
            {
                accessorKey: 'nickname',
                header: 'כינוי',
                size: 16,
            },

            {
                accessorKey: 'full_name',
                header: 'שם מלא ',
                size: 20,
                enableColumnFilter: false, // hide per-column filter UI for this column
            },

            {
                accessorKey: 'phone_number',
                header: 'טלפון איש קשר',
                size: 20,
                enableColumnFilter: false, // hide per-column filter UI for this column
            },
                        {
                accessorKey: 'secondary_phone_number',
                header: 'טלפון איש קשר משני',
                size: 20,
                enableColumnFilter: false, // hide per-column filter UI for this column
            },
            {
                accessorKey: 'campaign_name',
                header: 'קמפיין',
                size: 20,
            },
            {
                accessorKey: 'hotness',
                header: 'עדיפות',
                size: 12,
                sortingFn: (a, b) => (b.original.hotness ?? 0) - (a.original.hotness ?? 0), // Hot first
                Cell: ({ cell }) => {
                    const v = cell.getValue() ?? 0;
                    const m = HOT_MAP[v] || HOT_MAP[0];
                    return (
                        <Box title={m.label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{
                                width: 12, height: 12, borderRadius: '50%', bgcolor: m.color,
                                boxShadow: 1
                            }} />
                            <Typography variant="caption">{m.label}</Typography>
                        </Box>
                    );
                },
            },
            {
                accessorKey: 'company_name',
                header: 'חברה',
                size: 20,
                // ...compactCell
            },
            {
                accessorKey: 'status',
                header: 'סטטוס',
                size: 20,
                // ...compactCell

            },
            {
                accessorKey: 'last_contact',
                header: 'קשר אחרון',
                size: 20,
                Cell: ({ cell }) => {
                    const isoString = cell.getValue();
                    if (!isoString) return '';
                    const dateObj = new Date(isoString);
                    const optionsDate = { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Athens' };
                    return (
                        <>
                            {dateObj.toLocaleDateString('en-GB', optionsDate)}
                            <br />
                        </>
                    );
                },
                // ...compactCell
            },
            {
                accessorKey: 'creation_date',
                header: 'תאריך יצירה',
                size: 20,
                Cell: ({ cell }) => {
                    const isoString = cell.getValue();
                    if (!isoString) return '';
                    const dateObj = new Date(isoString);
                    const optionsDate = { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Athens' };
                    return (
                        <>
                            {dateObj.toLocaleDateString('en-GB', optionsDate)}
                            <br />
                        </>
                    );
                },
                // ...compactCell
            },
            {
                id: 'quoteLink',
                header: 'הצעת מחיר ⇢',
                enableSorting: false,
                Cell: ({ row }) => {
                    const quote = quotesByLeadId.get(String(row.original.id));
                    if (!quote) return '—';

                    return (
                        <Chip
                            label={`QT-${quote.SaleId}`}
                            color="warning"
                            size="small"
                            onClick={() => {
                                setTabIndex(1);            // jump to Quote tab
                                setSearchTerm(String(quote.SaleId));
                            }}
                        />
                    );
                },
                // ...compactCell
            },
            {
                accessorKey: 'email',
                header: 'דואר אלקטרוני',
                size: 20,
                // ...compactCell
            },
            {
                accessorKey: 'lead_source',
                header: 'מקור',
                size: 20,
                // ...compactCell
            },

            {
                accessorKey: 'lead_agent',
                header: 'סוכן ראשוני',
                size: 20,
                // ...compactCell

            },

            {
                id: 'searchableLead',
                header: 'Search Data',
                accessorFn: (row) => [
                    String(row.id ?? ''),
                    row.email,
                    row.parking_email,
                    row.parking_phone_number,         // NEW
                    row.full_name,
                    row.parking_full_name,     // NEW
                    row.phone_number,
                    row.company_name,
                    row.address,
                    row.parking_address,       // NEW
                    row.lead_source,
                    row.lead_agent,
                    row.handling_agent,
                    row.status,
                    row.campaign_name,
                        // NEW: include newly added fields
                    row.nickname,
                    row.secondary_phone_number,
                    row.secondary_full_name,
                    row.secondary_email,
                    row.company_id,
                    row.lanes_number,
                ].filter(Boolean).join(' '),
                enableColumnFilter: false,
                enableSorting: false,
                enableHiding: true,
                enableGlobalFilter: true,
                // hide from UI completely
                muiTableHeadCellProps: { sx: { display: 'none' } },
                muiTableBodyCellProps: { sx: { display: 'none' } },
                size: 0,
            },
            // (We’ll add “Actions” via getRowActions—no explicit column here)
        ],
        [quotesByLeadId]
    );
    const quoteJumpCol = {
        id: 'quoteJump',
        header: 'הצעת מחיר ⇢',
        enableSorting: false,
        Cell: ({ row }) => (
            <Chip
                label={`QT-${row.original.SaleId}`}
                color="warning"
                size="small"
                onClick={() => {
                    setTabIndex(1);                       // go to Quote tab
                    setSearchTerm(String(row.original.SaleId)); // filter to this quote
                }}
            />
        ),
    };

    const formatCurrency = (value) =>
        value != null
            ? value
                .toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
            : '';

    const filteredSales = useMemo(() => {
        const st = String(searchTerm).trim().toLowerCase();
        if (st === "") {
            return sales;
        }
        if (/^\d+$/.test(st)) {
            return sales.filter(s => String(s.SaleId).includes(st)
                || String(s.LeadId).includes(st));
        }
        // 2.a) build a Set of lead IDs whose email/full_name/phone matches `st`
        const matchingLeadIds = new Set(
            leads
                .filter((l) => {
                    return (
                        (l.email       || "").toLowerCase().includes(st) ||
                        (l.full_name   || "").toLowerCase().includes(st) ||
                        (l.phone_number|| "").toLowerCase().includes(st)
                    );
                })
                .map((l) => l.id) // assume your lead’s primary key is `id`
        );

        // 2.b) only keep sales whose LeadId is in that Set
        return sales.filter((s) => matchingLeadIds.has(s.LeadId));
    }, [searchTerm, sales, leads]);
    const { quoteSales, completedSales } = useMemo(() => {
        const quote   = filteredSales;
        const done    = filteredSales.filter(s => Number(s.Progress) === 100);
        return { quoteSales: quote, completedSales: done };
    }, [filteredSales]);


    const leadChipCol = {
        id: 'leadLink',
        header: 'ליד ⇢',
        enableSorting: false,
        Cell: ({ row }) => {
            const lead = leads.find(l => l.id === row.original.LeadId);
            if (!lead) return '—'
            return (
                <Chip
                    label={`LD-${lead.id}`}        // or just `${lead.id}` if you prefer
                    size="small"
                    color="primary"
                    onClick={() => {
                        setTabIndex(0)               // go back to your Leads tab
                        setSearchTerm( lead.id);
                    }}
                />
            )
        },
    }

    const salesColumns = useMemo(
        () => [
            leadChipCol,
            {
                id: 'saleLink',
                header: 'מכירה ⇢',
                enableSorting: false,
                Cell: ({ row }) => {
                    const saleDone = completedSales.find(s => s.SaleId === row.original.SaleId);
                    if (!saleDone) return '—';        // quote never became a sale

                    return (
                        <Chip
                            label={`SL-${saleDone.SaleId}`}
                            color="success"
                            size="small"
                            onClick={() => {
                                setTabIndex(2);             // jump to Sales tab
                                setSearchTerm(String(saleDone.SaleId));
                            }}
                        />
                    );
                },
            },
            {
                id: 'actions',
                header: 'פעולות',
                size: 8,
                enableSorting: false,
                Cell: ({ row }) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={() => handleOpenEditSaleModal(row.original)}
                        >
                            Edit
                        </Button>
                    </Box>
                ),
            },
            {
                accessorKey: 'Hotness',
                header: 'עדיפות',
                size: 12,
                sortingFn: (a, b) => (b.original.Hotness ?? 0) - (a.original.Hotness ?? 0), // Hot first
                Cell: ({ cell }) => {
                    const v = cell.getValue() ?? 0;
                    const m = HOT_MAP[v] || HOT_MAP[0];
                    return (
                        <Box title={m.label} sx={{ display:'flex', alignItems:'center', gap:1 }}>
                            <Box sx={{
                                width: 12, height: 12, borderRadius: '50%', bgcolor: m.color,
                                boxShadow: 1
                            }}/>
                            <Typography variant="caption">{m.label}</Typography>
                        </Box>
                    );
                },
            },
            {
                accessorKey: 'QuoteDate',
                header: 'תאריך הצעת מחיר',
                size: 15,
                Cell: ({ cell }) => {
                    const isoString = cell.getValue();
                    if (!isoString) return '';
                    return formatDate(isoString);
                },
            },
            //     {
            //       id: 'leadInfo',
            //   header: '',
            //   size : 70,
            //   enableSorting:false,
            //   Cell: ({ row }) => renderLeadMini(leads.find(l => l.id === row.original.LeadId)),
            // },
            // quoteJumpCol,

            // { accessorKey: 'LeadId', header: 'LeadId', size: 5  },
            { accessorKey: 'LeadType', header: 'Lead Type', size: 5  },
            {
                id: 'handlingAgent',
                header: 'סוכן',
                size: 20,
                accessorFn: row => {
                    const lead = leads.find(l => l.id === row.LeadId);
                    return lead?.handling_agent ?? '—';
                },
            },
            {
                accessorKey: 'ProjectName',
                header: 'שם פרויקט',
                size: 15,
            },
            { accessorKey: 'CompanyName', header: 'חברה', size: 5  },
            {accessorKey: "LeadSource", header: 'מקור', size: 5},
            { accessorKey: 'ContactPersonName', header: 'שם', size: 5  },
            { accessorKey: 'ContactPersonPhone', header: 'טלפון', size: 5  },
            { accessorKey: 'Lanes', header: 'נתיבים', size: 5  },
            {
                id: 'amount',
                header: 'סכום',
                size: 10,
                Cell: ({ row }) => {
                    const { LeadType, TotalAmountInSale, MonthlyAmountLeasing } = row.original;
                    if (LeadType === 'מכירה' || LeadType === 'ענן ותקשורת') {
                        return TotalAmountInSale != null ? `${formatCurrency(TotalAmountInSale)} ₪` : '';
                    } else {
                        return MonthlyAmountLeasing != null ? `${formatCurrency(MonthlyAmountLeasing*12)} ₪` : '';
                    }
                },
            },

            {
                header: 'התקדמות',
                accessorKey: 'Progress',
                Cell: ({ row, cell }) => {
                    if (row.depth !== 2) return '-'; // only show on sale rows
                    const progress = cell.getValue();
                    return PROGRESS_MAP[progress] || `${progress}%`; // fallback to percentage if not in map
                }
            },
            // (Actions via getRowActions below)
            // {
            //     id: "leadSearch",
            //     header: "Lead Search",     // you won’t actually see this, because we’ll hide it
            //     accessorFn: (saleRow) => {
            //         // saleRow.LeadId is the foreign‐key that points at one lead in `leads[]`.
            //         const lead = leads.find((L) => L.id === saleRow.LeadId);
            //         if (!lead) return "";
            //         // concatenate whichever lead fields you want to search on
            //         return `${lead.email || ""} ${lead.full_name || ""} ${lead.phone_number || ""}`.trim();
            //     },
            //     // Turn OFF all UI for this column; it’s purely for “global filter” to match against.
            //     enableColumnFilter: false,
            //     enableSorting: false,
            //     enableHiding: true,
            //     enableGlobalFilter: true,
            //     // We hide it from view completely:
            //     enableColumnOrdering: false,
            //     muiTableHeadCellProps: { sx: { display: "none" } },
            //     muiTableBodyCellProps: { sx: { display: "none" } },
            //     size: 0,
            // },
        ],
        [leads, completedSales] // whenever `leads` changes, re‐memoize so that the accessorFn picks up fresh lead data
    );
    const salesColumnsWithSearch = useMemo(
        () => [
            ...salesColumns,
            {
                id: "searchableData",
                header: "Search Data",
                enableColumnFilter: false,
                enableSorting: false,
                enableHiding: true,
                enableGlobalFilter: true,
                // Hide this column from view
                muiTableHeadCellProps: { sx: { display: "none" } },
                muiTableBodyCellProps: { sx: { display: "none" } },
                size: 0,
                accessorFn: (row) => {
                    const lead = leads.find(l => l.id === row.LeadId);
                    const saleDone = completedSales.find(s => s.SaleId === row.SaleId);

                    // Combine all searchable data
                    const searchableFields = [
                        row.LeadType,
                        row.ProjectName,
                        row.CompanyName,
                        row.ContactPersonName,
                        row.ContactPersonPhone,
                        row.Lanes,
                        lead?.lead_agent,
                        lead?.handling_agent,
                        row.Progress?.toString(),
                        row.TotalAmountInSale?.toString(),
                        row.MonthlyAmountLeasing?.toString(),
                        saleDone ? `SL-${saleDone.SaleId}` : '',
                    ].filter(Boolean);

                    return searchableFields.join(' ');
                },
            },
        ],
        [salesColumns, leads, completedSales]
    );
    const salesColumnsNoProgress = useMemo(
        () => [
            // show the same “go back to Leads” chip
            leadChipCol,

            // then a “go to Quote” chip on your finished-sales tab:
            quoteJumpCol,
            {
                accessorKey: "SaleDate",
                header: 'תאריך מכירה',
                size: 15,
                Cell: ({ cell }) => {
                    const isoString = cell.getValue();
                    return isoString ? formatDate(isoString) : '';
                },
            },

            // then every other column except Progress
            ...salesColumns.filter(c => c.accessorKey !== 'QuoteDate' && c.accessorKey !== 'Progress' &&c.id!=='saleLink' &&  c.id!=='leadLink' && c.id!=='quoteJump' && c.id!=='leadSearch'),
        ],
        [salesColumns, leadChipCol, quoteJumpCol]
    );

    const salesColumnsNoProgressWithSearch = useMemo(
        () => [
            // Include the base columns without Progress
            ...salesColumnsNoProgress,
            {
                id: "searchableDataCompleted",
                header: "Search Data Completed",
                enableColumnFilter: false,
                enableSorting: false,
                enableHiding: true,
                enableGlobalFilter: true,
                // Hide this column from view
                muiTableHeadCellProps: { sx: { display: "none" } },
                muiTableBodyCellProps: { sx: { display: "none" } },
                size: 0,
                accessorFn: (row) => {
                    const lead = leads.find(l => l.id === row.LeadId);
                    const quote = quoteSales.find(q => q.SaleId === row.SaleId);

                    // Combine all searchable data for completed sales
                    const searchableFields = [
                        row.LeadType,
                        row.ProjectName,
                        row.CompanyName,
                        row.ContactPersonName,
                        row.ContactPersonPhone,
                        row.Lanes,
                        lead?.lead_agent,
                        lead?.handling_agent,
                        row.TotalAmountInSale?.toString(),
                        row.MonthlyAmountLeasing?.toString(),
                        row.SaleId?.toString()
                    ].filter(Boolean);

                    return searchableFields.join(' ');
                },
            },
        ],
        [salesColumnsNoProgress, leads, quoteSales]
    );


    const handleSalesFileChange = async (e) => {
        const files = Array.from(e.target.files);
        const trimmed = files.map(file => ({
            file,
            previewUrl: URL.createObjectURL(file)
        }));
        setSaleFormData(prev => ({
            ...prev,
            attachments: prev.attachments ? [...prev.attachments, ...trimmed] :trimmed
        }));
    };

    const availablePercents = useMemo(() => {
        const alreadyUsed = payments.map(p => p.payment_type)       // e.g. ['50%','40%']
        if (newPayment?.type) alreadyUsed.push(newPayment.type)     // block the one you just picked, too

        // turn your base fractions into strings:
        const allLabels = (SALE_TYPES_MAP[paymentSale?.LeadType] || [])
            .map(p => `${p * 100}%`)

        // filter out any you’ve already grabbed
        return allLabels.filter(label => !alreadyUsed.includes(label))
    }, [payments, newPayment, paymentSale])

    const handleOpenCreateSale = (leadId) => {
        setSelectedLeadId(leadId);
        const lead = leads.find(l => l.id === leadId);
        console.log('lead = ', lead)
        setSaleSourceRow({
            LeadId: leadId,
           
            ContactPersonName: lead.full_name || '',
            ContactPersonPhone: lead.phone_number || '',
            LeadSource: lead.lead_source || '',
            // parking/secondary fields if you want backend to create Case/Project
            ParkingAddress: lead.parking_address || '',
            ParkingFullName: lead.parking_full_name || '',
            ParkingEmail: lead.parking_email || '',
            ParkingPhoneNumber: lead.parking_phone_number || '',
            SecondaryContactPersonName: lead.secondary_full_name || '',
            SecondaryContactEmail: lead.secondary_email || '',
            SecondaryContactPersonPhone: lead.secondary_phone_number || '',
            HandlingAgent: lead.handling_Agent || '',
            Nickname: lead.nickname,
            // empty arrays
            items: [],
           
            rev_share_rules: [],
        });
        setSaleFormData({
            LeadSource: lead.lead_source,
            Lanes: lead.lanes_number,
            TotalAmountInSale: 0,
            MonthlyAmountLeasing: 0,
            RevShareThreshold: 0,
            RevShareRatio: "",
            Progress: 0,
            Notes: "",
            LeadType: "",
            ContactPersonName: lead.full_name,
            ContactPersonPhone: lead.phone_number,
            Address: lead.address,
            CompanyName: lead.company_name || '',
            QuoteDate: new Date().toISOString().split('T')[0],
            // NEW: parking + secondary from lead
            ParkingAddress: lead.parking_address || "",
            ParkingFullName: lead.parking_full_name || "",
            ParkingEmail: lead.parking_email || "",
            ParkingPhoneNumber: lead.parking_phone_number || "",
            SecondaryContactPersonName: lead.secondary_full_name || "",
            SecondaryContactEmail: lead.secondary_email || "",
            SecondaryContactPersonPhone: lead.secondary_phone_number || "",
            ContactEmail: lead.email || "",
             attachments: [],
             SaleDate: ''
        });
        setShowCreateSaleModal(true);
    };
    const handleCloseCreateSale = () => {
        setShowCreateSaleModal(false);
        setSaleSourceRow(null); // ✅ reset when closing
    };

// form‐field change
    const handleSaleFormChange = (e) => {
        const { name, value } = e.target;
        if (name === "Progress") {
            // Try to coerce into a number (empty string → 0 temporarily)
            const num = Number(value);

            // If it's not a number or outside [0, 100], mark error
            if (isNaN(num) || num < 0 || num > 100) {
                setCreateProgressError(true);
            } else {
                setCreateProgressError(false);
            }
        }
        setSaleFormData(prev => ({ ...prev, [name]: value }));
    };

    const formatDate = (dateStr) => {
        const d = new Date(dateStr)     // parse the ISO
        const year  = d.getFullYear()
        const month = String(d.getMonth()+1).padStart(2,'0')
        const day   = String(d.getDate()   ).padStart(2,'0')
        return `${year}-${month}-${day}`;
    }

    const handleAddItem = () => {
        setSaleFormData(prev => ({
            ...prev,
            items: [...(prev.items||[]), {
                itemNumber: "", itemName: "", quantity: 1, price: 0
            }],
        }));
    };

// Remove an item at index
    const handleRemoveItem = idx => {
        setSaleFormData(prev => {
            const items = [...prev.items];
            items.splice(idx,1);
            return { ...prev, items };
        });
    };

// Change a single field on one item
    const handleItemChange = (idx, field, value) => {
        setSaleFormData(prev => {
            const items = prev.items.map((it,i) =>
                i === idx ? { ...it, [field]: value } : it
            );
            return { ...prev, items };
        });
    };

    const handleOpenEditSaleModal = async (sale) => {
    let projectFields = {};
    if (sale.ProjectId) {
        try {
            const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/sales-project/${sale.ProjectId}`);
            if (resp.ok) {
                projectFields = await resp.json();
            }
        } catch (e) {
            console.error("Failed to fetch sales_project fields", e);
        }
    }
    setEditSaleFormData({
        ...sale,
        SaleDate: sale.SaleDate ? formatDate(sale.SaleDate) : undefined,
        Lanes: sale.Lanes && sale.Lanes > 0 ? sale.Lanes : 1,
        QuoteDate: sale.QuoteDate ? formatDate(sale.QuoteDate) : undefined,
        QuoteValidDate: sale.QuoteValidDate ? formatDate(sale.QuoteValidDate) : undefined,
        items: sale.items || [],
        ExcludeFromStats: sale.ExcludeFromStats || 0,
        // Populate only the new project sales fields from projectFields if present
        ParkingCasualQty: projectFields.ParkingCasualQty ?? sale.ParkingCasualQty ?? 0,
        ParkingSubscriberQty: projectFields.ParkingSubscriberQty ?? sale.ParkingSubscriberQty ?? 0,
        ParkingDisabledQty: projectFields.ParkingDisabledQty ?? sale.ParkingDisabledQty ?? 0,
        SubscriberPricingRecommendation: projectFields.SubscriberPricingRecommendation ?? sale.SubscriberPricingRecommendation ?? 'none',
        SubscriberRecommendedPrice: projectFields.SubscriberRecommendedPrice ?? sale.SubscriberRecommendedPrice ?? '',
        CasualPricingRecommendation: projectFields.CasualPricingRecommendation ?? sale.CasualPricingRecommendation ?? 'none',
        CasualRecommendedPrice: projectFields.CasualRecommendedPrice ?? sale.CasualRecommendedPrice ?? '',
        ParkingFullName: projectFields.ParkingFullName ?? sale.ParkingFullName ?? ''
    });
    setProgressError(false);
    setShowEditSaleModal(true);
    setMonthlyTouched(false);
    loadSaleComments(sale.SaleId);
    };

    async function loadSaleComments(saleId){
        if(!saleId) return;
        setSaleCommentsLoading(true);
        try{
            const r = await fetch(`https://blue-parking-invite.bluept.dev/api/sales/${saleId}/comments`);
            const j = await r.json();
            setSaleComments(Array.isArray(j.comments)? j.comments : []);
        }catch(e){
            setSaleComments([]);
        }finally{
            setSaleCommentsLoading(false);
        }
    }

    async function handleAddSaleComment(){
    const txt = newSaleComment.trim();
    if(!txt || !editSaleFormData?.SaleId) return;
    const mentionEmails = extractMentionEmails(txt); // NEW
    try{
        const r = await fetch(`https://blue-parking-invite.bluept.dev/api/sales/${editSaleFormData.SaleId}/comments`, {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({
                Author: userEmail || null,
                CommentText: txt,
                MentionText: mentionEmails,
                ReturnDate: (leadReturnEnabled && leadReturnDate) ? leadReturnDate : null,          // send array
            })
        });
        if(r.ok){
            const row = await r.json();
            // backend returns JSON string fields → if needed parse SentTo/Mentions later
            setSaleComments(prev=>[...prev, row]);
            setNewSaleComment('');
            if (leadReturnEnabled && leadReturnDate) {
                setLeadReturnEnabled(false);
                // optionally clear date input
                // setLeadReturnDate('');
            }
        } else {
            console.log('comment post failed', await r.text());
        }
    }catch(e){
        console.log(e.message)
    }
    }

    async function loadLeadComments(leadId){
        if(!leadId) return;
            setLeadCommentsLoading(true);
        try{
            const r = await fetch(`https://blue-parking-invite.bluept.dev/api/leads/${leadId}/comments`);
            const j = await r.json();
            setLeadComments(Array.isArray(j.comments)? j.comments : []);
        }catch(e){
            setLeadComments([]);
        }finally{
            setLeadCommentsLoading(false);
        }
    }
    // NEW: add a lead comment
    async function handleAddLeadComment(){
        const txt = newLeadComment.trim();
        if(!txt || !editFormData?.id) return;
        const mentionEmails = extractMentionEmails(txt);
        try{
            const r = await fetch(`https://blue-parking-invite.bluept.dev/api/leads/${editFormData.id}/comments`, {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({
                Author: userEmail || null,
                CommentText: txt,
                MentionText: mentionEmails,
                ReturnDate: (leadReturnEnabled && leadReturnDate) ? leadReturnDate : null,
            })
            });
        if(r.ok){
            const row = await r.json();
            setLeadComments(prev=>[...prev,row]);
            setNewLeadComment('');
            if (leadReturnEnabled && leadReturnDate) {
                setLeadReturnEnabled(false);
                // optionally clear date input
                // setLeadReturnDate('');
            }
        } else {
            console.log('lead comment post failed', await r.text());
        }
        }catch(e){
            console.log(e.message);
        }
    }
    // NEW: lead comment input change (shares mention suggestions state)
    function handleNewLeadCommentChange(e){
    const v = e.target.value;
    setNewLeadComment(v);
    const m = v.match(/(^|\s)@([^\s@]*)$/);
    if (m) {
        const q = m[2] || '';
        setMentionActive(true);
        setMentionQuery(q);
        if (mentionFetchTimer.current) clearTimeout(mentionFetchTimer.current);
        mentionFetchTimer.current = setTimeout(async () => {
        try {
            if (!q) { setMentionSuggestions([]); return; }
            const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/users/suggest?q=${encodeURIComponent(q)}`);
            const users = await resp.json();
            const opts = (users || []).map(u => ({
            label: u.email || [u.given_name, u.family_name].filter(Boolean).join(' '),
            email: u.email || '',
            name: [u.given_name, u.family_name].filter(Boolean).join(' ')
            }));
            setMentionSuggestions(opts.slice(0, 6));
        } catch {
            setMentionSuggestions([]);
        }
        }, 180);
    } else {
        setMentionActive(false);
        setMentionQuery('');
        setMentionSuggestions([]);
    }
    }    
    const handleEditAddItem = () => {
        setEditSaleFormData(prev => ({
            ...prev,
            items: [
                ...prev.items,
                { itemNumber: "", itemName: "", quantity: 1, price: 0 }
            ]
        }));
    };
    const toDatetimeLocal = (dateString) => {
        if (!dateString) return '';

        // Create date object from the string
        const date = new Date(dateString);

        // Check if date is valid
        if (isNaN(date.getTime())) return '';

        // Get local date components without timezone conversion
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const handleEditItemChange = (idx, field, value) => {
        setEditSaleFormData(prev => {
            const items = [...prev.items];
            items[idx] = { ...items[idx], [field]: value };
            return { ...prev, items };
        });
    };

    const handleEditRemoveItem = idx => {
        setEditSaleFormData(prev => {
            const items = prev.items.filter((_, i) => i !== idx);
            return { ...prev, items };
        });
    };
    const handleEditSaleFormChange = (e) => {
        const { name, value } = e.target;
        setEditSaleFormData(prev => {
            const updated = {...prev, [name]: value };

            // If user edited the monthly field directly, mark it as “touched”
            if (name === "MonthlyAmountLeasing") {
                setMonthlyTouched(true);
            }

            if (name === "Progress") {
                // Try to coerce into a number (empty string → 0 temporarily)
                const num = Number(value);

                // If it's not a number or outside [0, 100], mark error
                if (isNaN(num) || num < 0 || num > 100) {
                    setProgressError(true);
                } else {
                    setProgressError(false);
                }

            }

            // If user changed “Lanes” AND they haven’t already manually touched monthly,
            // auto‐populate MonthlyAmountLeasing = Lanes * 4000
            if (name === "Lanes" && !monthlyTouched && updated.LeadType === 'ליסינג') {
                const lanesNum = parseInt(value, 10) || 0;
                updated.MonthlyAmountLeasing = lanesNum * 4000;
            }

            return updated;
        });    };


// submit to your API
    const handleCreateSaleSubmit = async (e) => {
        e.preventDefault();
        console.log(saleSourceRow)
        if (parseInt(saleFormData.Lanes, 10) < 1) {
            setAlertMsg("Lanes must be at least 1.");
            setOpenErrorAlert(true);
            return;
        }
        if (saleFormData.LeadType === "מכירה" && (!saleFormData.TotalAmountInSale || saleFormData.TotalAmountInSale <= 0)) {
            setAlertMsg("Total Amount is required for מכירה.");
            setOpenErrorAlert(true);
            return;
        }
        setLoading(true);                           // ← turn on spinner
        const uploaded = await uploadFilesWithThumbs(saleFormData.attachments);
        if (saleFormData.LeadType === 'ליסינג')
            saleFormData.MonthlyAmountLeasing = saleFormData.MonthlyAmountLeasing || saleFormData.Lanes * 4000;
        const base = {
            ...saleFormData,
            attachments: uploaded,
        };
        const payload = (selectedLeadId && saleSourceRow)
            ? { ...base, ...saleSourceRow }
            : base;

        try {
            const body = selectedLeadId
            ? { LeadId: selectedLeadId, ...payload }
            : { CaseId: saleFormData.CaseId, ProjectId: saleFormData.ProjectId, ...payload };
            const res = await fetch("https://blue-parking-invite.bluept.dev/api/add-sale", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });
            if (!res.ok) throw new Error("Server error");
            // after your POST succeeds:
            await refreshSalesCases(); // ← refresh hierarchical cases/projects/sales
            setShowCreateSaleModal(false);
            setAlertMsg("Sale created successfully!");
            setOpenSuccessAlert(true);
        } catch (err) {
            setLoading(false);                         // ← turn off spinner
            console.error(err);
            setAlertMsg(`Failed to create sale, error: ${err.message}`);
            setOpenErrorAlert(true);

        }
        setLoading(false);                         // ← turn off spinner

    };

    const normDateOnly = (v) => {
        if (!v) return null;
        const s = String(v).trim();
        if (!s) return null;
        // accept "YYYY-MM-DD" and "YYYY-MM-DD HH:mm:ss"
        return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : s.split(' ')[0];
    };

    function buildAddSaleBodyFromRow(saleRow, opts = {}) {
        const {
            CaseId,
            ProjectId,
            // optional fallbacks if Case/Project need to be created
            CaseName,
            CompanyName,
            Address,
            ContactPersonName,
            ContactPersonPhone,
            ProjectName,
            ParkingAddress,
            ParkingFullName,
            ParkingEmail,
            ParkingPhoneNumber,
            Nickname,
        } = opts;

        // base sale fields (already present on the row)
        const body = {
            LeadId: saleRow.LeadId ?? null,
            LeadType: saleRow.LeadType,
            LeadSource: saleRow.LeadSource ?? null,
            Lanes: saleRow.Lanes ?? null,
            TotalAmountInSale: saleRow.TotalAmountInSale ?? null,
            MonthlyAmountLeasing: saleRow.MonthlyAmountLeasing ?? null,
            Progress: saleRow.Progress ?? 0,
            Notes: saleRow.Notes ?? '',
            items: Array.isArray(saleRow.items) ? saleRow.items : [],
            attachments: Array.isArray(saleRow.attachments) ? saleRow.attachments : [],
            rev_share_rules: Array.isArray(saleRow.rev_share_rules) ? saleRow.rev_share_rules : [],

            // dates on leaf row
            QuoteDate: normDateOnly(saleRow.QuoteDate),
            QuoteValidDate: normDateOnly(saleRow.QuoteValidDate),
            SaleDate: normDateOnly(saleRow.SaleDate),

            // contact fields likely present on row
            CompanyName: saleRow.CompanyName ?? CompanyName ?? '',
            Address: saleRow.Address ?? Address ?? '',
            ContactPersonName: saleRow.ContactPersonName ?? ContactPersonName ?? '',
            ContactPersonPhone: saleRow.ContactPersonPhone ?? ContactPersonPhone ?? '',
        };

        // If the row is already bound to Case/Project, just send their IDs
        if (saleRow.CaseId || CaseId) body.CaseId = saleRow.CaseId ?? CaseId;
        if (saleRow.ProjectId || ProjectId) body.ProjectId = saleRow.ProjectId ?? ProjectId;

        // If missing, provide minimal data so backend can create Case and/or Project
        if (!body.CaseId) {
            Object.assign(body, {
                CaseName: CaseName ?? saleRow.CaseName ?? (saleRow.CompanyName || 'New Case'),
                Nickname: Nickname ?? saleRow.Nickname ?? '',
                // primary contact for case
                CaseCompanyName: body.CompanyName,
                CaseAddress: body.Address,
                CaseContactPersonName: body.ContactPersonName,
                CaseContactPersonPhone: body.ContactPersonPhone,
            });
        }

        if (!body.ProjectId) {
            Object.assign(body, {
                ProjectName: ProjectName ?? saleRow.ProjectName ?? (saleRow.CompanyName || 'New Project'),
                ParkingAddress: ParkingAddress ?? saleRow.ParkingAddress ?? '',
                ParkingFullName: ParkingFullName ?? saleRow.ParkingFullName ?? '',
                ParkingEmail: ParkingEmail ?? saleRow.ParkingEmail ?? '',
                ParkingPhoneNumber: ParkingPhoneNumber ?? saleRow.ParkingPhoneNumber ?? '',
            });
        }

        return body;
    }

    function getSalesData() {
        const priorityLabel = (hot) => {
            const n = Number(hot);
            if (n === 1) return "Low";
            if (n === 2) return "Medium";
            if (n === 3) return "High";
            return "N/A";
        };

        const formatDateTime = (dateStr) => {
            if (!dateStr) return "N/A";
            const d = new Date(dateStr);
            return d.toLocaleString("he-IL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            });
        };

        return completedSales.map((sale) => ({
            // 🔹 Core Sale Info
            SaleID: sale.SaleId || "N/A",
            Type: sale.LeadType || "N/A",
            Source: sale.LeadSource?.trim() || "N/A",
            Progress: `${sale.Progress ?? 0}%`,
            Priority: priorityLabel(sale.Hotness),

            // 🔹 Company & Contact Info
            Company: sale.CompanyName || "N/A",
            ContactName: sale.ContactPersonName || "N/A",
            ContactPhone: sale.ContactPersonPhone || "N/A",
            Address: sale.Address || "N/A",
            Lanes: sale.Lanes ?? "N/A",

            // 🔹 Financial Info
            TotalAmount: sale.TotalAmountInSale ?? "N/A",
            MonthlyLeasing: sale.MonthlyAmountLeasing ?? "N/A",
            RevenueShare: sale.rev_share_rules?.map(r => `${r.ratio} / ${r.threshold}`).join(", ") || "N/A",

            // 🔹 Status & Dates
            SentOffer: sale.SentOffer || "N/A",
            SaleDate: formatDateTime(sale.SaleDate),
            LaunchDate: formatDateTime(sale.LaunchAndDelivryDate),
            QuoteDate: formatDateTime(sale.QuoteDate),
            QuoteValid: formatDateTime(sale.QuoteValidDate),

            // 🔹 Notes & Attachments
            Notes: sale.Notes || "N/A"
        }));
    }

    function getQuotesData() {
        const priorityLabel = (hot) => {
            const n = Number(hot);
            if (n === 1) return "Low";
            if (n === 2) return "Medium";
            if (n === 3) return "High";
            return "N/A";
        };

        const formatDateTime = (dateStr) => {
            if (!dateStr) return "N/A";
            const d = new Date(dateStr);
            return d.toLocaleString("he-IL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            });
        };

        return quoteSales.map((sale) => ({
            // 🔹 Core Sale Info
            SaleID: sale.SaleId || "N/A",
            Type: sale.LeadType || "N/A",
            Source: sale.LeadSource?.trim() || "N/A",
            Progress: `${sale.Progress ?? 0}%`,
            Priority: priorityLabel(sale.Hotness),

            // 🔹 Company & Contact Info
            Company: sale.CompanyName || "N/A",
            ContactName: sale.ContactPersonName || "N/A",
            ContactPhone: sale.ContactPersonPhone || "N/A",
            Address: sale.Address || "N/A",
            Lanes: sale.Lanes ?? "N/A",

            // 🔹 Financial Info
            TotalAmount: sale.TotalAmountInSale ?? "N/A",
            MonthlyLeasing: sale.MonthlyAmountLeasing ?? "N/A",
            RevenueShare: sale.rev_share_rules?.map(r => `${r.ratio} / ${r.threshold}`).join(", ") || "N/A",

            // 🔹 Status & Dates
            SentOffer: sale.SentOffer || "N/A",
            SaleDate: formatDateTime(sale.SaleDate),
            LaunchDate: formatDateTime(sale.LaunchAndDelivryDate),
            QuoteDate: formatDateTime(sale.QuoteDate),
            QuoteValid: formatDateTime(sale.QuoteValidDate),

            // 🔹 Notes & Attachments
            Notes: sale.Notes || "N/A"
        }));
    }

    function getLeadsData() {
        const priorityLabel = (hot) => {
            const n = Number(hot);
            // map requested 1:Low, 2:Medium, 3:High
            if (n === 1) return 'Low';
            if (n === 2) return 'Medium';
            if (n === 3) return 'High';
            // fallback
            return 'N/A';
        };

        const formatDateTime = dateStr => {
            if (!dateStr) return "N/A";
            const d = new Date(dateStr);
            return d.toLocaleString("he-IL", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        };
        console.log(filteredList)
        return filteredList.map(ld => ({
            // 🔹 Core lead identity
            Name: ld.full_name || "N/A",
            Company: ld.company_name || "N/A",
            Email: ld.email || "N/A",
            Phone: ld.phone_number || "N/A",

            // 🔹 Lead status and ownership
            Priority: priorityLabel(ld.hotness),
            Status: ld.status || "N/A",
            HandlingAgent: ld.handling_agent || "N/A",
            LeadAgent: ld.lead_agent || "N/A",

            // 🔹 Source and description
            Source: ld.lead_source || "N/A",
            JobTitle: ld.job_title || "N/A",
            Notes: ld.notes || "N/A",
            IsQualified: ld.is_qualified || "N/A",

            // 🔹 Activity and tracking
            "Last Contact": formatDateTime(ld.last_contact) || "N/A",
            "Creation Date": formatDateTime(ld.creation_date) || "N/A",

            // 🔹 Additional company / system data
            Address: ld.address || "N/A",
            LanesNumber: ld.lanes_number ?? "N/A",
            CompanyID: ld.company_id || "N/A",
            QuoteID: quotesByLeadId.get(String(ld.id))?.SaleId || "N/A",
            ID: ld.id || "N/A"
        }));
    }

    async function handleExport(data) {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Leads");
        const colCount = Object.keys(data[0]).length;
        ws['!cols'] = new Array(colCount).fill({ wpx: 280 });
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // 2) Ask the user where to save:
        const pickerOpts = {
            suggestedName: `leads.xlsx`,
            types: [{
                description: "Excel Workbook",
                accept: {
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]
                }
            }]
        };

        try {
            const handle = await window.showSaveFilePicker(pickerOpts);
            const writable = await handle.createWritable();
            await writable.write(new Uint8Array(wbout));
            await writable.close();
            console.log("Saved!");
        } catch (err) {
            // User may have cancelled the dialog
            console.error("Save cancelled or failed:", err);
        }
    }

    const handleOpenEditModal = async (event) => {
        // setLoading(true);
        const d = new Date(event.last_contact)     // parse the ISO
        const year  = d.getFullYear()
        const month = String(d.getMonth()+1).padStart(2,'0')
        const day   = String(d.getDate()   ).padStart(2,'0')
        const dateOnly = `${year}-${month}-${day}`

        setEditFormData({
            ...event,
            last_contact: dateOnly,
            callHistory:  [],
        });
         await loadLeadComments(event.id);
        setShowEditModal(true)
        // setLoading(false);
    };
    const pctLabel = (p) => `${p * 100}%`;

    const unusedPercents = (leadType) => {
        const wanted = SALE_TYPES_MAP[leadType] || [];
        return wanted.filter((p) => !payments.some((pay) => pay.payment_type === pctLabel(p)));
    };

// Function to handle changes in the edit form fields:
    const handleEditFormChange = (e) => {
        const { name, value } = e.target;
        setEditFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleCloseLogsModal = () => {
        setShowLogsModal(false);
    };



    const salesRowsToShow = useMemo(() => {
        return filteredSales.slice(
            salesPage * salesRowsPerPage,
            (salesPage + 1) * salesRowsPerPage
        );
    }, [filteredSales, salesPage]);
    const handleSalesChangePage = (_, newPage) => {
        setSalesPage(newPage);
    };
    const handleRemoveAttachment = (index, isNew = false) => {
        setEditFormData((prev) => {
            // Decide whether to remove from existing attachments or new attachments
            if (isNew) {
                const updatedNew = prev
                    .newAttachments ? [...prev.newAttachments] : [];
                updatedNew.splice(index, 1);
                return { ...prev, newAttachments: updatedNew };
            } else {
                const updatedExisting = prev.attachments ? [...prev.attachments] : [];
                updatedExisting.splice(index, 1);
                return { ...prev, attachments: updatedExisting };
            }
        });
    };

    const handleRemoveAttachmentFromSale = (index, isNew = false) => {
        setEditSaleFormData((prev) => {
            // Decide whether to remove from existing attachments or new attachments
            if (isNew) {
                const updatedNew = prev
                    .newAttachments ? [...prev.newAttachments] : [];
                updatedNew.splice(index, 1);
                return { ...prev, newAttachments: updatedNew };
            } else {
                const updatedExisting = prev.attachments ? [...prev.attachments] : [];
                updatedExisting.splice(index, 1);
                return { ...prev, attachments: updatedExisting };
            }
        });
    };

    useEffect(() => {
        (async function getUserData() {
            const data = await getCurrentUser();
            setUserEmail(data.signInDetails.loginId);
        })();
    }, []);

    useEffect(() => {
        if (!paymentSale) return;

        (async () => {
            setLoadingPayments(true);

            try {
                // 1) ALWAYS fetch whatever is in the database first
                const res = await fetch(
                    `https://blue-parking-invite.bluept.dev/api/get-payments/${paymentSale.SaleId}`
                );
                const json = await res.json();
                const raw = json.payments || [];

                if (raw.length > 0) {
                    // 2) If there ARE payments in the DB, normalize them and use them
                    const normalized = raw.map((p) => ({
                        payment_type: p.payment_type,
                        // Store only YYYY-MM-DD (TextField type="date" expects yyyy-MM-dd)
                        payment_date: p.Payment_date.slice(0, 10),
                        amount: p.Amount,
                    }));
                    normalized.sort((a, b) => {
                        // “a.payment_date” and “b.payment_date” are "YYYY-MM-DD" strings
                        // If you kept the full ISO string, you could also do `new Date(a.payment_date)`:
                        const da = new Date(a.payment_date);
                        const db = new Date(b.payment_date);
                        return da - db;
                    });

                    setPayments(normalized);
                    setLoadingPayments(false);
                    return;
                }

                // 3) If the DB returned ZERO rows and LeadType is “ליסינג”, generate DEFAULT 26 rows
                if (paymentSale.LeadType === "ליסינג") {
                    const today = new Date();
                    const fmt = (d) => d.toISOString().slice(0, 10);

                    const leasingRows = [];

                    // (A) Deposit_3_months_from_Total → amount = 3 * MonthlyAmountLeasing
                    leasingRows.push({
                        payment_type: "Deposit_3_months_from_Total",
                        payment_date: fmt(today),
                        amount: paymentSale.MonthlyAmountLeasing * 3,
                    });

                    // (B) Switching_cost_of_credit_clearing → fixed 14,800
                    leasingRows.push({
                        payment_type: "Switching_cost_of_credit_clearing",
                        payment_date: fmt(today),
                        amount: 14800,
                    });

                    // (C) First “regular” installment (month #1) at today
                    leasingRows.push({
                        payment_type: "1",
                        payment_date: fmt(today),
                        amount: paymentSale.MonthlyAmountLeasing,
                    });

                    // (D) Now generate 23 more monthly‐increment rows (months 2..24)
                    for (let i = 1; i < 24; i++) {
                        const d = new Date(today);
                        d.setMonth(d.getMonth() + i);
                        leasingRows.push({
                            payment_type: `${i + 1}`, // e.g. "2", "3", … up to "24"
                            payment_date: fmt(d),
                            amount: paymentSale.MonthlyAmountLeasing,
                        });
                    }

                    setPayments(leasingRows);
                } else {
                    // 4) If no rows AND not a ליסינג, just leave payments = []
                    setPayments([]);
                }
            } catch (err) {
                console.error("get-payments failed", err);
                // If the fetch fails entirely, you could still fall back to an empty array:
                setPayments([]);
            } finally {
                setLoadingPayments(false);
            }
        })();
    }, [paymentSale]);

    // useEffect(() => {
    //     async function loadSales() {
    //         try {
    //             const res = await fetch("https://blue-parking-invite.bluept.dev/api/get-sales");
    //             const payload = await res.json();
    //             // adjust this if your API returns { data: […] } or { sales: […] }
    //             setSales(payload.sales.reverse() || payload.data.reverse() || payload.reverse());
    //         } catch (err) {
    //             console.error("Failed to load sales:", err);
    //         }
    //     }
    //     loadSales();
    // }, []);

    const addEditCallEntry = () => {
        setEditFormData(prev => ({
            ...prev,
            callHistory: [
                ...(prev.callHistory || []),
                { talked_with: '', call_date: getNowLocal(), return_date: '', notes: '' }
            ]
        }));
    };

    const handleEditCallEntryChange = (idx, field, value) => {
        setEditFormData(prev => ({
            ...prev,
            callHistory: prev.callHistory.map((c,i) =>
                i === idx ? { ...c, [field]: value } : c
            )
        }));
    };
    const removeEditCallEntry = idx => {
        setEditFormData(prev => ({
            ...prev,
            callHistory: prev.callHistory.filter((_,i) => i !== idx)
        }));
    };

    const handleEditSaleSubmit = async (e) => {
        // setLoading(true);
        e.preventDefault();
        try {
            if (
                Number(editSaleFormData.Progress) === 100 &&
                (
                Number(editSaleFormData.ParkingCasualQty || 0) +
                Number(editSaleFormData.ParkingSubscriberQty || 0) +
                Number(editSaleFormData.ParkingDisabledQty || 0)
                ) === 0
            ) {
                setAlertMsg("יש להזין לפחות חניה אחת");
                setOpenErrorAlert(true);
                return;
            }
            if (
            Number(editSaleFormData.Progress) === 100 &&
            (!editSaleFormData.ParkingFullName || !editSaleFormData.ParkingFullName.trim())
            ) {
            setAlertMsg("יש להזין שם חניון");
            setOpenErrorAlert(true);
            return;
            }
            if (parseInt(editSaleFormData.Lanes, 10) < 1) {
                setAlertMsg("Lanes must be at least 1.");
                setOpenErrorAlert(true);
                return;
            }
            if (editSaleFormData.LeadType === "מכירה" && (!editSaleFormData.TotalAmountInSale || editSaleFormData.TotalAmountInSale <= 0)) {
                setAlertMsg("Total Amount is required for a מכירה sale.");
                setOpenErrorAlert(true);
                return;
            }
            let uploadedFiles = [];

            // If there are new attachments to process:
            if (editSaleFormData.newAttachments && editSaleFormData.newAttachments.length > 0) {
                // Create an array of file requests for the presigned URL API.
                const fileRequests = editSaleFormData.newAttachments.map((fileObj) => ({
                    fileName: fileObj.name,
                    fileType: fileObj.type,
                }));

                let presignedData = null;
                try {
                    setLoading(true);
                    const resp = await fetch("https://blue-parking-invite.bluept.dev/api/get-presigned-urls", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ files: fileRequests }),
                    });
                    presignedData = await resp.json();
                    setLoading(false);
                } catch (err) {
                    setLoading(false);

                    console.error("Error requesting presigned URLs:", err);
                }

                // If presigned URLs were returned, loop through each new file and upload it.
                if (presignedData && presignedData.presignedUrls) {
                    for (let i = 0; i < editSaleFormData.newAttachments.length; i++) {
                        const fileObj = editSaleFormData.newAttachments[i];
                        const { url, key, fields } = presignedData.presignedUrls[i];

                        // Prepare the form data for the upload.
                        const formDataPayload = new FormData();
                        Object.entries(fields).forEach(([field, value]) => {
                            formDataPayload.append(field, value);
                        });
                        formDataPayload.append("file", fileObj.file);

                        // Upload the file.
                        const response = await fetch(url, {
                            method: "POST",
                            body: formDataPayload,
                        });

                        if (!response.ok) {
                            console.error(`Upload failed for ${fileObj.name}`);
                        } else {
                            console.log(`Uploaded ${fileObj.name} successfully.`);
                        }

                        // Push the file data so it can be stored along with the event.
                        uploadedFiles.push({
                            fileName: fileObj.name,
                            type: fileObj.type,
                            // Construct the file URL based on your presigned data. Adjust if necessary.
                            url: `${presignedData.presignedUrls[i].url}${fields.key}`,
                        });
                    }
                }
            }

            // Merge any uploaded files with the event's existing attachments.
            editSaleFormData.attachments = [
                ...(editSaleFormData.attachments || []),
                ...uploadedFiles,
            ];

            // Remove the newAttachments property before sending the payload (if desired)
            delete editSaleFormData.newAttachments;

            if (!monthlyTouched && editSaleFormData.Lanes && editSaleFormData.LeadType === 'ליסינג') {
                editSaleFormData.MonthlyAmountLeasing =
                    parseInt(editSaleFormData.Lanes, 10) * 4000;
            }
            editSaleFormData.SaleDate= editSaleFormData.SaleDate?.replace("T", " ");
            const res = await fetch(
                "https://blue-parking-invite.bluept.dev/api/save-sale",
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(editSaleFormData),
                }
            );
            if (!res.ok) throw new Error("save failed");
            await refreshSalesCases();
            setLoading(false);
            setShowEditSaleModal(false);
            setEditSaleFormData(null);
            setAlertMsg("Sale updated");
            setOpenSuccessAlert(true);
        } catch (err) {
            console.error(err);
            setLoading(false);
            setAlertMsg("Sale update failed");
            setOpenErrorAlert(true);
        }
    };


    const handleEditEventSubmit = async (e) => {
        e.preventDefault();
        // setLoading(true);

        // Prepare the updated event payload.
        // For example, convert the date/time from the datetime-local field to your expected format.
        const updatedEvent = {
            ...editFormData,
            // Convert "YYYY-MM-DDTHH:mm[:ss]" back to "YYYY-MM-DD HH:mm[:ss]" if needed.
            last_contact: editFormData.last_contact.replace("T", " "),
        };

        let uploadedFiles = [];

        // If there are new attachments to process:
        if (editFormData.newAttachments && editFormData.newAttachments.length > 0) {
            // Create an array of file requests for the presigned URL API.
            const fileRequests = editFormData.newAttachments.map((fileObj) => ({
                fileName: fileObj.name,
                fileType: fileObj.type,
            }));

            let presignedData = null;
            try {
                // setLoading(true);
                const resp = await fetch("https://blue-parking-invite.bluept.dev/api/get-presigned-urls", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ files: fileRequests }),
                });
                presignedData = await resp.json();
                // setLoading(false);
            } catch (err) {
                setLoading(false);

                console.error("Error requesting presigned URLs:", err);
            }

            // If presigned URLs were returned, loop through each new file and upload it.
            if (presignedData && presignedData.presignedUrls) {
                for (let i = 0; i < editFormData.newAttachments.length; i++) {
                    const fileObj = editFormData.newAttachments[i];
                    const { url, key, fields } = presignedData.presignedUrls[i];

                    // Prepare the form data for the upload.
                    const formDataPayload = new FormData();
                    Object.entries(fields).forEach(([field, value]) => {
                        formDataPayload.append(field, value);
                    });
                    formDataPayload.append("file", fileObj.file);

                    // Upload the file.
                    const response = await fetch(url, {
                        method: "POST",
                        body: formDataPayload,
                    });

                    if (!response.ok) {
                        console.error(`Upload failed for ${fileObj.name}`);
                    } else {
                        console.log(`Uploaded ${fileObj.name} successfully.`);
                    }

                    // Push the file data so it can be stored along with the event.
                    uploadedFiles.push({
                        fileName: fileObj.name,
                        type: fileObj.type,
                        // Construct the file URL based on your presigned data. Adjust if necessary.
                        url: `${presignedData.presignedUrls[i].url}${fields.key}`,
                    });
                }
            }
        }

        // Merge any uploaded files with the event's existing attachments.
        updatedEvent.attachments = [
            ...(updatedEvent.attachments || []),
            ...uploadedFiles,
        ];

        // Remove the newAttachments property before sending the payload (if desired)
        delete updatedEvent.newAttachments;
        updatedEvent.userEmail= userEmail;
        try {
            // Call your API endpoint to save the updated event.
            const response = await fetch("https://blue-parking-invite.bluept.dev/api/save-lead", {
                method: "PUT", // You may use PUT if that fits your design better.
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updatedEvent),
            });
            const result = await response.json();
            setLoading(false);
            if (response.ok) {
                setAlertMsg("Event updated successfully!");
                setOpenSuccessAlert(true);
                // alert("Event updated successfully!");
                // Update local state to reflect the changes.
                setLeads((prevEvents) =>
                    prevEvents.map((ev) => (ev.id === updatedEvent.id ? updatedEvent : ev))
                );
                setFilteredEvents((prevEvents) =>
                    prevEvents.map((ev) => (ev.id === updatedEvent.id ? updatedEvent : ev))
                );
                setShowEditModal(false);
                setEditFormData(null);
            } else {
                setAlertMsg("Event updated failed!");
                setOpenErrorAlert(true);
            }
        } catch (err) {
            console.error("Error updating event:", err);
            setLoading(false);
            setAlertMsg("Event updated failed!");
            setOpenErrorAlert(true);
        }
    };

    const handleOpenChecklistForProject = (projectObj) => {
        console.log(projectObj)
        setSaleChecklist({
            ...saleChecklist,
            ProjectId: projectObj.ProjectId,
            ProjectName: projectObj.ProjectName ?? '',
            CompanyName: projectObj.subRows[0]?.CompanyName ?? '',
            SaleId:  projectObj.subRows[0]?.SaleId ?? null,
            // Populate other fields from projectObj if needed, e.g.:
            ChargePermission: projectObj.ChargePermission ?? false,
            DepositRequired: projectObj.DepositRequired ?? false,
            ClearingAgreementSigned: projectObj.ClearingAgreementSigned ?? false,
            ParkingCreatedInFinance: projectObj.ParkingCreatedInFinance ?? false,
            FinanceRowCreated: projectObj.FinanceRowCreated ?? false,
            MeirApproved: projectObj.MeirApproved ?? false,
            ApprovedForExecution: projectObj.ApprovedForExecution ?? false,
            AdvanceAmount: projectObj.AdvanceAmount ?? null, // or any other mapping
        });
        setShowChecklistModal(true);
    };
    // MODAL STATES
    const [showAddModal, setShowAddModal] = useState(false);
    // const [showDetailModal, setShowDetailModal] = useState(false);

    useEffect(() => {
        async function fetchMasterSales() {
            try {
                setLoading(true);
                const response = await fetch("https://blue-parking-invite.bluept.dev/api/get-leads");
                const data = await response.json();
                setLoading(false);
                setLeads(data.sales.reverse());
                setFilteredEvents(data.sales);
            } catch (err) {
                setLoading(false);
                console.error("Error fetching events:", err);
            }
        }
        fetchMasterSales();
    }, []);

    const emailAgentMap = {
        // omri:  ['omri', 'עומרי'],
        // miri:  ['miri','מירי','', null,],
        // oren:  ['oren','אורן'],
        // leon: ['oren','אורן'],
    };

    // FORM STATE for Add Event
    const [formData, setFormData] = useState({
        email: "",
        parking_email: "",
        parking_phone_number: "",
        full_name: "",
        parking_full_name: "",
        parking_address: "",
        phone_number: "",
        job_title: "",
        is_qualified: "",
        notes: "",
        handling_agent: "",
        lead_agent: "",
        status: "",
        last_contact: "",
        attachments: [],
        company_name: "",
        company_id: "",
        address: "",
        lanes_number: 0,
        lead_source: "",
        callHistory: [],
        secondary_full_name: "",
        secondary_email: "",
        secondary_phone_number: "",
        nickname: "",
        campaign_name: "",
        hotness: 1,
    });

    // SELECTED EVENT for "View Details"
    const [selectedEvent, setSelectedEvent] = useState(null);

    // STYLE OVERRIDES FOR DARK/LIGHT
    const pageBackground = darkMode ? "#1A2035" : "#F5F5F5";
    const textColor = darkMode ? "#ffffff" : "#000000";
    const paperBg = darkMode ? "#27293d" : "#ffffff";
    const inputBorderColor = darkMode ? "#666" : "#ccc";

    useEffect(() => {
        console.log(selectedEvent?.attachments);
    }, [selectedEvent]);
// ...existing code...

    useEffect(() => {
    const normalize = v => String(v ?? "").replace(/\s+/g, " ").trim();
    const sources = new Set();
    (salesCases || []).forEach(c => {
        (c.projects || []).forEach(p => {
        (p.sales || []).forEach(s => {
            const v = normalize(s.LeadSource);
            if (v) sources.add(v);
        });
        });
    });
    setLeadSourceOptions(Array.from(sources).sort());
    }, [salesCases]);

    useEffect(() => {
        let abort = false;
        async function loadCases() {
            setSalesCasesLoading(true);
            setSalesCasesErr(null);
            try {
                const r = await fetch('https://blue-parking-invite.bluept.dev/api/sales-cases');
                if (!r.ok) throw new Error('fetch failed');
                const j = await r.json();
                if (!abort) setSalesCases(Array.isArray(j.cases) ? j.cases : []);
            } catch (e) {
                if (!abort) setSalesCasesErr(e.message || 'error');
            } finally {
                if (!abort) setSalesCasesLoading(false);
            }
        }
        loadCases();
        return () => { abort = true; };
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const openLead = params.get('openLead');
        if (openLead) {
            setTabIndex(0);                  // ✅ switch to Leads tab
            setSearchTerm(String(openLead)); // ✅ filter list by id (now included in searchableLead)
        }
    }, [setTabIndex]);

    
const salePassesQuoteFilters = useCallback((s, currentTabIndex) => {
  // Source filter
  if (selectedLeadSources.length) {
    const normSrc = String(s.LeadSource ?? "").replace(/\s+/g, " ").trim();
    const wanted = selectedLeadSources.map(v => String(v).replace(/\s+/g, " ").trim());
    if (!wanted.includes(normSrc)) return false;
  }

  // Date filter only if user set from/to (QuoteDate or SaleDate)
  if (quoteFrom || quoteTo) {
    const rawDate = s.QuoteDate || s.SaleDate;
    if (!rawDate) return false;

    const isoLike = rawDate.includes(' ') ? rawDate.replace(' ', 'T') : rawDate;
    const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(isoLike) ? `${isoLike}T00:00:00` : isoLike);
    if (isNaN(d.getTime())) return false;

    if (quoteFrom) {
      const from = new Date(`${quoteFrom}T00:00:00`);
      if (d < from) return false;
    }
    if (quoteTo) {
      const to = new Date(`${quoteTo}T23:59:59.999`);
      if (d > to) return false;
    }
  }

  // NEW: ReturnDate filter (leaf sale only) - use tab-specific states
  const returnFrom = currentTabIndex === 1 ? returnFromQuotes : currentTabIndex === 2 ? returnFromSales : returnFromLeads;
  const returnTo = currentTabIndex === 1 ? returnToQuotes : currentTabIndex === 2 ? returnToSales : returnToLeads;
  
  if (returnFrom || returnTo) {
    const rawRet = s.ReturnDate;
    if (!rawRet) return false;
    const isoRet = rawRet.includes(' ') ? rawRet.replace(' ', 'T') : rawRet;
    const rd = new Date(/^\d{4}-\d{2}-\d{2}$/.test(isoRet) ? `${isoRet}T00:00:00` : isoRet);
    if (isNaN(rd.getTime())) return false;

    if (returnFrom) {
      const rf = new Date(`${returnFrom}T00:00:00`);
      if (rd < rf) return false;
    }
    if (returnTo) {
      const rt = new Date(`${returnTo}T23:59:59.999`);
      if (rd > rt) return false;
    }
  }

  return true;
}, [quoteFrom, quoteTo, selectedLeadSources, returnFromLeads, returnToLeads, returnFromQuotes, returnToQuotes, returnFromSales, returnToSales]);

    // Normalize → MRT hierarchical shape (subRows). We do not mutate original sales data.
    const normProgress = (s) => {
    const v = s?.Progress;
    if (v == null) return NaN;
    return parseInt(String(v).replace('%','').trim(), 10);
    };
    const caseIsTrulyEmpty = (c) => !Array.isArray(c.projects) || c.projects.length === 0;
    const projectIsTrulyEmpty = (p) => !Array.isArray(p.sales) || p.sales.length === 0;
        // Quotes: Progress !== 100, then remove empty projects/cases
    const hierarchicalQuotesData = useMemo(
        () =>
            (salesCases || [])
                .map(c => {
                    const projects = (c.projects || []).map(p => {
                        const salesFiltered = (p.sales || []).filter(s => {
                            const prog = normProgress(s);
                            return (
                                prog !== 100  &&
                                salePassesQuoteFilters(s, 1) &&
                                saleMatchesAgents(s, 1)
                            );
                        });
                        return { ...p, subRows: salesFiltered };
                    }).filter(p => (p.subRows?.length || 0) > 0 || projectIsTrulyEmpty(p));
                    return { ...c, subRows: projects };
                })
                .filter(c => (c.subRows?.length || 0) > 0 || caseIsTrulyEmpty(c)),
        [salesCases, salePassesQuoteFilters, saleMatchesAgents]
    );

    // Sales: Progress === 100, then remove empty projects/cases
    const hierarchicalCompletedData = useMemo(
        () =>
            (salesCases || [])
                .map(c => {
                    const projects = (c.projects || []).map(p => {
                        const salesFiltered = (p.sales || []).filter(s => {
                            const prog = normProgress(s);
                            return (
                                prog === 100 &&
                                salePassesQuoteFilters(s, 2) &&
                                saleMatchesAgents(s, 2)
                            );
                        });
                        return { ...p, subRows: salesFiltered };
                    }).filter(p => (p.subRows?.length || 0) > 0);
                    return { ...c, subRows: projects };
                })
                .filter(c => (c.subRows?.length || 0) > 0),
        [salesCases, salePassesQuoteFilters, saleMatchesAgents]
    );

    // Flatten sale rows for export (case/project info copied in)
const refreshSalesCases = useCallback(async () => {
  setSalesCasesLoading(true);
  setSalesCasesErr(null);
  try {
    const r = await fetch('https://blue-parking-invite.bluept.dev/api/sales-cases');
    if (!r.ok) throw new Error('fetch failed');
    const j = await r.json();
    setSalesCases(Array.isArray(j.cases) ? j.cases : []);
  } catch (e) {
    setSalesCasesErr(e.message || 'error');
  } finally {
    setSalesCasesLoading(false);
  }
}, []);

// ...existing code...

// Shared factory for hierarchical columns
    const useHierarchicalColumns = (mode, opts = {}) => useMemo(() => {
        const { onEditSale, onEditProject, onEditCase, leadChipCol } = opts;

        const formatDateShort = (iso) => {
            if (!iso) return '-';
            const d = new Date(iso);
            return isNaN(d.getTime()) ? '-' : d.toLocaleDateString('he-IL');
        };

        const getProjectLatestReturn = (projectRow) => {
            const sales = projectRow?.original?.subRows || projectRow?.original?.sales || [];
            let latest = null;
            for (const s of sales) {
                const t = s.ReturnDate ? new Date(s.ReturnDate).getTime() : NaN;
                if (Number.isFinite(t)) latest = latest == null ? t : Math.max(latest, t);
            }
            return latest ? new Date(latest).toISOString() : null;
        };

        // helper: resolve handling agent for a sale row
        const getHandlingAgentFromSale = (sale) => {
            if (!sale) return null;
            if (sale.handling_agent) return sale.handling_agent;
            const lead = leads.find(l => l.id === sale.LeadId);
            return lead?.handling_agent ?? null;
        };

        const moneyToILS = (n) =>
            (Number(n) || 0).toLocaleString('he-IL', {
                style: 'currency',
                currency: 'ILS',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });

        const getHierValue = (row, key) => {
            if (row.depth === 2) return row.original[key] ?? '-'; // sale
            if (row.depth === 1) {
                const projVal = row.original[key];
                const caseVal = row.getParentRow()?.original?.[key];
                return (projVal ?? caseVal ?? '-');
            }
            return row.original[key] ?? '-'; // case
        };

        const amountCellQuotes = ({ row }) => {
            if (row.depth === 2) {
                const val = row.original.LeadType === 'ליסינג'
                    ? Number(row.original.MonthlyAmountLeasing) || 0
                    : Number(row.original.TotalAmountInSale) || 0;
                return moneyToILS(val);
            }
            if (row.depth === 1) {
                const sum = (row.original.subRows || []).reduce((s, x) =>
                    s + (x.LeadType === 'ליסינג'
                        ? (Number(x.MonthlyAmountLeasing) || 0)
                        : (Number(x.TotalAmountInSale) || 0)), 0);
                return moneyToILS(sum);
            }
            const sum = (row.original.subRows || [])
                .flatMap(p => p.subRows || [])
                .reduce((s, x) =>
                    s + (x.LeadType === 'ליסינג'
                        ? (Number(x.MonthlyAmountLeasing) || 0)
                        : (Number(x.TotalAmountInSale) || 0)), 0);
            return moneyToILS(sum);
        };

        const amountCellSales = ({ row }) => {
            const annualizeIfLeasing = (sale) =>
                sale.LeadType === 'ליסינג'
                    ? (Number(sale.MonthlyAmountLeasing) || 0) * 12
                    : (Number(sale.TotalAmountInSale) || 0);

            if (row.depth === 2) {
                return moneyToILS(annualizeIfLeasing(row.original));
            }
            if (row.depth === 1) {
                const sum = (row.original.subRows || []).reduce((s, x) => s + annualizeIfLeasing(x), 0);
                return moneyToILS(sum);
            }
            const sum = (row.original.subRows || [])
                .flatMap(p => p.subRows || [])
                .reduce((s, x) => s + annualizeIfLeasing(x), 0);
            return moneyToILS(sum);
        };

        const dateCellQuotes = ({ row }) => {
            const v = row.depth === 2
                ? (row.original.QuoteDate || row.original.SaleDate)
                : (row.depth === 1 ? row.original.QuoteDate : null);
            return v ? new Date(v).toLocaleDateString('he-IL') : '-';
        };

        const dateCellSales = ({ row }) => {
            const v = row.depth === 2
                ? (row.original.SaleDate || row.original.QuoteDate)
                : (row.depth === 1 ? row.original.SaleDate : null);
            return v ? new Date(v).toLocaleDateString('he-IL') : '-';
        };

        const amountCell = mode === 'quotes' ? amountCellQuotes : amountCellSales;
        const dateCell = mode === 'quotes' ? dateCellQuotes : dateCellSales;

        return [
            {
                header: 'פעולות',
                id: 'actions',
                Cell: ({ row }) => {
                    // depth 2: edit sale (existing)
                    if (row.depth === 2 && onEditSale) {
                        // Show extra button only for sales (not quotes
                        return (
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Tooltip title="עריכת מכירה" arrow>
                                    <IconButton
                                        color="primary"
                                        size="small"
                                        aria-label="Edit Sale"
                                        onClick={() => onEditSale(row.original)}
                                        sx={{ color: '#fff', '&:hover': { bgcolor: 'primary.dark' }, borderRadius: 1 }}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        );
                    }
                    // depth 1: edit project
                    if (row.depth === 1 && onEditProject) {
                        const hasCompletedSale = (row.original.subRows || row.original.sales || [])
            .some(sale => Number(sale.Progress) === 100);
                        return (
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Tooltip title="עריכת פרויקט" arrow>
                                    <IconButton
                                        color="info"
                                        size="small"
                                        aria-label="Edit Project"
                                        onClick={() => onEditProject(row.original)}
                                        sx={{ color: '#fff', '&:hover': { bgcolor: 'info.dark' }, borderRadius: 1 }}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                {hasCompletedSale && (
                    <Tooltip title="צ'קליסט מכירה" arrow>
                        <IconButton
                            color="secondary"
                            size="small"
                            aria-label="Sales Checklist"
                            onClick={() => handleOpenChecklistForProject(row.original)}
                            sx={{ color: '#fff', '&:hover': { bgcolor: 'secondary.dark' }, borderRadius: 1 }}
                        >
                            <ChecklistIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
                            </Box>
                        );
                    }
                    // depth 0: edit case
                    if (row.depth === 0 && onEditCase) {
                        return (
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Tooltip title="עריכת תיק" arrow>
                                    <IconButton
                                        color="secondary"
                                        size="small"
                                        aria-label="Edit Case"
                                        onClick={() => onEditCase(row.original)}
                                        sx={{ color: '#fff', '&:hover': { bgcolor: 'secondary.dark' }, borderRadius: 1 }}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        );
                    }
                    return null;
                },
            },
            {
                header: 'שם',
                accessorFn: row => row.CaseName || row.ProjectName || row.CompanyName || '',
                Cell: ({ row }) => {
                    if (row.depth === 0) return row.original.CaseName || '-';
                    if (row.depth === 1) return row.original.ProjectName || '-';
                    return row.original.CompanyName || row.original.ContactPersonName ||
                        (mode === 'quotes' ? `הצעה #${row.original.SaleId ?? '-'}` : `מכירה #${row.original.SaleId ?? '-'}`);
                },
            },
            {
                header: 'כתובת חניון',
                accessorFn: row => row.ParkingAddress || '',
                Cell: ({ row }) => {
                    if (row.depth === 1) {
                        // project level (depth 1)
                        return row.original.ParkingAddress || '-';
                    }
                    if (row.depth === 0) {
                        // case level: pull from first child project that has ParkingAddress
                        const projects = row.original.subRows || row.original.projects || [];
                        const pa = projects.find(p => p.ParkingAddress)?.ParkingAddress;
                        return pa || '-';
                    }
                    // sale level (depth 2): read from parent project
                    const project = row.getParentRow()?.original;
                    return project?.ParkingAddress || '-';
                },
            },
            {
                header: 'שם חניון',
                accessorFn: row => row.ParkingFullName || '',
                Cell: ({ row }) => {
                    if (row.depth === 1) {
                        // project level
                        return row.original.ParkingFullName || '-';
                    }
                    if (row.depth === 0) {
                        // case level: pull from first child project that has ParkingFullName
                        const projects = row.original.subRows || row.original.projects || [];
                        const pf = projects.find(p => p.ParkingFullName)?.ParkingFullName;
                        return pf || '-';
                    }
                    // sale level: read from parent project
                    const project = row.getParentRow()?.original;
                    return project?.ParkingFullName || '-';
                },
            },
            {
                header: 'כינוי',
                accessorFn: row => row.Nickname || '',
                Cell: ({ row }) => {
                    if (row.depth === 0) {
                        // case level
                        return row.original.Nickname || '-';
                    }
                    // project or sale: read from parent case
                    const caseRow = row.getParentRow()?.depth === 1
                        ? row.getParentRow()?.getParentRow()
                        : row.getParentRow();
                    return caseRow?.original?.Nickname || '-';
                },
            },
            {
                header: 'סוכן מטפל',
                id: 'handling_agent',
                Cell: ({ row }) => {
                    if (row.depth === 2) {
                        return getHandlingAgentFromSale(row.original) || '-';
                    }
                    if (row.depth === 1) {
                        const sales = row.original.subRows || [];
                        const v = sales.map(s => getHandlingAgentFromSale(s)).find(Boolean);
                        return v || '-';
                    }
                    // depth 0: scan all child sales under projects
                    const projects = row.original.subRows || row.original.projects || [];
                    const allSales = projects.flatMap(p => p.subRows || []);
                    const v = allSales.map(s => getHandlingAgentFromSale(s)).find(Boolean);
                    return v || '-';
                },
            },
            { header: 'שם איש קשר', accessorKey: 'ContactPersonName', Cell: ({ row }) => getHierValue(row, 'ContactPersonName') },
            {
                header: 'תאריך חזרה',
                id: 'returnDate',
                enableSorting: false,
                Cell: ({ row }) => {
                    if (row.depth === 2) {
                        // sale-level
                        return formatDateShort(row.original.ReturnDate);
                    }
                    if (row.depth === 1) {
                        // project-level: max from child sales
                        const iso = getProjectLatestReturn(row);
                        return formatDateShort(iso);
                    }
                    // case-level
                    return formatDateShort(row.original.ReturnDate);
                },
            },
            { header: 'טלפון 1', accessorKey: 'ContactPersonPhone', Cell: ({ row }) => getHierValue(row, 'ContactPersonPhone') },
            {
                header: 'טלפון 2',
                accessorKey: 'SecondaryContactPersonPhone',
                Cell: ({ row }) => getHierValue(row, 'SecondaryContactPersonPhone'),
            },
            { header: 'כתובת', accessorKey: 'Address', Cell: ({ row }) => getHierValue(row, 'Address') },

            { header: 'סכום', id: 'amount', Cell: amountCell },

            // shared small columns
            leadChipCol,
            { header: 'סוג לידים', accessorKey: 'LeadType', Cell: ({ row, cell }) => (row.depth === 2 ? (cell.getValue() || '-') : '-') },
            { header: 'מקור', accessorKey: 'LeadSource', Cell: ({ row, cell }) => (row.depth === 2 ? (cell.getValue() || '-') : '-') },
            { header: 'נתיבים', accessorKey: 'Lanes', Cell: ({ row, cell }) => (row.depth === 2 ? (cell.getValue() ?? '-') : '-') },
            {
                header: 'התקדמות',
                accessorKey: 'Progress',
                Cell: ({ row, cell }) => {
                    if (row.depth !== 2) return '-'; // only show on sale rows
                    const progress = cell.getValue();
                    return PROGRESS_MAP[progress] || `${progress}%`; // fallback to percentage if not in map
                }
            },

            // priority chip (only meaningful on leaf)
            {
                header: 'עדיפות',
                id: 'priority',
                sortingFn: (a, b) => Number(b.original?.Hotness ?? 0) - Number(a.original?.Hotness ?? 0),
                Cell: ({ row }) => {
                    if (row.depth !== 2) return '-';
                    const v = Number(row.original?.Hotness ?? 0);
                    const m = HOT_MAP[v] || HOT_MAP[0];
                    return (
                        <Box title={m.label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: m.color, boxShadow: 1 }} />
                            <Typography variant="caption">{m.label}</Typography>
                        </Box>
                    );
                },
            },

            // date column depends on mode
            { header: mode === 'quotes' ? 'תאריך הצעה' : 'תאריך מכירה', id: mode === 'quotes' ? 'quoteDate' : 'saleDate', Cell: dateCell },

            // actions only on leaf (sale row)


            // hidden search aggregator differs by mode
            {
                id: mode === 'quotes' ? 'searchAllQuotes' : 'searchAllSales',
                header: 'Search All',
                accessorFn: (orig) => {
                    if (!orig.SaleId) return '';
                    const commentsText = orig.CombinedComments
                        || (Array.isArray(orig.comments) ? orig.comments.map(c => c.CommentText).join(' ') : '');
                    const base = [
                        orig.SaleId, orig.LeadId, orig.LeadType, orig.LeadSource, orig.ProjectName,
                        orig.CompanyName, orig.ContactPersonName, orig.ContactPersonPhone, orig.Address,
                        orig.Lanes, orig.Progress, orig.TotalAmountInSale, orig.MonthlyAmountLeasing,
                        orig.QuoteDate, orig.QuoteValidDate, orig.SaleDate, orig.Notes, commentsText,
                    ];
                    return base.filter(Boolean).join(' ');
                },
                enableGlobalFilter: true,
                enableColumnFilter: false,
                enableSorting: false,
                enableHiding: true,
                muiTableHeadCellProps: { sx: { display: 'none' } },
                muiTableBodyCellProps: { sx: { display: 'none' } },
                size: 0,
            },
        ];
    }, [opts, mode]);

// Usage:
// quotesHierarchicalColumns
const quotesHierarchicalColumns = useHierarchicalColumns('quotes', {
  onEditSale: handleOpenEditSaleModal,
  onEditProject: handleOpenEditProjectModal,
  onEditCase: handleOpenEditCaseModal,
  leadChipCol,
});

// salesHierarchicalColumns
const salesHierarchicalColumns = useHierarchicalColumns('sales', {
    onEditSale: handleOpenEditSaleModal,
  onEditProject: handleOpenEditProjectModal,
  onEditCase: handleOpenEditCaseModal,
  leadChipCol,
});

// ...existing code...

    const filteredQuoteSalesByDate = useMemo(() => {
        if (!quoteSales) return [];
        if (!quoteFrom && !quoteTo && (!selectedLeadSources || selectedLeadSources.length === 0)) return quoteSales;

        const from = quoteFrom ? new Date(`${quoteFrom}T00:00:00`) : null;
        const to   = quoteTo   ? new Date(`${quoteTo}T23:59:59.999`) : null;

        const parseDate = raw => {
            if (!raw) return null;
            if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return new Date(`${raw}T00:00:00`);
            const normalized = raw.includes(' ') ? raw.replace(' ', 'T') : raw;
            const d = new Date(normalized);
            return isNaN(d.getTime()) ? null : d;
        };

        const normalize = v => String(v ?? "").replace(/\s+/g, " ").trim();
        const selNorm = (selectedLeadSources || []).map(normalize);

        return quoteSales.filter(s => {
            if (selNorm.length) {
                const src = normalize(s.LeadSource);
                if (!selNorm.includes(src)) return false;
            }
            const raw = s.QuoteDate ?? s.SaleDate ?? null;
            const d = parseDate(raw);
            if (!d) return false;
            if (from && d < from) return false;
            if (to && d > to) return false;
            return true;
        });
    }, [quoteSales, quoteFrom, quoteTo, selectedLeadSources]);

    const filterByEmail = useCallback((events) => {
        if (!userEmail) return events
        const emailLower = userEmail.toLowerCase()

        for (const key of Object.keys(emailAgentMap)) {
            if (emailLower.includes(key)) {
                // const names = emailAgentMap[key]

                return events.filter(ev => {
                    const names = emailAgentMap[key]

                    const agent = (ev.handling_agent || "").toLowerCase().trim()
                    // ✅ if no agent assigned, show it to everyone:
                    if (!agent) return true
                    // ✅ otherwise only show if it matches this user’s names
                    return names.some(n => agent.includes(n))
                })
            }
        }

        // if your email didn’t match any special key, give you everything
        return events
    }, [userEmail])


    // first apply any other filters/searches, then apply the email‐based filter
    const filteredList = useMemo(() => {
        const st = String(searchTerm).trim().toLowerCase();

        // start from email-based filter + showAll logic
        let base = filterByEmail(filteredEvents);
        if (!showAll) base = base.filter((ev) => !ev.status?.includes("לא רלוונטי"));
        if (showIrrelevant) base = leads.filter((ev) => ev.status?.includes("לא רלוונטי"));

        // NEW: filter by handling agent (same behavior as quotes/sales) - use Leads-specific state
        if (selectedAgentsLeads.length) {
            base = base.filter(ev =>
                selectedAgentsLeads.includes(String(ev.handling_agent ?? '').trim())
            );
        }
        //   'רועי' : 'royi@blueparking.co.il'
        // 'עומרי': 'omri@blueparking.co.il',
        // 'מאיר': 'meir@blueparking.co.il'
        // משה : 'moshed@blueparking.co.il'
        // 'royi@blueparking.co.il 'omri@blueparking.co.il' 'meir@blueparking.co.il' 'moshed@blueparking.co.il'
        if (showMyToday && userEmail) {
            console.log('userEmail = ', userEmail)
            const agentName = getAgentNameByEmail(userEmail);
            const todayStr = new Date().toISOString().slice(0, 10);
            base = base.filter(ev =>
                Array.isArray(agentName)
                    ? agentName.includes(String(ev.handling_agent).trim()) && ev.ReturnDate && ev.ReturnDate.slice(0, 10) === todayStr
                    : String(ev.handling_agent).trim() === agentName && ev.ReturnDate && ev.ReturnDate.slice(0, 10) === todayStr
            );
        }

        // NEW: filter by ReturnDate (date only, inclusive range) - use Leads-specific states
        if (returnFromLeads || returnToLeads) {
            base = base.filter(ev => {
                const raw = ev.ReturnDate;
                if (!raw) return false; // require ReturnDate when a range is set
                const isoLike = raw.includes(' ') ? raw.replace(' ', 'T') : raw;
                const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(isoLike) ? `${isoLike}T00:00:00` : isoLike);
                if (isNaN(d.getTime())) return false;

                if (returnFromLeads) {
                    const rf = new Date(`${returnFromLeads}T00:00:00`);
                    if (d < rf) return false;
                }
                if (returnToLeads) {
                    const rt = new Date(`${returnToLeads}T23:59:59.999`);
                    if (d > rt) return false;
                }
                return true;
            });
        }

        // existing text search
        if (st !== "") {
            base = base.filter((ev) => {
                return (
                    String(ev.id).includes(st) ||
                    (ev.email || "").toLowerCase().includes(st) ||
                    (ev.full_name || "").toLowerCase().includes(st) ||
                    (ev.phone_number || "").toLowerCase().includes(st)
                );
            });
        }

        return base;
    }, [
        filteredEvents,
        filterByEmail,
        showAll,
        showIrrelevant,
        searchTerm,
        // NEW deps:
        selectedAgentsLeads,
        returnFromLeads,
        returnToLeads,
        leads,
        showMyToday, 
        userEmail   
    ]);
    const leadRowsToShow = filteredList.slice(
        page * rowsPerPage,
        (page + 1) * rowsPerPage
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    //
    const handleCreateRevShareRuleChange = (idx, field, value) => {
        const rules = [...saleFormData.rev_share_rules];
        rules[idx] = { ...rules[idx], [field]: value };
        setSaleFormData({
            ...saleFormData,
            rev_share_rules: rules,
        });
    };

    const handleCreateAddRevShareRule = () => {
        setSaleFormData({
            ...saleFormData,
            rev_share_rules: [
                ...(saleFormData.rev_share_rules || []),
                { ratio: "", threshold: "" },
            ],
        });
    };

    const handleCreateRemoveRevShareRule = (idx) => {
        setSaleFormData({
            ...saleFormData,
            rev_share_rules: saleFormData.rev_share_rules.filter(
                (_, i) => i !== idx
            ),
        });
    };
    //
    const handleEditRevShareRuleChange = (idx, field, value) => {
        const rules = [...editSaleFormData.rev_share_rules];
        rules[idx] = { ...rules[idx], [field]: value };
        setEditSaleFormData({
            ...editSaleFormData,
            rev_share_rules: rules,
        });
    };

    const handleEditAddRevShareRule = () => {
        setEditSaleFormData({
            ...editSaleFormData,
            rev_share_rules: [
                ...(editSaleFormData.rev_share_rules || []),
                { ratio: "", threshold: "" },
            ],
        });
    };

    const handleEditRemoveRevShareRule = (idx) => {
        setEditSaleFormData({
            ...editSaleFormData,
            rev_share_rules: editSaleFormData.rev_share_rules.filter(
                (_, i) => i !== idx
            ),
        });
    };
    const handleOpenAddModal = () => {
        setFormData({
            //mail	Full Name	Phone Number	Job Title	Is Qualified	Handling Agent	Handling Agent	Status	Last Contact
            email: "",
            parking_email: "",
            parking_phone_number: "",
            full_name: "",
            parking_full_name: "",
            phone_number: "",
            job_title: "",
            is_qualified: "",
            notes: "",
            handling_agent: "",
            lead_agent: "",
            status: "",
            last_contact: "",
            attachments: [],
            company_name: "",
            company_id: "",
            address: "",
            parking_address: "",
            lanes_number: 0,
            lead_source: "",
            callHistory: [],
            campaign_name: "",
            hotness: 1,
        });
        setShowAddModal(true);
    }
    const handleCloseAddModal = () => setShowAddModal(false);

    const handleAddEventChange = (e) => {
        const { name, value } = e.target;
        console.log('name: ', name, "value: ", value);
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAddEventChangePlace = (pname, pid) => {
        // const { name, value } = e.target;
        // console.log('name: ', name, "value: ", value);
        setFormData((prev) => ({
            ...prev,
            ['place']: pname,
            ['place_id']: pid,
        }));
    };

    const handleFileChange = async (e, isEdit = false) => {
        e.preventDefault();
        const picked = Array.from(e.target.files);
        setLoadingFiles(true);

        const processed = await Promise.all(picked.map(processAttachment));

        setLoadingFiles(false);
        const trimmed = processed.map(({ original, thumbnail, icon }) => ({
            file:         original,
            thumbFile:    thumbnail ?? null,
            iconName:     icon      ?? null,
            name:         original.name,
            type:         original.type,
            previewUrl:   URL.createObjectURL(thumbnail ?? original),
        }));

        if (isEdit) {
            // push into `newAttachments` so you keep existing attachments untouched
            setEditFormData(prev => ({
                ...prev,
                newAttachments: [...(prev.newAttachments || []), ...trimmed]
            }));
        } else {
            setFormData(prev => ({ ...prev, attachments: trimmed }));
        }
    };

    const handleFileChangeSale = async (e, isEdit = false) => {
        e.preventDefault();
        const picked = Array.from(e.target.files);
        setLoadingFiles(true);

        const processed = await Promise.all(picked.map(processAttachment));

        setLoadingFiles(false);
        const trimmed = processed.map(({ original, thumbnail, icon }) => ({
            file:         original,
            thumbFile:    thumbnail ?? null,
            iconName:     icon      ?? null,
            name:         original.name,
            type:         original.type,
            previewUrl:   URL.createObjectURL(thumbnail ?? original),
        }));

        if (isEdit) {
            // push into `newAttachments` so you keep existing attachments untouched
            setEditSaleFormData(prev => ({
                ...prev,
                newAttachments: [...(prev.newAttachments || []), ...trimmed]
            }));
        } else {
            setEditSaleFormData(prev => ({ ...prev, attachments: trimmed }));
        }
    };

    const uploadFilesWithThumbs = async (files) => {
        if (!files?.length) return [];

        // Flat list of every File we need to send up (orig + thumb if exists)
        const allFiles = files.flatMap(att => att.thumbFile ? [att.file, att.thumbFile] : [att.file]);
        const fileRequests = allFiles.map(f => ({ fileName: f.name, fileType: f.type }));

        const presResp = await fetch("https://blue-parking-invite.bluept.dev/api/get-presigned-urls", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ files: fileRequests })
        });
        const { presignedUrls } = await presResp.json();

        const uploadedMeta = [];

        for (let i = 0; i < allFiles.length; i++) {
            const file   = allFiles[i];
            const target = presignedUrls[i];
            const data   = new FormData();
            Object.entries(target.fields).forEach(([k,v]) => data.append(k,v));
            data.append("file", file);

            await fetch(target.url, { method: "POST", body: data });
            uploadedMeta.push({
                name: file.name,
                type: file.type,
                url:  `${target.url}${target.fields.key}`
            });
        }

        // Re‑group by original attachment so we can provide {url, thumbUrl}
        const result = files.map(att => {
            const origIdx  = uploadedMeta.findIndex(m => m.name === att.file.name);
            const thumbIdx = att.thumbFile ? uploadedMeta.findIndex(m => m.name === att.thumbFile.name) : -1;
            return {
                fileName: att.file.name,
                type:     att.file.type,
                url:      uploadedMeta[origIdx].url,
                thumbUrl: thumbIdx >= 0 ? uploadedMeta[thumbIdx].url : null,
                iconName: att.iconName ?? null
            };
        });
        return result;
    };

    function addSixHoursThenFormat(dateString /* "YYYY-MM-DD" or "YYYY-MM-DDTHH:MM:SS.000Z" */) {
        // 1) Turn it into a JS Date at local time (or parse the ISO if needed)
        // If you only have a date-only string ("2025-06-03"), do:
        const [Y, M, D] = dateString.split("-").map(Number);
        const dt = new Date(Y, M - 1, D);
        // If you had a full ISO already, you could do: const dt = new Date(dateString);

        // 2) Add 6 hours
        dt.setHours(dt.getHours() + 24);

        // 3) Return MySQL format
        return toMySQLDateTime(dt);
    }
    async function handleScheduleLeadReturn() {
        if (!editFormData?.id || !leadReturnEnabled || !leadReturnDate) return;
        setLeadReturnSaving(true);
        try {
            const r = await fetch(`https://blue-parking-invite.bluept.dev/api/leads/${editFormData.id}/return-date`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ReturnDate: convertToMySQLDatetime(leadReturnDate) })
            });
            if (!r.ok) {
                console.log('return date save failed', await r.text());
            } else {
                // optional: update local editFormData so UI reflects new return date
                setEditFormData(prev => ({ ...prev, next_return_date: convertToMySQLDatetime(leadReturnDate) }));
                setLeadReturnEnabled(false);
            }
        } catch (e) {
            console.log(e.message);
        } finally {
            setLeadReturnSaving(false);
        }
    }
    const handleAddEventSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const uploadedFiles = await uploadFilesWithThumbs(formData.attachments);

            const norm = (v) => (v === '' || v == null ? null : v);
            const numOrNull = (v) => {
                const n = Number(v);
                return Number.isFinite(n) ? n : null;
            };
            const hotnessMap = { low: 0, medium: 1, high: 2 };
            const hotnessValue =
                typeof formData.hotness === 'string'
                    ? hotnessMap[formData.hotness.toLowerCase()] ?? null
                    : numOrNull(formData.hotness);
            const newEvent = {
            email: norm(formData.email),
            parking_email: norm(formData.parking_email),
            parking_phone_number: norm(formData.parking_phone_number),
            full_name: norm(formData.full_name),
            parking_full_name: norm(formData.parking_full_name),
            phone_number: norm(formData.phone_number),
            job_title: norm(formData.job_title),
            is_qualified: norm(formData.is_qualified),
            notes: norm(formData.notes),
            handling_agent: norm(formData.handling_agent),
            lead_agent: norm(formData.lead_agent),
            status: norm(formData.status),

            company_name: norm(formData.company_name),
            company_id: norm(formData.company_id),
            address: norm(formData.address),
            parking_address: norm(formData.parking_address),

            lanes_number: numOrNull(formData.lanes_number),
            lead_source: norm(formData.lead_source),

            last_contact: convertToMySQLDatetime(formData.last_contact),

            attachments: uploadedFiles,

            creation_date: new Date().toISOString(),
            campaign_name: norm(formData.campaign_name),

            userEmail: userEmail,
            // NEW: always 0/1/2
            hotness: hotnessValue,

            secondary_full_name: norm(formData.secondary_full_name),
            secondary_email: norm(formData.secondary_email),
            secondary_phone_number: norm(formData.secondary_phone_number),
            nickname: norm(formData.nickname),
            };

            const addResp = await fetch("https://blue-parking-invite.bluept.dev/api/add-lead", {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify(newEvent)
            });
            const savedEvent = await addResp.json();

            setLeads(prev => [savedEvent, ...prev]);
            setFilteredEvents(prev => [savedEvent, ...prev])
            setShowAddModal(false);
            setAlertMsg("הליד נשמר בהצלחה");
            setOpenSuccessAlert(true);
        } catch (err) {
            console.error(err);
            setAlertMsg("שגיאה בשמירת הליד");
            setOpenErrorAlert(true);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveAll = async () => {
        // build the final list
        const finalList = [
            ...payments.map(p => ({
                payment_type: p.payment_type,
                payment_date: addSixHoursThenFormat(p.payment_date), // now "2025-05-28T06:00:00.000Z"
                amount:       p.amount
            })),
            ...(newPayment && newPayment.type
                ? [{
                    payment_type: newPayment.type,
                    payment_date: addSixHoursThenFormat(newPayment.date),
                    amount:       paymentSale.TotalAmountInSale * (parseInt(newPayment.type, 10) / 100)
                }]
                : [])
        ];


        try {
            const res = await fetch("https://blue-parking-invite.bluept.dev/api/save-payments", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    SaleId:   paymentSale.SaleId,
                    payments: finalList
                })
            });
            if (!res.ok) throw new Error("Save failed");

            // update the UI
            setPayments(finalList);
            setNewPayment(null);
            setPaymentSale(null);

            // ← show a success snackbar here:
            setAlertMsg("Payments saved successfully");
            setOpenSuccessAlert(true);
        } catch (err) {
            console.error("save-payments failed", err);
            setAlertMsg(`Failed to save payments: ${err.message}`);
            setOpenErrorAlert(true);
        }
    };

    const renderAttachmentPreview = (att, idx) => {
        // ---------- images ----------
        if (att.type.startsWith("image/")) {
            return (
                <img
                    src={getImageSrc(att)}
                    alt={att.fileName}
                    width={80}
                    height={80}
                    style={{ objectFit: "cover", cursor: "pointer", marginRight: 4 }}
                    onClick={() =>
                        handleOpenMedia({ url: att.url, type: att.type, name: att.fileName })
                    }
                />
            );
        }


        // ---------- videos ----------
        if (att.type.startsWith("video/")) {
            if(att.thumbUrl){
                return (
                    <img
                        src={att?.thumbUrl}
                        alt={att.fileName}
                        width={80}
                        height={80}
                        loading="lazy"
                        style={{ objectFit: "cover", cursor: "pointer", marginRight: 4 }}
                        onClick={() =>
                            handleOpenMedia({ url: att.url, type: att.type, name: att.fileName })
                        }
                    />
                )
            }
            else {
                return (<Grid item key={idx}>
                        <video
                            src={att.url}
                            muted
                            preload="metadata"  // this helps load just video metadata (not full file)
                            style={{
                                width: 80,
                                height: 80,
                                cursor: "pointer",
                                objectFit: "cover"
                            }}
                            onClick={() =>
                                handleOpenMedia({
                                    url: att.url,
                                    type: att.type,
                                    name: att.fileName,
                                })
                            }
                        />
                    </Grid>
                )
            }

        }
        return (
            <Button
                variant="text"
                color="info"
                onClick={() => window.open(att.url, "_blank")}
            >
                {att.fileName}
            </Button>
        );
    };


    const handleDeleteEvent = async (event) => {
        console.log(event);
        setLoading(true);
        const res = await fetch("https://blue-parking-invite.bluept.dev/api/delete-event", {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: event.id }),
        })

        const result = await res.json();
        setLoading(false);
        if(result.message=== "Event deleted successfully"){
            setAlertMsg("Event deleted successfully");
            setOpenSuccessAlert(true);
            setFilteredEvents((prevEvents) => prevEvents.filter((ev) => ev.id !== event.id));
            setLeads((prevEvents) => prevEvents.filter((ev) => ev.id !== event.id));
        }
        else{
            setAlertMsg("Event deletion failed");
            setOpenErrorAlert(true);
            setOpenErrorAlert(true);
        }
    }
    // const visibleRows = useMemo(
    //     ()=> filteredEvents.slice(page*rowsPerPage, page*rowsPerPage+rowsPerPage),
    //     [filteredEvents,page]
    // );

    const isPaymentSetValid = () => {
        if (!paymentSale) return false;

        // If it's a 'מכירה' sale, ensure exactly 3 payments,
        // and the numeric values (50 + 40 + 10) sum to 100:
        if (paymentSale.LeadType === 'מכירה') {
            if (payments.length !== 3) return false;

            // Extract the numeric percentages, e.g. "50%" → 50
            const sum = payments
                .map((p) => parseInt(p.payment_type.replace('%',''), 10) || 0)
                .reduce((acc, x) => acc + x, 0);

            return sum === 100;
        }

        // If it's 'ליסינג', just make sure we have at least one row
        // (or you can do more checks if you want). Here we always return true once < maxCount:
        if (paymentSale.LeadType === 'ליסינג') {
            // e.g. require at least the 2 “special” rows + 1 normal?
            return payments.length > 0;
        }

        // For any other sale type, just allow saving
        return true;
    };


    // const handleCloseDetailModal = () => {
    //     setShowDetailModal(false);
    // };


    const handleEditFileChange = (e) => {
        const files = Array.from(e.target.files);
        // Process each file to create an object with useful information.
        const newFiles = files.map((file) => ({
            file,
            name: file.name,
            type: file.type,
            previewUrl: URL.createObjectURL(file), // You can display a preview (if needed)
        }));

        // Save the newly selected files in the edit form state.
        // (Using a dedicated property "newAttachments" so that you keep existing attachments intact.)
        setEditFormData((prev) => ({
            ...prev,
            newAttachments: newFiles,
        }));
    };

    const { totalsByType, grandTotal } = useMemo(() => {
        const tbt = {};
        let all = 0;
        for (const ev of filteredEvents) {
            const amt = Number(ev.payment_amount) || 0;
            const type = ev.event_type || "אחר";
            tbt[type] = (tbt[type] || 0) + amt;
            all += amt;
        }
        return { totalsByType: tbt, grandTotal: all };
    }, [filteredEvents]);

    const flatSales = useMemo(() => {
        const out = [];
        (salesCases || []).forEach(c =>
            (c.projects || []).forEach(p =>
                (p.sales || []).forEach(s => out.push(s))
            )
        );
        return out;
    }, [salesCases]);

    const closedDeals = flatSales.filter(s => Number(s.Progress) === 100);

const leasingCountClosedDeals = closedDeals.filter(s => s.LeadType === "ליסינג").length;
const saleCountClosedDeals    = closedDeals.filter(s => s.LeadType === "מכירה").length;

const totalSalesClosed = closedDeals
  .filter(s => s.LeadType === "מכירה")
  .reduce((acc, s) => acc + (Number(s.TotalAmountInSale) || 0), 0)
  .toLocaleString("he-IL", { style: "currency", currency: "ILS", minimumFractionDigits: 0, maximumFractionDigits: 0 });

const totalsLeasingClosed = closedDeals
  .filter(s => s.LeadType === "ליסינג")
  .reduce((acc, s) => acc + ((Number(s.MonthlyAmountLeasing) || 0) * 12), 0)
  .toLocaleString("he-IL", { style: "currency", currency: "ILS", minimumFractionDigits: 0, maximumFractionDigits: 0 });

const closedArrDeals     = closedDeals.filter(s => s.LeadType === "ליסינג" || s.LeadType === "חכירה");
const closedOneTimeDeals = closedDeals.filter(s => s.LeadType === "מכירה");

const totalLanesARRClosed =
  closedArrDeals.reduce((acc, s) => acc + (Number(s.Lanes) || 0), 0);

const totalLanesOneTimeClosed =
  closedOneTimeDeals.reduce((acc, s) => acc + (Number(s.Lanes) || 0), 0);
    // If you still want the old "sales", you could alias:
    // const sales = flatSales;

    // Segment stats based on flatSales
    const segments = [
        { label: "0‑50%", predicate: s => Number(s.Progress) <= 50 },
        { label: "50‑70%", predicate: s => Number(s.Progress) > 50 && Number(s.Progress) <= 70 },
        { label: "70‑99%", predicate: s => Number(s.Progress) > 70 && Number(s.Progress) < 100 },
    ];

    const segmentStats = segments.map(({ label, predicate }) => {
        let seg = flatSales.filter(s => {
            // First check if it matches the segment predicate
            if (!predicate(s)) return false;

            // Then check if it should be excluded from stats
            // Only exclude if explicitly marked as true
            if (s.ExcludeFromStats === true || s.ExcludeFromStats === 1) return false;

            return true;
        });

        const leasingCount = seg.filter(s => s.LeadType === "ליסינג" || s.LeadType === "ענן ותקשורת").length;
        const saleCount = seg.filter(s => s.LeadType === "מכירה").length;

        const totalLeasingNum = seg
            .filter(s => s.LeadType === "ליסינג" || s.LeadType === "ענן ותקשורת")
            .reduce((sum, s) => sum + (Number(s.MonthlyAmountLeasing) || 0) * 12, 0);

        const totalSaleNum = seg
            .filter(s => s.LeadType === "מכירה")
            .reduce((sum, s) => sum + (Number(s.TotalAmountInSale) || 0), 0);

        const totalLanesNum = seg
            .filter(s => s.LeadType !== "ענן ותקשורת")
            .reduce((sum, s) => sum + (Number(s.Lanes) || 0), 0);

        const totalLeasing = totalLeasingNum.toLocaleString("he-IL", { style: "currency", currency: "ILS", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const totalSales = totalSaleNum.toLocaleString("he-IL", { style: "currency", currency: "ILS", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const totalLanes = totalLanesNum.toLocaleString("he-IL");

        return { label, leasingCount, saleCount, totalLeasing, totalSales, totalLanes };
    });

// ...existing code...
function ReturnScheduler() {
  const white = '#fff';
  const outline = leadReturnEnabled ? white : 'rgba(255,255,255,0.6)';

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      sx={{
        p: 1.25,
        border: '1px',
        borderColor: leadReturnEnabled ? white : (t) => t.palette.divider,
        borderRadius: 2,
        color: white,
      }}
    >
      <Checkbox
        size="medium"
        checked={leadReturnEnabled}
        onChange={(e) => setLeadReturnEnabled(e.target.checked)}
        sx={{
          color: white,
          '&.Mui-checked': { color: white },
          '& .MuiSvgIcon-root': { fontSize: 22 },
        }}
      />
      <Typography variant="body2" sx={{ minWidth: 110, color: white, fontWeight: 600 }}>
        תאריך חזרה
      </Typography>
      <TextField
        type="datetime-local"
        size="medium"
        disabled={!leadReturnEnabled}
        value={leadReturnDate}
        onChange={(e) => setLeadReturnDate(e.target.value)}
        sx={{
          minWidth: 200,
          '& .MuiOutlinedInput-input': { color: white, py: 1.1 },
          '& input::-webkit-calendar-picker-indicator': { filter: 'invert(1)' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: outline },
            '&:hover fieldset': { borderColor: white },
            '&.Mui-focused fieldset': { borderColor: white },
            '&.Mui-disabled fieldset': { borderColor: outline },
          },
          '& .MuiSvgIcon-root': { color: white },
        }}
        InputLabelProps={{ shrink: true, sx: { color: white } }}
      />
    </Box>
  );
}
// ...existing code...

    function CommentsList({ comments, loading, emptyLabel }) {
        if (loading) {
            return (
                <Box display="flex" justifyContent="center" py={2}>
                    <CircularProgress size={22} />
                </Box>
            );
        }
        if (!comments.length) {
            return (
                <Typography variant="caption" sx={{ opacity: 0.6 }}>
                    {emptyLabel}
                </Typography>
            );
        }

        const formatReturnDate = (raw) => {
            if (!raw) return '';
            const isoLike = raw.includes(' ') ? raw.replace(' ', 'T') : raw;
            const d = new Date(isoLike);
            if (isNaN(d.getTime())) return '';
            return d.toLocaleString('he-IL', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        };

        return (
            <Stack spacing={1.2} mt={0.5}>
                {comments.map((c, idx) => {
                    const returnRaw = c.ReturnDate || c.return_date || null;
                    const returnStr = formatReturnDate(returnRaw);
                    const isFuture = returnRaw ? new Date(returnRaw) > new Date() : false;

                    return (
                        <Paper
                            key={c.CommentId || idx}
                            elevation={2}
                            sx={{
                                p: 1,
                                bgcolor: '#fff',
                                color: '#000',
                                borderRadius: 1,
                                position: 'relative',
                                              textAlign: 'right',               // right-align everything inside
              direction: 'rtl', 
                            }}
                        >
                            <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                {c.Author || '—'} · {c.CreatedAt}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.25, mt: 0.5 }}
                            >
                                {highlightMentions(c.CommentText)}
                            </Typography>

                            {returnStr && (
                                <Box
                                    sx={{
                                        mt: 0.75,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        px: 1,
                                        py: 0.6,
                                        borderRadius: 1,
                                        bgcolor: isFuture ? 'info.light' : 'grey.200',
                                        border: '1px solid',
                                        borderColor: isFuture ? 'info.main' : 'grey.400',
                                    }}
                                >
                                    <Chip
                                        size="small"
                                        color={isFuture ? 'info' : 'default'}
                                        label={isFuture ? 'תאריך חזרה נקבע' : 'תאריך חזרה עבר'}
                                        sx={{ fontSize: 11 }}
                                    />
                                    <Typography variant="caption" sx={{ fontWeight: 500 }}>
                                        {returnStr}
                                    </Typography>
                                </Box>
                            )}
                        </Paper>
                    );
                })}
            </Stack>
        );
    }
    
    function AgentReturnFilter({
        selectedAgents, setSelectedAgents, handlingAgents = [],
        returnFrom, setReturnFrom,
        returnTo, setReturnTo,
        onResetPage,
    }) {
        return (
            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={1}>
                <FormControl variant="standard" size="small" sx={{ minWidth: 200 }}>
                    <InputLabel id="agent-filter-shared">סוכן מטפל</InputLabel>
                    <Select
                        labelId="agent-filter-shared"
                        multiple
                        value={selectedAgents}
                        onChange={(e) => {
                            const v = e.target.value;
                            setSelectedAgents(Array.isArray(v) ? v : (v ? [v] : []));
                            onResetPage?.();
                        }}
                        renderValue={(sel) => (sel && sel.length ? sel.join(', ') : 'All')}
                    >
                        {handlingAgents.map(opt => (
                            <MenuItem key={opt} value={opt} sx={{ py: 0.5, minHeight: 28 }}>
                                <Checkbox size="small" checked={selectedAgents.includes(opt)} />
                                <ListItemText primary={opt} primaryTypographyProps={{ fontSize: 13 }} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    label="חזרה מ־"
                    type="date"
                    size="small"
                    value={returnFrom}
                    onChange={(e) => { setReturnFrom(e.target.value); onResetPage?.(); }}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 140 }}
                />
                <TextField
                    label="חזרה עד"
                    type="date"
                    size="small"
                    value={returnTo}
                    onChange={(e) => { setReturnTo(e.target.value); onResetPage?.(); }}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 140 }}
                />

                <Button
                    size="small"
                    onClick={() => {
                        setSelectedAgents([]);
                        setReturnFrom('');
                        setReturnTo('');
                        onResetPage?.();
                    }}
                >
                    נקה
                </Button>
            </Box>
        );
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={6000}
                onClose={() => setOpenErrorAlert(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenErrorAlert(false)} severity="error" variant="filled">
                    {alertMsg}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={6000}
                onClose={() => setOpenSuccessAlert(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSuccessAlert(false)} severity="success" variant="filled">
                    {alertMsg}
                </Alert>
            </Snackbar>
            {/* Container Box for the page */}
            {loading ?
                <Box
                    sx={{
                        position: "fixed",  // or "absolute" if you prefer relative to a specific parent
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",  // truly centers it
                    }}
                >
                    <CircularProgress
                        variant="indeterminate"
                        disableShrink
                        sx={(theme) => ({
                            color: '#1a90ff',
                            animationDuration: '550ms',
                            // display: "flex",
                            // justifyContent: "center",
                            // alignItems: "center",
                            // left: 0,
                            [`& .${circularProgressClasses.circle}`]: {
                                strokeLinecap: 'round',
                            },
                            ...theme.applyStyles('dark', {
                                color: '#308fe8',
                            }),
                        })}
                        size={40}
                        thickness={4}
                    />
                </Box>
                :
                <Box
                    sx={{
                        backgroundColor: pageBackground,
                        color: textColor,
                        minHeight: "100vh",
                        p: 3,
                    }}
                >
                    {/* PAGE TITLE + ADD BUTTON */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography variant="h4" fontWeight="bold">
                            Master Sales
                        </Typography>

                    </Box>
                    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                        <Tabs value={tabIndex} onChange={handleTabChange}>
                            <Tab icon={<ContactsIcon />} label="Leads" />
                            <Tab icon={<ReceiptIcon />} label="Quotes" />
                            <Tab icon={<CheckIcon />} label="Sales" />
                        </Tabs>
                    </Box>
                    {(tabIndex === 0) && (
                        <>
                            <Dialog
                                open={showChartModal}
                                onClose={() => setShowChartModal(false)}
                                fullWidth
                                maxWidth="lg"
                            >
                                <DialogContent dividers sx={{ backgroundColor: pageBackground }}>
                                    <Box mb={1} textAlign="center">
                                        <Typography variant="h6">Lead Sources</Typography>
                                    </Box>
                                    <Box sx={{ width: "100%", height: { xs: 360, md: 720 } }}>
                                        <LeadSourcePie sales={leads} height={700} maxWidth={1000} />
                                    </Box>
                                    <DialogActions>
                                        <Button onClick={() => setShowChartModal(false)}>Close</Button>
                                    </DialogActions>
                                </DialogContent>
                            </Dialog>
                            <Box
                                sx={{
                                    my: 2,
                                    width: '100%',
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(7, 1fr)' }, // 1 column on very small screens, 7 equal columns otherwise
                                    gap: 2,
                                }}
                            >
                                {[
                                    [" לידים רלוונטיים", leads.length - leads.filter(ev => ev.status?.includes("לא רלוונטי")).length],
                                    ["לידים לא רלוונטיים", leads.filter(ev => ev.status?.includes("לא רלוונטי")).length],
                                    ["לידים עם מקור", filteredList.filter(l => l.lead_source).length],
                                    ["לידים עם סוכן ראשוני", filteredList.filter(l => l.lead_agent).length],
                                    ["לידים עם סוכן מטפל", filteredList.filter(l => l.handling_agent).length],
                                    ["הצעת מחיר עם לידים", filteredSales.filter(l => l.LeadId).length],
                                    [" הצעות מחיר ללא לידים ", filteredList.length - filteredSales.filter(l => l.LeadId).length],
                                ].map(([label, value]) => (
                                    <Card
                                        key={label}
                                        sx={{
                                            borderRadius: 2,
                                            boxShadow: 4,
                                            backgroundColor: paperBg,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <CardContent sx={{ p: 1.5, textAlign: 'center', color: textColor }}>
                                            <Typography variant="caption" sx={{ opacity: 0.7, display: 'block', whiteSpace: 'nowrap' }}>
                                                {label}
                                            </Typography>
                                            <Typography variant="h6">{value}</Typography>
                                        </CardContent>
                                    </Card>
                                ))}
                            </Box>

                        </>
                    )}
                    {tabIndex === 1 && (
                        <Grid container spacing={2}>
                            {segmentStats.slice(0, 3).map(
                                ({ label, leasingCount, saleCount, totalLeasing, totalSales, totalLanes }) => (
                                    <Grid item xs={12} sm={6} md={4} key={label}>
                                        <Card
                                            sx={{
                                                borderRadius: 5,
                                                boxShadow: 5,
                                                mb: 2,
                                                backgroundColor: pageBackground,
                                                height: "100%",
                                            }}
                                        >
                                            <CardContent sx={{ color: textColor, p: 2 }}>
                                                {/* Card Header */}
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    align="center"
                                                    sx={{ fontWeight: 600, fontSize: "1rem" }}
                                                >
                                                    {label}
                                                </Typography>
                                                <Divider sx={{ my: 1 }} />

                                                {/* Stats Stack */}
                                                <Stack direction="column" spacing={0.8}>
                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography variant="caption" color="inherit">
                                                            כמות MRR
                                                        </Typography>
                                                        <Typography variant="body2" color="inherit">
                                                            {leasingCount}
                                                        </Typography>
                                                    </Box>

                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography variant="caption" color="inherit">
                                                            סכום חד פעמי
                                                        </Typography>
                                                        <Typography variant="body2" color="inherit">
                                                            {saleCount}
                                                        </Typography>
                                                    </Box>

                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography variant="caption" color="inherit">
                                                            כמות ARR
                                                        </Typography>
                                                        <Typography variant="body2" color="inherit">
                                                            {totalLeasing}
                                                        </Typography>
                                                    </Box>

                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography variant="caption" color="inherit">
                                                            כמות חד פעמי
                                                        </Typography>
                                                        <Typography variant="body2" color="inherit">
                                                            {totalSales}
                                                        </Typography>
                                                    </Box>

                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography variant="caption" color="inherit">
                                                            סך הכל נתיבים
                                                        </Typography>
                                                        <Typography variant="body2" color="inherit">
                                                            {totalLanes}
                                                        </Typography>
                                                    </Box>
                                                </Stack>

                                                <Divider sx={{ my: 1 }} />

                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )
                            )}
                        </Grid>
                    )}
                    {(tabIndex === 2) && (
                        <Box
                            sx={{
                                mb: 2,
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' }, // stack only on extra small
                                gap: 2,
                                width: '100%',
                            }}
                        >
                            {[ // label, value(s)
                                {
                                    label: 'כמות MRR',
                                    primary: leasingCountClosedDeals,
                                },
                                {
                                    label: 'כמות עסקאות סגורות',
                                    primary: saleCountClosedDeals,
                                },
                                {
                                    label: 'כמות ARR',
                                    primary: totalsLeasingClosed,
                                    extraLabel: 'סך הכל נתיבים',
                                    extraValue: totalLanesARRClosed,
                                },
                                {
                                    label: 'כמות חד פעמי',
                                    primary: totalSalesClosed,
                                    extraLabel: 'סך הכל נתיבים',
                                    extraValue: totalLanesOneTimeClosed,
                                },
                            ].map((m) => (
                                <Card
                                    key={m.label}
                                    sx={{
                                        flex: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: paperBg,
                                        borderRadius: 2,
                                        boxShadow: 4,
                                        minHeight: 90,
                                    }}
                                >
                                    <CardContent sx={{ p: 1.5, textAlign: 'center', color: textColor }}>
                                        <Typography variant="caption" sx={{ opacity: 0.7, display: 'block', whiteSpace: 'nowrap' }}>
                                            {m.label}
                                        </Typography>
                                        <Typography variant="h6">{m.primary}</Typography>
                                        {m.extraLabel && (
                                            <>
                                                <Typography variant="caption" sx={{ opacity: 0.7, display: 'block', mt: .5 }}>
                                                    {m.extraLabel}
                                                </Typography>
                                                <Typography variant="body1">{m.extraValue}</Typography>
                                            </>
                                        )}
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    )}
                    {tabIndex === 0 && (
                        <Box display="flex" flexDirection="column" mb={3}>
                            <Box display="flex" alignItems="center" gap={2} mb={2}>
                                <Tooltip title="+ הוסף ליד" arrow>
                                    <IconButton
                                        color="primary"
                                        onClick={handleOpenAddModal}
                                        sx={{ bgcolor: 'primary.main', color: '#fff', '&:hover': { bgcolor: 'primary.dark' } }}
                                        aria-label="Add Lead"
                                    >
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="יצוא" arrow>
                                    <IconButton
                                        onClick={() => handleExport(getLeadsData())}
                                        sx={{ bgcolor: '#008000', color: '#fff', '&:hover': { bgcolor: '#008000' } }}
                                        aria-label="Export Leads"
                                    >
                                        <CloudUploadIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="גרף" arrow>
                                    <IconButton
                                        color="info"
                                        onClick={() => setShowChartModal(true)}
                                        sx={{ bgcolor: 'info.main', color: '#fff', '&:hover': { bgcolor: 'info.dark' } }}
                                        aria-label="Lead Analytics"
                                    >
                                        <BarChartIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="היום שלי" arrow>
                                    <IconButton
                                        onClick={() => setShowMyToday(v => !v)}
                                        sx={{
                                            bgcolor: showMyToday ? "primary.light" : "#e0e0e0",
                                            color: showMyToday ? "#fff" : "#333",
                                            '&:hover': { bgcolor: showMyToday ? "primary.dark" : "#bdbdbd" },
                                            borderRadius: "50%",      // make it a circle
                                            width: 40,                // fixed size for circle
                                            height: 40,
                                            p: 0,                     // remove extra padding
                                            transition: "background 0.2s",
                                        }}
                                        aria-label="היום שלי"
                                    >
                                        <CalendarTodayIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box display="flex" alignItems="center" mb={2}>

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={showAll}
                                            onChange={e => setShowAll(e.target.checked)}
                                            size="small"
                                        />
                                    }
                                    label="להראות הכל"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={showIrrelevant}
                                            onChange={e => setShowIrrelevant(e.target.checked)}
                                            size="small"
                                        />
                                    }
                                    label="הצג רק לידים לא רלוונטיים"
                                />
                            </Box>
                            <AgentReturnFilter
                                selectedAgents={selectedAgentsLeads}
                                setSelectedAgents={setSelectedAgentsLeads}
                                handlingAgents={handlingAgents}
                                returnFrom={returnFromLeads}
                                setReturnFrom={setReturnFromLeads}
                                returnTo={returnToLeads}
                                setReturnTo={setReturnToLeads}
                            />
                            <MaterialReactTable
                                columns={leadColumns}
                                initialState={{
                                    showColumnFilters: true,
                                    columnVisibility: isMobile
                                        ? {
                                            company_name: true,
                                            status: true,
                                            last_contact: true,
                                            creation_date: true,
                                            lead_agent: false,
                                            email: false,
                                            full_name: false,
                                            phone_number: false,
                                            lead_source: false,
                                            handling_agent: true,
                                            callHistory: false,
                                            quoteLink: false,
                                            searchableLead: false,
                                            campaign_name: false, // keep hidden
                                        }
                                        : { searchableLead: false },   // keep hidden on desktop too
                                }}
                                defaultColumn={{ enableColumnFilter: false }}
                                data={filteredList}
                                autoResetPageIndex={false}
                                enableGlobalFilter={true}
                                state={{ globalFilter, showGlobalFilter, columnFilters }}       // ← both bits of state
                                onGlobalFilterChange={setGlobalFilter}            // ← handle text changes
                                onShowGlobalFilterChange={setShowGlobalFilter}    // ← handle icon toggle
                                onColumnFiltersChange={handleColumnFiltersChange}  // ← AND HERE
                                enableStickyHeader
                                displayColumnDefOptions={{
                                    'mrt-row-actions': {
                                        header: 'פעולות',      // <-- change header text here
                                        size: 120,               // optional: keep or adjust width
                                    },
                                }}
                                muiTableContainerProps={{
                                    ref: tableContainerRef,
                                    sx: {
                                        overflowX: "auto",
                                        position: "relative",
                                        // faint right-edge cue only on mobile when more to the right
                                        background:
                                            isMobile && nav.canRight
                                                ? "linear-gradient(to right, rgba(0,0,0,0) 85%, rgba(0,0,0,0.06))"
                                                : "none",
                                    },
                                }}
                                muiToolbarSearchTextFieldProps={{
                                    value: globalFilter,
                                    onChange: e => setGlobalFilter(e.target.value),
                                    placeholder: "Search…",
                                }}

                                muiTablePaperProps={{
                                    sx: { backgroundColor: darkMode ? '#27293d' : '#ffffff' },
                                }}
                                renderTopToolbarCustomActions={() =>
                                    searchTerm ? (
                                        <Button size="small" onClick={() => setSearchTerm("")}>
                                            Show all
                                        </Button>
                                    ) : null
                                }
                                enableRowActions
                                positionActionsColumn="first"
                                renderRowActions={({ row }) => (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',     // horizontal
                                            alignItems: 'center',
                                            gap: 0.5,                 // tighter spacing
                                        }}
                                    >
                                        <Tooltip title="עריכה" arrow>
                                            <IconButton
                                                color="primary"
                                                size="small"
                                                onClick={() => handleOpenEditModal(row.original)}
                                                sx={{ bgcolor: 'primary.main', color: '#fff', '&:hover': { bgcolor: 'primary.dark' } }}
                                            >
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="יצירת הצעה" arrow>
                                            <IconButton
                                                color="secondary"
                                                size="small"
                                                onClick={() => handleOpenCreateSale(row.original.id)}
                                                sx={{ bgcolor: 'secondary.main', color: '#fff', '&:hover': { bgcolor: 'secondary.dark' } }}
                                            >
                                                <ReceiptIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                )}
                                muiTableBodyRowProps={({ row }) => ({
                                    sx: {
                                        // highlight the parent row when it's expanded
                                        height: 80,
                                        '& td': {
                                            minHeight: 80,
                                            height: 80,
                                            py: 0,
                                            lineHeight: '44px',
                                            display: 'table-cell',
                                        },
                                        backgroundColor: row.getIsExpanded()
                                            ? (theme) => theme.palette.action.hover
                                            : undefined,
                                        // give all child rows a very light tinted background
                                        ...(row.depth > 0 && {
                                            backgroundColor: (theme) => theme.palette.grey[50],
                                        }),
                                        // optional: add a left border for children
                                        ...(row.depth > 0 && {
                                            borderLeft: (theme) => `4px solid ${theme.palette.primary.light}`,
                                        }),
                                    },
                                })}

                                muiBottomToolbarProps={{
                                    sx: {
                                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                                        color: darkMode ? '#fff' : '#1e293b',
                                        ".MuiFormLabel-root": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiSelect-icon": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiSelect-select": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiBox-root.MuiButtonBase-root": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiSvgIcon-root": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                            // pick a dimmer color for disabled icons
                                            color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                                        },
                                    }
                                }}
                                muiTopToolbarProps={{
                                    sx: {
                                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                                        color: '#fff',
                                        ".MuiSvgIcon-root": {

                                            color: darkMode ? '#fff' : '#1e293b',

                                        },
                                        // ".Mui-TableHeadCell": {
                                        //     color: darkMode ? '#fff' : '#1e293b',
                                        // },
                                        ".MuiTableSortLabel-iconDirectionAsc": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        }
                                    },

                                }}
                                muiTableBodyCellProps={({ row }) => ({
                                    sx: {
                                        backgroundColor: (darkMode ? "#1e293b" : "#ffffff"),
                                        color: darkMode ? "#ffffff" : "#000",
                                        ".MuiSvgIcon-root": {
                                            color: darkMode ? "#ffffff" : "#000",
                                        },
                                        maxWidth: "80px"
                                    },
                                })}
                                muiTableHeadCellProps={{
                                    sx: {
                                        backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                                        color: "white",
                                        fontWeight: "bold",
                                        ".MuiSvgIcon-root": {
                                            color: darkMode ? "#ffffff" : "#000",
                                        },
                                        ".Mui-TableHeadCell-Content-Wrapper": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        // then specifically target the sort label icon:
                                        '& .MuiTableSortLabel-icon': {
                                            color: darkMode ? '#fff !important' : '#000 !important',
                                        },
                                        // likewise for iconDirectionAsc / iconDirectionDesc if needed
                                        '& .MuiTableSortLabel-iconDirectionAsc': {
                                            color: darkMode ? '#fff !important' : '#000 !important',
                                        },
                                        '& .MuiTableSortLabel-iconDirectionDesc': {
                                            color: darkMode ? '#fff !important' : '#000 !important',
                                        },
                                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                            // pick a dimmer color for disabled icons
                                            color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        }
                                    },
                                }}
                                muiTableHeadProps={{
                                    sx: {
                                        display: "table-header-group",
                                        backgroundColor: "rgb(0,0,0)",
                                        color: "white",
                                        "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
                                    },
                                }}
                            />
                            {/* Left pager */}
                            {(
                                <IconButton
                                    onClick={() => handlePage("left")}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        left: 8,
                                        top: isMobile ? '50%' : '40%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 3,
                                        boxShadow: 2,
                                        border: "1px solid rgba(255,255,255,0.25)",

                                        color: "white",                 // <- set the icon color
                                        '& .MuiSvgIcon-root, & svg': {
                                            color: `white !important`,
                                            fill: `white !important`,
                                        },
                                        backgroundColor: (t) =>
                                            t.palette.mode === "white",
                                        '&:hover': { backgroundColor: "white" },
                                        '&:active': { backgroundColor: "white" },
                                        '&:focus-visible': { outline: 'none' },
                                    }}
                                >
                                    <ChevronLeftIcon sx={{color: "#fff"}}/>
                                </IconButton>
                            )}

                            {/* Right pager */}
                            { (
                                <IconButton
                                    onClick={() => handlePage("right")}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        right: 8,
                                        top: isMobile ? '50%' : '40%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 3,
                                        boxShadow: 2,
                                        border: "1px solid rgba(255,255,255,0.25)",
                                        color: "white",                 // <- set the icon color
                                        '& .MuiSvgIcon-root, & svg': {
                                            color: `white !important`,
                                            fill: `white !important`,
                                        },
                                        backgroundColor: (t) =>
                                            t.palette.mode === "white",
                                        '&:hover': { backgroundColor: "white" },
                                        '&:active': { backgroundColor: "white" },
                                        '&:focus-visible': { outline: 'none' },
                                    }}
                                >
                                    <ChevronRightIcon />
                                </IconButton>
                            )}
                        </Box>
                    )}




                    {tabIndex === 1 && (
                        <>
                            <Box display="flex" alignItems="center" my={2}>
                                <Tooltip title="צור תיק לקוח" arrow>
                                    <IconButton
                                        color="primary"
                                        onClick={() => setShowCreateCaseModal(true)}
                                        // bigger button + spacing like in Leads
                                        size="medium"
                                        sx={{
                                            bgcolor: 'primary.main',
                                            color: '#fff',
                                            '&:hover': { bgcolor: 'primary.dark' },
                                            mr: 1.5, // add space to the right
                                            p: 1.25, // a bit more padding for larger feel
                                        }}
                                        aria-label="Create Case"
                                    >
                                        <FolderOpenIcon fontSize="medium" />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="יצוא" arrow>
                                    <IconButton
                                        onClick={() => handleExport(getQuotesData())}
                                        size="medium"
                                        sx={{
                                            bgcolor: '#008000',
                                            color: '#fff',
                                            '&:hover': { bgcolor: '#008000' },
                                            mr: 1.5, // spacing between icons
                                            p: 1.25,
                                        }}
                                        aria-label="Export Quotes"
                                    >
                                        <CloudUploadIcon fontSize="medium" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={1}>
                                <FormControl variant="standard" size="small" sx={{ minWidth: 200 }}>
                                    <InputLabel id="agent-filter-quotes">סוכן מטפל</InputLabel>
                                    <Select
                                        labelId="agent-filter-quotes"
                                        multiple
                                        value={selectedAgentsQuotes}
                                        onChange={(e) => {
                                            const v = e.target.value;
                                            setSelectedAgentsQuotes(Array.isArray(v) ? v : (v ? [v] : []));
                                            setSalesPage(0);
                                        }}
                                        renderValue={(sel) => (sel && sel.length ? sel.join(', ') : 'All')}
                                    >
                                        {handlingAgents.map(opt => (
                                            <MenuItem key={opt} value={opt} sx={{ py: 0.5, minHeight: 28 }}>
                                                <Checkbox size="small" checked={selectedAgentsQuotes.includes(opt)} />
                                                <ListItemText primary={opt} primaryTypographyProps={{ fontSize: 13 }} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* NEW: Return Date range */}
                                <TextField
                                    label="חזרה מ־"
                                    type="date"
                                    size="small"
                                    value={returnFromQuotes}
                                    onChange={(e) => { setReturnFromQuotes(e.target.value); setSalesPage(0); }}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ minWidth: 140 }}
                                />
                                <TextField
                                    label="חזרה עד"
                                    type="date"
                                    size="small"
                                    value={returnToQuotes}
                                    onChange={(e) => { setReturnToQuotes(e.target.value); setSalesPage(0); }}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ minWidth: 140 }}
                                />

                                <Button
                                    size="small"
                                    onClick={() => {
                                        setSelectedAgentsQuotes([]);
                                        setReturnFromQuotes("");
                                        setReturnToQuotes("");
                                        setSalesPage(0);
                                    }}
                                >
                                    נקה
                                </Button>
                            </Box>
                            <MaterialReactTable
                                columns={quotesHierarchicalColumns}
                                data={hierarchicalQuotesData}
                                defaultColumn={{ enableGlobalFilter: false }}
                                getSubRows={row => row.subRows}
                                enableExpanding
                                enableGlobalFilter
                                onGlobalFilterChange={setGlobalFilter}
                                globalFilterFields={['searchAllQuotes']}

                                muiToolbarSearchTextFieldProps={{                // <-- bind input
                                    value: globalFilter,
                                    onChange: (e) => setGlobalFilter(e.target.value),
                                    placeholder: 'חיפוש…',
                                }}
                                globalFilterFn="includesString"
                                state={{ globalFilter, expanded: quotesExpanded }}
                                autoResetPageIndex={false}
                                paginateExpandedRows={false}
                                getRowId={(row) =>
                                    row.SaleId ? `sale-${row.SaleId}` :
                                        row.ProjectId ? `proj-${row.CaseId}-${row.ProjectId}` :
                                            `case-${row.CaseId}`
                                }
                                positionActionsColumn="last"
                                onExpandedChange={setQuotesExpanded}
                                muiTablePaperProps={{
                                    sx: { backgroundColor: darkMode ? '#27293d' : '#ffffff' },
                                }}
                                enableRowActions={false}
                                filterFromLeafRows={true}
                                displayColumnDefOptions={{
                                    'mrt-row-expand': {
                                        size: 90,
                                        header: '',
                                        muiTableBodyCellProps: ({ row }) => {
                                            const depth = row.depth;
                                            const projectsCount = depth === 0 ? (row.original.subRows?.length || 0) : null;
                                            const salesCountProject = depth === 1 ? (row.original.subRows?.length || 0) : null;

                                            return {
                                                sx: { px: 0, width: 90, minWidth: 90 },
                                                children: (
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            width: '100%',
                                                            '& > .slot': { flex: '0 0 auto', display: 'flex', alignItems: 'center' },
                                                            '& .expandBtn': { width: 28, justifyContent: 'center' },
                                                        }}
                                                    >
                                                        <Box className="slot expandBtn">
                                                            <IconButton
                                                                size="small"
                                                                onClick={row.getToggleExpandedHandler()}
                                                                disabled={!row.getCanExpand()}
                                                                sx={{
                                                                    p: 0.5,
                                                                    opacity: row.getCanExpand() ? 1 : 0.4, // show icon but dim when disabled
                                                                    cursor: row.getCanExpand() ? 'pointer' : 'default',
                                                                }}
                                                            >
                                                                {row.getIsExpanded()
                                                                    ? <ChevronRightIcon sx={{ transform: 'rotate(90deg)', color: '#fff' }} />
                                                                    : <ChevronRightIcon sx={{ color: '#fff' }} />}
                                                            </IconButton>
                                                        </Box>

                                                        <Box className="slot">
                                                            {depth === 0 && (
                                                                <>
                                                                    <Chip size="small" color="primary" label={projectsCount} sx={{ fontSize: 9 }} />

                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => handleOpenCreateProject(row.original)}
                                                                        sx={{ ml: 0.5, p: 0.5 }}
                                                                        aria-label="Add Project"
                                                                        title="הוסף פרויקט"
                                                                    >
                                                                        <AddCircleOutlineIcon sx={{ color: '#fff' }} />
                                                                    </IconButton>

                                                                </>
                                                            )}
                                                            {depth === 1 && (
                                                                <>
                                                                    <Chip size="small" color="success" label={salesCountProject} sx={{ fontSize: 9, ml: 2 }} />
                                                                    {/* Always show Add Sale button */}
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => handleOpenCreateSaleForProject(row)}
                                                                        sx={{ ml: 0.5, p: 0.5 }}
                                                                        aria-label="Add Sale"
                                                                        title="הוסף הצעה"
                                                                    >
                                                                        <AddCircleOutlineIcon sx={{ color: '#fff' }} />
                                                                    </IconButton>
                                                                </>
                                                            )}
                                                            {depth === 2 && (
                                                                <Chip size="small" color="warning" label="הצעה" sx={{ fontSize: 11, ml: 6 }} />
                                                            )}
                                                        </Box>
                                                    </Box>
                                                ),
                                            };
                                        },
                                    },
                                }}
                                initialState={{
                                    columnSizing: 20,
                                    // columnVisibility: {
                                    //     leadSearch: false,           // ensure it stays hidden in column‐visibility state
                                    // },
                                }}
                                // renderTopToolbarCustomActions={() => (
                                //     <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                //         <FormControl variant="standard" size="small" sx={{ minWidth: 200, maxWidth: 200 }}>
                                //             <InputLabel id="quotes-lead-source-label">סוכן הצעה</InputLabel>
                                //             <Select
                                //                 labelId="quotes-lead-source-label"
                                //                 multiple
                                //                 value={selectedLeadSources}
                                //                 onChange={(e) => {
                                //                     const v = e.target.value;
                                //                     setSelectedLeadSources(typeof v === "string" ? v.split(",") : v);
                                //                     setSalesPage(0);
                                //                 }}
                                //                 renderValue={(sel) => (sel && sel.length ? sel.join(", ") : "All")}
                                //             >
                                //                 {leadSourceOptions.map((opt) => (
                                //                     <MenuItem key={opt} value={opt} sx={{ py: 0.5, minHeight: 28 }}>
                                //                         <Checkbox checked={selectedLeadSources.indexOf(opt) > -1} size="small" />
                                //                         <ListItemText primary={opt} primaryTypographyProps={{ fontSize: 13 }} />
                                //                     </MenuItem>
                                //                 ))}
                                //             </Select>
                                //         </FormControl>
                                //         <TextField
                                //             label="מ תאריך"
                                //             type="date"
                                //             size="small"
                                //             value={quoteFrom}
                                //             onChange={(e) => { setQuoteFrom(e.target.value); setSalesPage(0); }}
                                //             InputLabelProps={{ shrink: true }}
                                //             sx={{ minWidth: 140 }}
                                //         />
                                //         <TextField
                                //             label="עד תאריך"
                                //             type="date"
                                //             size="small"
                                //             value={quoteTo}
                                //             onChange={(e) => { setQuoteTo(e.target.value); setSalesPage(0); }}
                                //             InputLabelProps={{ shrink: true }}
                                //             sx={{ minWidth: 140 }}
                                //         />
                                //         <Button
                                //             size="small"
                                //             onClick={() => {
                                //                 setQuoteFrom("");
                                //                 setQuoteTo("");          // FIX: actually clear 'to'
                                //                 setSelectedLeadSources([]);
                                //                 setSalesPage(0);
                                //             }}
                                //         >
                                //             CLEAR
                                //         </Button>
                                //     </Box>
                                // )}

                                muiTableBodyRowProps={({ row }) => {
                                    // modern, low-contrast surfaces by hierarchy
                                    const depth = row.depth;
                                    const theme = useTheme();
                                    const isDark = darkMode;

                                    const projectAccent = theme.palette.info.main;
                                    const saleAccent = "#7E57C2";

                                    const projectBg = alpha(projectAccent, isDark ? 0.10 : 0.06);
                                    const projectHover = alpha(projectAccent, isDark ? 0.18 : 0.12);

                                    const saleBg = alpha(saleAccent, isDark ? 0.08 : 0.05);
                                    const saleHover = alpha(saleAccent, isDark ? 0.16 : 0.10);

                                    const baseBg = isDark ? '#1E293B' : '#ffffff';
                                    const dividerColor = alpha(theme.palette.divider, 0.18);

                                    const isProject = depth === 1;
                                    const isSale = depth >= 2;

                                    const bg = isProject ? projectBg : isSale ? saleBg : baseBg;
                                    const hoverBg = isProject ? projectHover : isSale ? saleHover : alpha(theme.palette.primary.main, isDark ? 0.10 : 0.06);
                                    const accent = isProject ? projectAccent : isSale ? saleAccent : alpha(theme.palette.primary.main, 0.4);

                                    // round the group “block” a bit for children
                                    const parentExpanded = row.getParentRow()?.getIsExpanded();
                                    const isChild = depth > 0;

                                    return {
                                        sx: {
                                            // subtle separators
                                            height: 80,
                                            '& td': {
                                                // keep your existing background/transition, plus add these:
                                                minHeight: 80,
                                                height: 80,
                                                py: 0,                // remove vertical padding
                                                lineHeight: '44px',   // center single-line content
                                                display: 'table-cell' // ensure proper table layout
                                            },
                                            borderTop: `1px solid ${dividerColor}`,
                                            '& td': {
                                                backgroundColor: bg,
                                                transition: 'background-color .2s ease, box-shadow .2s ease',
                                            },
                                            '&:hover td': {
                                                backgroundColor: hoverBg,
                                            },
                                            // modern left accent
                                            borderLeft: isChild ? `4px solid ${accent}` : undefined,

                                            // give children a soft “card” feel
                                            ...(isChild && {
                                                boxShadow: isDark
                                                    ? 'inset 0 1px 0 rgba(255,255,255,0.04)'
                                                    : 'inset 0 1px 0 rgba(0,0,0,0.04)',
                                            }),

                                            // a bit more contrast when parent is expanded
                                            ...(isChild && parentExpanded && {
                                                '& td': { backgroundColor: hoverBg },
                                            }),
                                        },
                                    };
                                }}

                                muiBottomToolbarProps={{
                                    sx: {
                                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                                        color: darkMode ? '#fff' : '#1e293b',
                                        ".MuiFormLabel-root": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiSelect-icon": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiSelect-select": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiBox-root.MuiButtonBase-root": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        ".MuiSvgIcon-root": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                            // pick a dimmer color for disabled icons
                                            color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                                        },
                                    }
                                }}
                                muiTopToolbarProps={{
                                    sx: {
                                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                                        color: '#fff',
                                        ".MuiSvgIcon-root": {

                                            color: darkMode ? '#fff' : '#1e293b',

                                        },
                                        // ".Mui-TableHeadCell": {
                                        //     color: darkMode ? '#fff' : '#1e293b',
                                        // },
                                        ".MuiTableSortLabel-iconDirectionAsc": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        }
                                    },

                                }}
                                // muiTableBodyCellProps={({ row }) => ({
                                //     sx: {
                                //         backgroundColor: (darkMode ? "#1e293b" : "#ffffff"),
                                //         color: darkMode ? "#ffffff" : "#000",
                                //         ".MuiSvgIcon-root" : {
                                //             color: darkMode ? "#ffffff" : "#000",
                                //         },
                                //         maxWidth: "80px"
                                //     },
                                // })}
                                muiTableHeadCellProps={{
                                    sx: {
                                        backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                                        color: "white",
                                        fontWeight: "bold",
                                        ".MuiSvgIcon-root": {
                                            color: darkMode ? "#ffffff" : "#000",
                                        },
                                        ".Mui-TableHeadCell-Content-Wrapper": {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        },
                                        // then specifically target the sort label icon:
                                        '& .MuiTableSortLabel-icon': {
                                            color: darkMode ? '#fff !important' : '#000 !important',
                                        },
                                        // likewise for iconDirectionAsc / iconDirectionDesc if needed
                                        '& .MuiTableSortLabel-iconDirectionAsc': {
                                            color: darkMode ? '#fff !important' : '#000 !important',
                                        },
                                        '& .MuiTableSortLabel-iconDirectionDesc': {
                                            color: darkMode ? '#fff !important' : '#000 !important',
                                        },
                                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                            // pick a dimmer color for disabled icons
                                            color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: darkMode ? '#fff' : '#1e293b',
                                        }
                                    },
                                }}
                                muiTableHeadProps={{
                                    sx: {
                                        display: "table-header-group",
                                        backgroundColor: "rgb(0,0,0)",
                                        color: "white",
                                        "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
                                    },
                                }}
                                muiTableContainerProps={{
                                    ref: tableContainerRef,
                                    sx: {
                                        width: '100%',
                                        backgroundColor: 'transparent',
                                    },
                                }}
                                muiTableBodyCellProps={({ row }) => ({
                                    sx: {
                                        // top-level Case rows keep the solid color (as in the screenshot)
                                        backgroundColor:
                                            row.depth === 0
                                                ? (darkMode ? '#1e293b' : '#ffffff')   // adjust if your case bg differs
                                                : 'transparent',                       // let child row bg show
                                        color: darkMode ? '#fff' : '#000',
                                        '.MuiSvgIcon-root': { color: darkMode ? '#fff' : '#000' },
                                        maxWidth: '80px',
                                    },
                                })}
                            />
                            {   (
                                <IconButton
                                    onClick={() => handlePage("left")}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        left: 8,
                                        top: isMobile ? '50%' : '40%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 3,
                                        boxShadow: 2,
                                        border: "1px solid rgba(255,255,255,0.25)",

                                        color: "white",                 // <- set the icon color
                                        '& .MuiSvgIcon-root, & svg': {
                                            color: `white !important`,
                                            fill: `white !important`,
                                        },
                                        backgroundColor: (t) =>
                                            t.palette.mode === "white",
                                        '&:hover': { backgroundColor: "white"},
                                        '&:active': { backgroundColor: "white" },
                                        '&:focus-visible': { outline: 'none' },
                                    }}
                                >
                                    <ChevronLeftIcon sx={{color: "#fff"}}/>
                                </IconButton>
                            )}

                            {/* Right pager */}
                            { (
                                <IconButton
                                    onClick={() => handlePage("right")}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        right: 8,
                                        top: isMobile ? '50%' : '40%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 3,
                                        boxShadow: 2,
                                        border: "1px solid rgba(255,255,255,0.25)",
                                        color: "white",                 // <- set the icon color
                                        '& .MuiSvgIcon-root, & svg': {
                                            color: `white !important`,
                                            fill: `white !important`,
                                        },
                                        backgroundColor: (t) =>
                                            t.palette.mode === "white",
                                        '&:hover': { backgroundColor: "white"},
                                        '&:active': { backgroundColor: "white" },
                                        '&:focus-visible': { outline: 'none' },
                                    }}
                                >
                                    <ChevronRightIcon />
                                </IconButton>
                            )}
                        </>

                    )}
                    {tabIndex === 2 && (
                        <>
                            <Box display="flex" alignItems="center" mb={1}>
                                <Tooltip title="יצוא" arrow>
                                    <IconButton
                                        onClick={() => handleExport(getSalesData())}
                                        sx={{ bgcolor: '#008000', color: '#fff', '&:hover': { bgcolor: '#008000' } }}
                                        aria-label="Export Sales"
                                        size="small"
                                    >
                                        <CloudUploadIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={1}>
                                <FormControl variant="standard" size="small" sx={{ minWidth: 200 }}>
                                    <InputLabel id="agent-filter-sales">סוכן מטפל</InputLabel>
                                    <Select
                                        labelId="agent-filter-sales"
                                        multiple
                                        value={selectedAgentsSales}
                                        onChange={(e) => {
                                            const v = e.target.value;
                                            setSelectedAgentsSales(Array.isArray(v) ? v : (v ? [v] : []));
                                            setSalesPage(0);
                                        }}
                                        renderValue={(sel) => (sel && sel.length ? sel.join(', ') : 'All')}
                                    >
                                        {handlingAgents.map(opt => (
                                            <MenuItem key={opt} value={opt} sx={{ py: 0.5, minHeight: 28 }}>
                                                <Checkbox size="small" checked={selectedAgentsSales.includes(opt)} />
                                                <ListItemText primary={opt} primaryTypographyProps={{ fontSize: 13 }} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <TextField
                                    label="חזרה מ־"
                                    type="date"
                                    size="small"
                                    value={returnFromSales}
                                    onChange={(e) => { setReturnFromSales(e.target.value); setSalesPage(0); }}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ minWidth: 140 }}
                                />
                                <TextField
                                    label="חזרה עד"
                                    type="date"
                                    size="small"
                                    value={returnToSales}
                                    onChange={(e) => { setReturnToSales(e.target.value); setSalesPage(0); }}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ minWidth: 140 }}
                                />

                                <Button size="small" onClick={() => { setSelectedAgentsSales([]); setReturnFromSales(""); setReturnToSales(""); setSalesPage(0); }}>
                                    נקה
                                </Button>
                            </Box>
                            <MaterialReactTable
                                columns={salesHierarchicalColumns}
                                data={hierarchicalCompletedData}
                                getSubRows={row => row.subRows}
                                enableExpanding
                                state={{ globalFilter }}                  // <-- add
                                onGlobalFilterChange={setGlobalFilter}
                                enableGlobalFilter
                                defaultColumn={{ enableGlobalFilter: false }}
                                autoResetPageIndex={false}
                                filterFromLeafRows={true}
                                globalFilterFields={['searchAllSales']}        // <-- search hidden leaf column
                                globalFilterFn="includesString"
                                paginateExpandedRows={false}
                                muiToolbarSearchTextFieldProps={{
                                    value: globalFilter,
                                    onChange: (e) => setGlobalFilter(e.target.value),
                                    placeholder: 'חיפוש…',
                                }}
                                getRowId={(row) =>
                                    row.SaleId ? `sale-${row.SaleId}` :
                                        row.ProjectId ? `proj-${row.CaseId}-${row.ProjectId}` :
                                            `case-${row.CaseId}`
                                }
                                positionActionsColumn="last"
                                enableRowActions={false}
                                muiTablePaperProps={{ sx: { backgroundColor: darkMode ? '#27293d' : '#ffffff' } }}

                                // same expand icon/counts style as Quotes
                                displayColumnDefOptions={{
                                    'mrt-row-expand': {
                                        size: 90,                     // fixed width for the whole cell
                                        header: '',                   // icon only header
                                        muiTableBodyCellProps: ({ row }) => {
                                            const depth = row.depth;
                                            const projectsCount = depth === 0 ? (row.original.subRows?.length || 0) : null;
                                            const salesCountProject = depth === 1 ? (row.original.subRows?.length || 0) : null;

                                            return {
                                                sx: {
                                                    px: 0,
                                                    width: 90,
                                                    minWidth: 90,
                                                },
                                                children: (
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            width: '100%',
                                                            // reserve fixed slots: [expand button][case/project/sale chip]
                                                            '& > .slot': {
                                                                flex: '0 0 auto',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                            },
                                                            // prevent layout shift on rerender
                                                            '& .expandBtn': { width: 28, justifyContent: 'center' },
                                                        }}
                                                    >
                                                        <Box className="slot expandBtn">
                                                            <IconButton
                                                                size="small"
                                                                onClick={row.getToggleExpandedHandler()}
                                                                disabled={!row.getCanExpand()}
                                                                sx={{
                                                                    p: 0.5,
                                                                    opacity: row.getCanExpand() ? 1 : 0.4,   // keep visible but dimmed
                                                                    cursor: row.getCanExpand() ? 'pointer' : 'default',
                                                                }}
                                                            >
                                                                {row.getIsExpanded()
                                                                    ? <ChevronRightIcon sx={{ transform: 'rotate(90deg)', color: '#fff' }} />
                                                                    : <ChevronRightIcon sx={{ color: '#fff' }} />}
                                                            </IconButton>
                                                        </Box>

                                                        <Box className="slot">
                                                            {depth === 0 && (
                                                                <Chip
                                                                    size="small"
                                                                    color="primary"
                                                                    label={projectsCount}
                                                                    sx={{ fontSize: 9 }}
                                                                />
                                                            )}
                                                            {depth === 1 && (
                                                                <Chip
                                                                    size="small"
                                                                    color="success"
                                                                    label={salesCountProject}
                                                                    sx={{ fontSize: 9, ml: 3 }}
                                                                />
                                                            )}
                                                            {depth === 2 && (
                                                                <Chip
                                                                    size="small"
                                                                    color="warning"
                                                                    label="מכירה"         // or מכירה for sales table
                                                                    sx={{ fontSize: 11, ml: 8 }}
                                                                />
                                                            )}
                                                        </Box>
                                                    </Box>
                                                ),
                                            };
                                        },
                                    },
                                }}

                                initialState={{ columnSizing: 20 }}

                                // reuse the same modern row styling as Quotes
                                muiTableBodyRowProps={({ row }) => {
                                    const depth = row.depth;
                                    const theme = useTheme();
                                    const isDark = darkMode;

                                    const projectAccent = theme.palette.info.main;
                                    const saleAccent = theme.palette.success.main;

                                    const projectBg = alpha(projectAccent, isDark ? 0.10 : 0.06);
                                    const projectHover = alpha(projectAccent, isDark ? 0.18 : 0.12);

                                    const saleBg = alpha(saleAccent, isDark ? 0.08 : 0.05);
                                    const saleHover = alpha(saleAccent, isDark ? 0.16 : 0.10);

                                    const baseBg = isDark ? '#1E293B' : '#ffffff';
                                    const dividerColor = alpha(theme.palette.divider, 0.18);

                                    const isProject = depth === 1;
                                    const isSale = depth >= 2;

                                    const bg = isProject ? projectBg : isSale ? saleBg : baseBg;
                                    const hoverBg = isProject ? projectHover : isSale ? saleHover : alpha(theme.palette.primary.main, isDark ? 0.10 : 0.06);
                                    const accent = isProject ? projectAccent : isSale ? saleAccent : alpha(theme.palette.primary.main, 0.4);

                                    const parentExpanded = row.getParentRow()?.getIsExpanded();
                                    const isChild = depth > 0;

                                    return {
                                        sx: {
                                            height: 80,
                                            '& td': {
                                                minHeight: 80,
                                                height: 80,
                                                py: 0,
                                                lineHeight: '44px',
                                                display: 'table-cell',
                                                backgroundColor: bg,
                                                transition: 'background-color .2s ease, box-shadow .2s ease',
                                            },
                                            borderTop: `1px solid ${dividerColor}`,
                                            '& td': { backgroundColor: bg, transition: 'background-color .2s ease, box-shadow .2s ease' },
                                            '&:hover td': { backgroundColor: hoverBg },
                                            borderLeft: isChild ? `4px solid ${accent}` : undefined,
                                            ...(isChild && {
                                                boxShadow: isDark
                                                    ? 'inset 0 1px 0 rgba(255,255,255,0.04)'
                                                    : 'inset 0 1px 0 rgba(0,0,0,0.04)',
                                            }),
                                            ...(isChild && parentExpanded && { '& td': { backgroundColor: hoverBg } }),
                                        },
                                    };
                                }}

                                muiBottomToolbarProps={{
                                    sx: {
                                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                                        color: darkMode ? '#fff' : '#1e293b',
                                        ".MuiFormLabel-root": { color: darkMode ? '#fff' : '#1e293b' },
                                        ".MuiSelect-icon": { color: darkMode ? '#fff' : '#1e293b' },
                                        ".MuiSelect-select": { color: darkMode ? '#fff' : '#1e293b' },
                                        ".MuiBox-root.MuiButtonBase-root": { color: darkMode ? '#fff' : '#1e293b' },
                                        ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                            color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                                        },
                                    }
                                }}
                                muiTopToolbarProps={{
                                    sx: {
                                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                                        color: '#fff',
                                        ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                                        ".MuiTableSortLabel-iconDirectionAsc": { color: darkMode ? '#fff' : '#1e293b' },
                                        '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                                    },
                                }}
                                muiTableHeadCellProps={{
                                    sx: {
                                        backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                                        color: "white",
                                        fontWeight: "bold",
                                        ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                                        ".Mui-TableHeadCell-Content-Wrapper": { color: darkMode ? '#fff' : '#1e293b' },
                                        '& .MuiTableSortLabel-icon': { color: darkMode ? '#fff !important' : '#000 !important' },
                                        '& .MuiTableSortLabel-iconDirectionAsc': { color: darkMode ? '#fff !important' : '#000 !important' },
                                        '& .MuiTableSortLabel-iconDirectionDesc': { color: darkMode ? '#fff !important' : '#000 !important' },
                                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                            color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                                        },
                                        '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                                    },
                                }}
                                muiTableHeadProps={{
                                    sx: {
                                        display: "table-header-group",
                                        backgroundColor: "rgb(0,0,0)",
                                        color: "white",
                                        "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
                                    },
                                }}
                                muiTableContainerProps={{
                                    ref: tableContainerRef,
                                    sx: { width: '100%', backgroundColor: 'transparent' },
                                }}
                                muiTableBodyCellProps={({ row }) => ({
                                    sx: {
                                        backgroundColor: row.depth === 0 ? (darkMode ? '#1e293b' : '#ffffff') : 'transparent',
                                        color: darkMode ? '#fff' : '#000',
                                        '.MuiSvgIcon-root': { color: darkMode ? '#fff' : '#000' },
                                        maxWidth: '80px',
                                    },
                                })}
                            />

                            {   (
                                <IconButton
                                    onClick={() => handlePage("left")}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        left: 8,
                                        top: isMobile ? '50%' : '40%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 3,
                                        boxShadow: 2,
                                        border: "1px solid rgba(255,255,255,0.25)",

                                        color: "white",                 // <- set the icon color
                                        '& .MuiSvgIcon-root, & svg': {
                                            color: `white !important`,
                                            fill: `white !important`,
                                        },
                                        backgroundColor: (t) =>
                                            t.palette.mode === "white",
                                        '&:hover': { backgroundColor: "white"},
                                        '&:active': { backgroundColor: "white" },
                                        '&:focus-visible': { outline: 'none' },
                                    }}
                                >
                                    <ChevronLeftIcon sx={{color: "#fff"}}/>
                                </IconButton>
                            )}

                            {/* Right pager */}
                            { (
                                <IconButton
                                    onClick={() => handlePage("right")}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        right: 8,
                                        top: isMobile ? '50%' : '40%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 3,
                                        boxShadow: 2,
                                        border: "1px solid rgba(255,255,255,0.25)",
                                        color: "white",                 // <- set the icon color
                                        '& .MuiSvgIcon-root, & svg': {
                                            color: `white !important`,
                                            fill: `white !important`,
                                        },
                                        backgroundColor: (t) =>
                                            t.palette.mode === "white",
                                        '&:hover': { backgroundColor: "white"},
                                        '&:active': { backgroundColor: "white" },
                                        '&:focus-visible': { outline: 'none' },
                                    }}
                                >
                                    <ChevronRightIcon />
                                </IconButton>
                            )}
                        </>
                    )}


                    <Modal open={Boolean(paymentSale)} onClose={() => {
                        setPaymentSale(null);
                        setPayments([]);
                        setNewPayment(null);
                        setEditingIdx(null);
                    }}>
                        <Box sx={{
                            position: 'absolute',
                            top: '50%', left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: paperBg,
                            color: textColor,
                            p: 3,
                            borderRadius: 2,
                            // width: 500,
                            maxHeight: '80vh',      // <-- cap height
                            overflowY: 'auto',      // <-- enable scrolling
                        }}>
                            <Typography variant="h6" mb={2}>
                                Payments – Sale&nbsp;#{paymentSale?.SaleId}
                            </Typography>

                            {loadingPayments && <CircularProgress size={30} />}

                            {!loadingPayments && (
                                <>
                                    {/* ---------- payments table ---------- */}
                                    <Table size="small">
                                        <TableHead sx={{ display: "table-header-group" }}>
                                            <TableRow>
                                                <TableCell style={{ color: textColor }}>Type</TableCell>
                                                <TableCell style={{ color: textColor }}>Date</TableCell>
                                                <TableCell style={{ color: textColor }} align="right">Amount&nbsp;(₪)</TableCell>
                                                <TableCell />
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {payments?.map((p, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell style={{ color: textColor }}>
                                                        {editingIdx === idx
                                                            ? (
                                                                <Select
                                                                    value={p.payment_type}
                                                                    onChange={(e) => {
                                                                        const v = e.target.value;
                                                                        setPayments((prev) => prev.map(
                                                                            (row, i) => i === idx
                                                                                ? {
                                                                                    ...row, payment_type: v,
                                                                                    amount: paymentSale?.TotalAmountInSale * (parseInt(v, 10) / 100)
                                                                                }
                                                                                : row
                                                                        ));
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    {SALE_TYPES_MAP[paymentSale?.LeadType]   // all allowed
                                                                        ?.map(pctLabel)
                                                                        .map((label) => (
                                                                            <MenuItem key={label} value={label}>{label}</MenuItem>
                                                                        ))}
                                                                </Select>
                                                            )
                                                            : p.payment_type}
                                                    </TableCell>

                                                    <TableCell style={{ color: textColor }}>
                                                        {editingIdx === idx
                                                            ? (
                                                                <TextField
                                                                    type="date"
                                                                    size="small"
                                                                    value={p.payment_date?.slice(0, 10)}
                                                                    onChange={(e) => {
                                                                        const v = e.target.value;
                                                                        setPayments((prev) => prev.map(
                                                                            (row, i) => i === idx ? { ...row, payment_date: v } : row
                                                                        ));
                                                                    }}
                                                                />
                                                            )
                                                            : new Date(p.payment_date).toLocaleDateString('he-IL')}
                                                    </TableCell>

                                                    <TableCell style={{ color: textColor }} align="right">
                                                        {p.amount?.toLocaleString('he-IL')}
                                                    </TableCell>

                                                    <TableCell style={{ color: textColor }}>
                                                        {editingIdx === idx ? (
                                                            <>
                                                                {/* ✕ Cancel button (revert changes) */}
                                                                <IconButton
                                                                    onClick={() => {
                                                                        // Restore the original row from backupRow:
                                                                        setPayments(prev => {
                                                                            const copy = [...prev];
                                                                            copy[idx] = backupRow;
                                                                            return copy;
                                                                        });
                                                                        setEditingIdx(null);
                                                                        setBackupRow(null);
                                                                    }}
                                                                >
                                                                    <CloseIcon style={{ color: textColor }} fontSize="small" />
                                                                </IconButton>

                                                                {/* ✓ Save button (keep changes) */}
                                                                <IconButton
                                                                    onClick={() => {
                                                                        // Commit is already “in” payments[idx], since your onChange updated it.
                                                                        // So just exit edit‐mode:
                                                                        setEditingIdx(null);
                                                                        setBackupRow(null);
                                                                    }}
                                                                >
                                                                    <CheckIcon style={{ color: textColor }} fontSize="small" />
                                                                </IconButton>
                                                            </>
                                                        ) : (
                                                            // Pencil (✎) to enter edit mode
                                                            <IconButton
                                                                onClick={() => {
                                                                    setBackupRow(payments[idx]); // snapshot the row before editing
                                                                    setEditingIdx(idx);
                                                                }}
                                                            >
                                                                <EditIcon style={{ color: textColor }} fontSize="small" />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            {/* ---------  new payment row  ---------- */}
                                            {newPayment && (
                                                <TableRow>
                                                    <TableCell style={{ color: textColor }}>
                                                        <Select
                                                            size="small"
                                                            value={newPayment.type}
                                                            onChange={e => setNewPayment(p => ({ ...p, type: e.target.value }))}
                                                        >
                                                            {availablePercents.map(label => (
                                                                <MenuItem key={label} value={label}>
                                                                    {label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            type="date"
                                                            size="small"
                                                            value={newPayment.date}
                                                            onChange={(e) =>
                                                                setNewPayment((prev) => ({ ...prev, date: e.target.value }))}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{ color: textColor }} align="right">
                                                        {newPayment.type
                                                            ? (paymentSale?.TotalAmountInSale *
                                                                (parseInt(newPayment.type, 10) / 100)).toLocaleString('he-IL')
                                                            : ''}
                                                    </TableCell>
                                                    <TableCell>
                                                        <IconButton style={{ color: textColor }} onClick={() => setNewPayment(null)}>
                                                            <CloseIcon style={{ color: textColor }} fontSize="small" />
                                                        </IconButton>
                                                        <IconButton onClick={() => {
                                                            setPayments(prev => [
                                                                ...prev,
                                                                {
                                                                    payment_type: newPayment.type,
                                                                    payment_date: newPayment.date,
                                                                    amount: paymentSale.TotalAmountInSale * (parseInt(newPayment.type, 10) / 100)
                                                                }
                                                            ]);
                                                            // start a fresh new row
                                                            setNewPayment(null);
                                                        }}>
                                                            <CheckIcon style={{ color: textColor }} fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>

                                    {/* ---------- actions ---------- */}
                                    <Box mt={2} display="flex" justifyContent="space-between">
                                        {(() => {
                                            const type = paymentSale?.LeadType;
                                            if (!type) return null;

                                            // How many rows are allowed:
                                            const maxCount =
                                                type === 'מכירה'
                                                    ? 3
                                                    : type === 'ליסינג'
                                                        ? 26
                                                        : 0;

                                            // If we haven’t yet hit the max *and* we’re not currently editing a new row:
                                            if (payments.length < maxCount && !newPayment) {
                                                return (
                                                    <Button
                                                        onClick={() =>
                                                            setNewPayment({
                                                                type: '',
                                                                date: new Date().toISOString().slice(0, 10),
                                                            })
                                                        }
                                                    >
                                                        + Add Payment
                                                    </Button>
                                                );
                                            }
                                            return null;
                                        })()}

                                        <Box ml="auto">
                                            <Button onClick={() => setPaymentSale(null)} sx={{ mr: 1 }}>
                                                Cancel
                                            </Button>

                                            {/* Save button will be conditionally disabled (see next section) */}
                                            <Button
                                                variant="contained"
                                                disabled={
                                                    loadingPayments ||
                                                    !isPaymentSetValid() /* see validation helper below */
                                                }
                                                onClick={handleSaveAll}
                                            >
                                                Save
                                            </Button>
                                        </Box>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Modal>

                    <Modal
                        open={showCallHistoryModal}
                        onClose={() => setShowCallHistoryModal(false)}
                    >
                        <Box sx={{
                            position: 'absolute', top: '50%', left: '50%',
                            transform: 'translate(-50%,-50%)',
                            bgcolor: paperBg, color: textColor, p: 3, borderRadius: 2,
                            maxHeight: '80vh', overflowY: 'auto', width: 600
                        }}>
                            <Typography variant="h6" mb={2}>
                                Call History for Lead #{selectedLeadForCalls?.id}
                            </Typography>
                            <Table size="small">
                                <TableHead sx={{
                                    display: "table-header-group",
                                }}>
                                    <TableRow >
                                        <TableCell sx={{ color: textColor }}>Talked With</TableCell>
                                        <TableCell sx={{ color: textColor }}>Call Date</TableCell>
                                        <TableCell sx={{ color: textColor }}>Return Date</TableCell>
                                        <TableCell sx={{ color: textColor }}>Notes</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {callHistoryList.map((ch) => (
                                        <TableRow key={ch.id}>
                                            <TableCell sx={{ color: textColor }}>{ch.talked_with}</TableCell>
                                            <TableCell sx={{ color: textColor }}>
                                                {ch.call_date
                                                    ? new Date(ch.call_date).toLocaleString('en-GB', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    })
                                                    : ''}
                                            </TableCell>
                                            <TableCell sx={{ color: textColor }}>
                                                {ch.return_date
                                                    ? new Date(ch.return_date).toLocaleString('en-GB', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    })
                                                    : ''}
                                            </TableCell>
                                            <TableCell sx={{ color: textColor }}>{ch.notes}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <Box mt={2} textAlign="right">
                                <Button onClick={() => setShowCallHistoryModal(false)}>
                                    Close
                                </Button>
                            </Box>
                        </Box>
                    </Modal>



                    <Modal open={showEditSaleModal} onClose={() => setShowEditSaleModal(false)}>
                    <Box
                        sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: paperBg,
                        color: textColor,
                        p: { xs: 2, md: 4 },
                        borderRadius: 3,
                        width: { xs: '98vw', md: '90vw' },
                        maxWidth: 1800,
                        maxHeight: '98vh',
                        boxShadow: 8,
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        }}
                    >
                        {/* Sticky Header */}
                        <Box sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                        bgcolor: paperBg,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        pb: 1,
                        borderBottom: `1px solid ${textColor}22`,
                        }}>
                        <Typography variant="h6" fontWeight={700}>
                            עריכת מכירה #{editSaleFormData?.SaleId}
                        </Typography>
                        <IconButton onClick={() => setShowEditSaleModal(false)} sx={{ color: textColor }}>
                            <CloseIcon />
                        </IconButton>
                        </Box>

                        {editSaleFormData && (
                        <Box component="form" onSubmit={handleEditSaleSubmit} sx={{ mt: 2 }}>
                            <Grid container spacing={3}>
                            {/* --- Left Column: Sale & Company --- */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3 }}>
                                {/* Sale Details */}
                                <Box sx={{ flex: 1 }}>
                                    <Typography variant="subtitle1" fontWeight={600} mb={1}>פרטי מכירה</Typography>
                                    <Divider sx={{ mb: 2 }} />
                                    <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small">
                                        <InputLabel id="hotness-label">עדיפות</InputLabel>
                                        <Select
                                            labelId="hotness-label"
                                            label="Priority"
                                            name="Hotness"
                                            sx={{ height: 44 }}
                                            value={editSaleFormData.Hotness ?? 0}
                                            onChange={e => setEditSaleFormData(prev => ({ ...prev, Hotness: Number(e.target.value) }))}
                                        >
                                            <MenuItem value={2}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[2].color }} />{HOT_MAP[2].label}</Box></MenuItem>
                                            <MenuItem value={1}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[1].color }} />{HOT_MAP[1].label}</Box></MenuItem>
                                            <MenuItem value={0}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[0].color }} />{HOT_MAP[0].label}</Box></MenuItem>
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth margin="normal">
                                        <InputLabel id="edit-sale-leadtype-label">סוג ליד</InputLabel>
                                        <Select
                                            labelId="edit-sale-leadtype-label"
                                            label="Lead Type"
                                            name="LeadType"
                                            sx={{ height: 44 }}
                                            value={editSaleFormData.LeadType}
                                            onChange={handleEditSaleFormChange}
                                        >
                                            <MenuItem value="מכירה">מכירה</MenuItem>
                                            <MenuItem value="ליסינג">ליסינג</MenuItem>
                                            <MenuItem value="ענן ותקשורת">ענן ותקשורת</MenuItem>
                                            <MenuItem value="חכירה">חכירה</MenuItem>
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField label="נתיב" name="Lanes" type="number" inputProps={{ min: 1 }} value={editSaleFormData.Lanes} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField label="ליסינג חודשי" name="MonthlyAmountLeasing" type="number" value={editSaleFormData.MonthlyAmountLeasing} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField label="תאריך הצעה" name="QuoteDate" type="date" value={editSaleFormData.QuoteDate} onChange={handleEditSaleFormChange} InputLabelProps={{ shrink: true }} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField label="תאריך מכירה" name="SaleDate" type="date" value={editSaleFormData.SaleDate} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                                                        <Grid item xs={12}>
                                        <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={editSaleFormData.ExcludeFromStats === true || editSaleFormData.ExcludeFromStats === 1}
                                            onChange={e =>
                                                setEditSaleFormData(prev => ({
                                                ...prev,
                                                ExcludeFromStats: e.target.checked ? 1 : 0
                                                }))
                                            }
                                            sx={{
                                                color: textColor,
                                                '&.Mui-checked': { color: 'primary.main' },
                                            }}
                                            />
                                        }
                                        label="אל תכלול בדוחות כספיים"
                                        sx={{
                                            color: textColor,
                                            '& .MuiFormControlLabel-label': { fontSize: '0.95rem' }
                                        }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="h6" mb={1}>פריטי הצעת מחיר</Typography>
                                        {editSaleFormData.items.map((item, idx) => (
                                        <Grid container spacing={1} key={idx} alignItems="center" sx={{ mb: 1 }}>
                                            <Grid item xs={4}>
                                            <TextField label="Item #" value={item.itemNumber} onChange={e => handleEditItemChange(idx, 'itemNumber', e.target.value)} fullWidth size="small" variant="outlined" />
                                            </Grid>
                                            <Grid item xs={4}>
                                            <TextField label="Name" value={item.itemName} onChange={e => handleEditItemChange(idx, 'itemName', e.target.value)} fullWidth size="small" variant="outlined" />
                                            </Grid>
                                            <Grid item xs={2}>
                                            <TextField label="Qty" type="number" value={item.quantity} sx={{ width: "60px" }} onChange={e => handleEditItemChange(idx, 'quantity', +e.target.value)} fullWidth size="small" variant="outlined" />
                                            </Grid>
                                            <Grid item xs={2}>
                                            <Tooltip title="הסר פריט" arrow>
                                                <IconButton onClick={() => handleEditRemoveItem(idx)}>
                                                <CloseIcon sx={{ color: textColor }} />
                                                </IconButton>
                                            </Tooltip>
                                            </Grid>
                                        </Grid>
                                        ))}
                                        <Button size="small" onClick={handleEditAddItem} sx={{ mt: 1 }}>+ הוסף פריט</Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>קבצים מצורפים</Typography>
                                        <input type="file" multiple onChange={e => handleFileChangeSale(e, true)} disabled={loadingFiles} style={{ opacity: loadingFiles ? 0.5 : 1 }} />
                                        {loadingFiles && (<CircularProgress variant="indeterminate" size={30} thickness={4} sx={{ mt: 1 }} />)}
                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
                                        {editSaleFormData.attachments?.map((att, idx) => (
                                            <Box key={idx} sx={{ position: 'relative', display: 'inline-block' }}>
                                            {att.url ? (
                                                att.type?.startsWith('image/') ? (
                                                <Tooltip title="הורד תמונה" arrow>
                                                    <a href={att.url} download={att.fileName} style={{ display: 'inline-block' }}>
                                                    <img src={att.url} alt={att.fileName} style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 2 }} />
                                                    </a>
                                                </Tooltip>
                                                ) : att.type?.startsWith('video/') ? (
                                                <Tooltip title="הורד וידאו" arrow>
                                                    <a href={att.url} download={att.fileName} style={{ display: 'inline-block' }}>
                                                    <video src={att.url} style={{ width: 100, height: 100, borderRadius: 2 }} controls />
                                                    </a>
                                                </Tooltip>
                                                ) : (
                                                <Button component="a" href={att.url} download={att.fileName} variant="text" color="info">{att.fileName}</Button>
                                                )
                                            ) : null}
                                            <Tooltip title="הסר קובץ" arrow>
                                                <IconButton size="small" onClick={() => handleRemoveAttachmentFromSale(idx, false)} sx={{ position: 'absolute', top: -8, right: -8, backgroundColor: 'rgba(255,255,255,0.8)' }}>
                                                <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            </Box>
                                        ))}
                                        {editSaleFormData.newAttachments?.map((att, idx) => (
                                            <Box key={`new-${idx}`} sx={{ position: "relative", display: "inline-block" }}>
                                            {att.previewUrl && att.type?.startsWith("image") ? (
                                                <Tooltip title="הורד תמונה חדשה" arrow>
                                                <a href={att.previewUrl} download={att.name} style={{ display: "inline-block" }}>
                                                    <img src={att.previewUrl} alt={att.name} style={{ width: 100, height: 100, objectFit: "cover", cursor: "pointer", borderRadius: 2 }} />
                                                </a>
                                                </Tooltip>
                                            ) : att.previewUrl && att.type?.startsWith("video") ? (
                                                <Tooltip title="הורד וידאו חדש" arrow>
                                                <a href={att.previewUrl} download={att.name} style={{ display: "inline-block" }}>
                                                    <video src={att.previewUrl} style={{ width: 100, height: 100, cursor: "pointer", borderRadius: 2 }} controls />
                                                </a>
                                                </Tooltip>
                                            ) : (
                                                <Button component="a" href={att.previewUrl} download={att.name} variant="text" color="info">{att.name}</Button>
                                            )}
                                            <Tooltip title="הסר קובץ" arrow>
                                                <IconButton size="small" onClick={() => handleRemoveAttachment(idx, true)} sx={{ position: "absolute", top: -8, right: -8, backgroundColor: "rgba(255,255,255,0.8)", "&:hover": { backgroundColor: "rgba(255,255,255,1)" } }}>
                                                <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            </Box>
                                        ))}
                                        </Box>
                                    </Grid>
                                    </Grid>
                                </Box>
                                {/* Company & Contact */}
                                <Box sx={{ flex: 1 }}>
                                    <Typography variant="subtitle1" fontWeight={600} mb={1}>חברה ואיש קשר</Typography>
                                    <Divider sx={{ mb: 2 }} />
                                    <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth margin="normal" size="small">
                                        <InputLabel id="edit-sale-leadsource-label">מקור ליד</InputLabel>
                                        <Select
                                            labelId="edit-sale-leadsource-label"
                                            label="מקור ליד"
                                            name="LeadSource"
                                            value={editSaleFormData.LeadSource ?? ''}
                                            onChange={handleEditSaleFormChange}
                                            sx={{ height: 44 }}
                                        >
                                            {LEAD_SOURCE_OPTIONS.map((opt) => (
                                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                            ))}
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="שם פרויקט" name="ProjectName" value={editSaleFormData.ProjectName} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="סכום כולל" name="TotalAmountInSale" type="number" required={editSaleFormData.LeadType === 'מכירה'} error={editSaleFormData.LeadType === 'מכירה' && !editSaleFormData.TotalAmountInSale} value={editSaleFormData.TotalAmountInSale} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth margin="normal">
                                        <InputLabel id="edit-sale-progress-label">התקדמות</InputLabel>
                                        <Select
                                            labelId="edit-sale-progress-label"
                                            label="התקדמות"
                                            name="Progress"
                                            value={editSaleFormData.Progress ?? 30}
                                            onChange={handleEditSaleFormChange}
                                            sx={{ height: 44 }}
                                        >
                                            {PROGRESS_OPTIONS.map(opt => (
                                            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                            ))}
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="תקף עד" name="QuoteValidDate" type="date" value={editSaleFormData.QuoteValidDate} onChange={handleEditSaleFormChange} InputLabelProps={{ shrink: true }} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="שם איש קשר" name="ContactPersonName" value={editSaleFormData.ContactPersonName} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="טלפון איש קשר" name="ContactPersonPhone" value={editSaleFormData.ContactPersonPhone} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="כתובת" name="Address" value={editSaleFormData.Address} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="הערות" name="Notes" value={editSaleFormData.Notes} onChange={handleEditSaleFormChange} multiline rows={4} fullWidth margin="normal" inputProps={{ dir: 'rtl' }} variant="outlined" InputProps={{ sx: { '& .MuiInputBase-input': { textAlign: 'right' }, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }} />
                                    </Grid>
                                    </Grid>
                                </Box>
                                </Box>
                            </Grid>

                            {/* --- Right Column: Parking, Items, Comments --- */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                {/* Parking & Pricing */}
                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600} mb={1}>חניון ומחירון</Typography>
                                    <Divider sx={{ mb: 2 }} />
                                    <Grid container spacing={2}>
                                    {/* Parking Full Name and Total on same row */}
                                    <Grid item xs={8}>
                                        <TextField
                                            label="שם חניון"
                                            name="ParkingFullName"
                                            value={editSaleFormData.ParkingFullName || ''}
                                            onChange={handleEditSaleFormChange}
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label={'סה"כ חניות'}
                                            name="ParkingTotalQty"
                                            value={
                                                (parseInt(editSaleFormData.ParkingCasualQty || 0, 10) +
                                                parseInt(editSaleFormData.ParkingSubscriberQty || 0, 10) +
                                                parseInt(editSaleFormData.ParkingDisabledQty || 0, 10))
                                            }
                                            InputProps={{ readOnly: true }}
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField label="חניות מזדמנים" name="ParkingCasualQty" type="number" value={editSaleFormData.ParkingCasualQty} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField label="חניות מנויים" name="ParkingSubscriberQty" type="number" value={editSaleFormData.ParkingSubscriberQty} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField label="חניות נכים" name="ParkingDisabledQty" type="number" value={editSaleFormData.ParkingDisabledQty} onChange={handleEditSaleFormChange} fullWidth margin="normal" variant="outlined" />
                                    </Grid>



                                    <Grid item xs={6}>
                                        <FormControl fullWidth margin="normal">
                                        <InputLabel id="subscriber-pricing-label">מחירון מנויים</InputLabel>
                                        <Select
                                            labelId="subscriber-pricing-label"
                                            label="מחירון מנויים"
                                            name="SubscriberPricingRecommendation"
                                            value={editSaleFormData.SubscriberPricingRecommendation}
                                            onChange={handleEditSaleFormChange}
                                            sx={{ height: 44 }}
                                        >
                                            <MenuItem value="none">אין</MenuItem>
                                            <MenuItem value="company_decision">החלטת חברה</MenuItem>
                                            <MenuItem value="price">מחיר</MenuItem>
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth margin="normal">
                                        <InputLabel id="casual-pricing-label">מחירון מזדמנים</InputLabel>
                                        <Select
                                            labelId="casual-pricing-label"
                                            label="מחירון מזדמנים"
                                            name="CasualPricingRecommendation"
                                            value={editSaleFormData.CasualPricingRecommendation}
                                            onChange={handleEditSaleFormChange}
                                            sx={{ height: 44 }}
                                        >
                                            <MenuItem value="none">אין</MenuItem>
                                            <MenuItem value="company_decision">החלטת חברה</MenuItem>
                                            <MenuItem value="price">מחיר</MenuItem>
                                        </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* Price Inputs Row (conditionally rendered, but always in their own row) */}
                                    <Grid item xs={6}>
                                        {editSaleFormData.SubscriberPricingRecommendation === "price" && (
                                        <TextField
                                            label="מחיר מנוי"
                                            name="SubscriberRecommendedPrice"
                                            type="number"
                                            value={editSaleFormData.SubscriberRecommendedPrice}
                                            onChange={handleEditSaleFormChange}
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                        />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {editSaleFormData.CasualPricingRecommendation === "price" && (
                                        <TextField
                                            label="מחיר מזדמן"
                                            name="CasualRecommendedPrice"
                                            type="number"
                                            value={editSaleFormData.CasualRecommendedPrice}
                                            onChange={handleEditSaleFormChange}
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                        />
                                        )}
                                    </Grid>


                                    </Grid>
                                </Box>
                                {/* Items */}

                                {/* Comments */}
                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600} mb={1}>תגובות</Typography>
                                    <Divider sx={{ borderColor: 'rgba(255,255,255,0.3)' }} />
                                    <Box sx={{ p: 0, maxHeight: 220, overflowY: 'auto', pr: 0.5 }}>
                                    <CommentsList comments={saleComments} loading={saleCommentsLoading} emptyLabel="אין תגובות עדיין." />
                                    </Box>
                                    <Divider sx={{ borderColor: 'rgba(255,255,255,0.3)' }} />
                                    <Box sx={{ position: 'relative', mt: 1 }}>
                                    <TextField
                                        value={newSaleComment}
                                        onChange={handleNewSaleCommentChange}
                                        placeholder="הוסף תגובה (השתמש ב @ כדי להזכיר)..."
                                        multiline
                                        minRows={3}
                                        fullWidth
                                        size="medium"
                                        inputProps={{ dir: 'rtl' }}
                                        variant="outlined"
                                    />
                                    {mentionActive && mentionSuggestions.length > 0 && (
                                        <Box sx={{ position: 'absolute', left: 0, right: 0, zIndex: 10, mt: 0.5, bgcolor: (t) => t.palette.background.paper, border: '1px solid', borderColor: (t) => t.palette.divider, borderRadius: 1, maxHeight: 220, overflowY: 'auto', color: "#000" }}>
                                        {mentionSuggestions.map((sug, idx) => (
                                            <Box key={idx} onClick={() => insertMention(sug.email || sug.label)} sx={{ px: 1, py: 0.75, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' }, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2">{sug.label}</Typography>
                                            {sug.email && (<Typography variant="caption" sx={{ opacity: 0.8 }}>{sug.email}</Typography>)}
                                            </Box>
                                        ))}
                                        </Box>
                                    )}
                                    </Box>
                                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                                    <ReturnScheduler />
                                    <Button variant="contained" size="small" disabled={!newSaleComment.trim()} onClick={handleAddSaleComment}>הוסף תגובה</Button>
                                    </Box>
                                </Box>
                                </Box>
                            </Grid>
                            </Grid>

                            {/* Revenue Share Rules */}
                            <Box mt={4}>
                            <Typography variant="h6" mb={1}>כללי חלוקת הכנסות</Typography>
                            <Divider sx={{ mb: 2 }} />
                            {editSaleFormData.rev_share_rules?.map((pair, idx) => (
                                <Grid container spacing={1} alignItems="center" key={idx} sx={{ mb: 1 }}>
                                <Grid item xs={5}>
                                    <TextField label="Ratio (%)" value={pair.ratio} onChange={e => handleEditRevShareRuleChange(idx, "ratio", e.target.value)} fullWidth variant="outlined" />
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField label="Threshold" value={pair.threshold} onChange={e => handleEditRevShareRuleChange(idx, "threshold", e.target.value)} fullWidth variant="outlined" />
                                </Grid>
                                <Grid item xs={2}>
                                    <Tooltip title="הסר כלל" arrow>
                                    <IconButton onClick={() => handleEditRemoveRevShareRule(idx)}>
                                        <CloseIcon style={{ color: textColor }} />
                                    </IconButton>
                                    </Tooltip>
                                </Grid>
                                </Grid>
                            ))}
                            <Button size="small" onClick={handleEditAddRevShareRule}>+ הוסף כלל</Button>
                            </Box>

                            {/* Action Buttons */}
                            <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                            <Button onClick={() => setShowEditSaleModal(false)} variant="outlined" color="secondary">ביטול</Button>
                            <Button type="submit" variant="contained" color="primary" disabled={progressError}>שמירה</Button>
                            </Box>
                        </Box>
                        )}
                    </Box>
                    </Modal>


                    <Modal
                        open={confirmDelete.open}
                        onClose={() => setConfirmDelete({ open: false, event: null })}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                backgroundColor: paperBg, // use your paper background variable
                                color: textColor,         // use your text color variable
                                p: 4,
                                borderRadius: 2,
                                minWidth: 300,
                            }}
                        >
                            <Typography variant="h6" mb={2}>
                                Are you sure you want to delete this event?
                            </Typography>
                            <Box display="flex" justifyContent="center">
                                <Button
                                    variant="outlined"
                                    onClick={() => setConfirmDelete({ open: false, event: null })}
                                    sx={{ mr: 2 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ backgroundColor: "red" }}
                                    onClick={async () => {
                                        // Call your delete logic
                                        await handleDeleteEvent(confirmDelete.event);
                                        // Close the modal
                                        setConfirmDelete({ open: false, event: null });
                                    }}
                                >
                                    Delete
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                    <Modal open={showCreateSaleModal} onClose={handleCloseCreateSale}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%", left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: paperBg,
                                color: textColor,
                                p: 4,
                                borderRadius: 2,
                                width: "92vw",
                                maxWidth: 1400,
                                maxHeight: "95vh",
                                overflowY: "auto",
                            }}
                        >
                            <Typography variant="h6" mb={2}>
                                {selectedLeadId
                                    ? `#${selectedLeadId} צור הצעת מחיר עבור ליד`
                                    : 'צור הצעת מחיר (ללא ליד)'}
                            </Typography>

                            <Box component="form" onSubmit={handleCreateSaleSubmit}>
                                <Grid container spacing={2}>

                                    {/* ───── COLUMN 1 ───── */}
                                    <Grid item xs={12} md={4}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth margin="normal">
                                                    <InputLabel id="create-sale-leadtype-label">סוג ליד</InputLabel>
                                                    <Select
                                                        labelId="create-sale-leadtype-label"
                                                        label="Lead Type"
                                                        name="LeadType"
                                                        sx={{ height: 44 }}
                                                        value={saleFormData.LeadType}
                                                        onChange={handleSaleFormChange}
                                                    >
                                                        <MenuItem value="מכירה">מכירה</MenuItem>
                                                        <MenuItem value="ליסינג">ליסינג</MenuItem>
                                                        <MenuItem value="ענן ותקשורת">ענן ותקשורת</MenuItem>
                                                        <MenuItem value="חכירה">חכירה</MenuItem>

                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="נתיבים"
                                                    name="Lanes"
                                                    type="number"
                                                    inputProps={{ min: 1 }}
                                                    value={saleFormData.Lanes}
                                                    onChange={handleSaleFormChange}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="ליסינג חודשי"
                                                    name="MonthlyAmountLeasing"
                                                    type="number"
                                                    value={saleFormData.MonthlyAmountLeasing}
                                                    onChange={handleSaleFormChange}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="תאריך הצעה"
                                                    name="QuoteDate"
                                                    type="date"
                                                    value={saleFormData.QuoteDate}
                                                    onChange={handleSaleFormChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                {selectedLeadId && (
                                                    <TextField
                                                        label="שם חברה"
                                                        name="CompanyName"
                                                        value={saleFormData.CompanyName}
                                                        onChange={handleSaleFormChange}
                                                        fullWidth
                                                    />
                                                )}
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="טלפון איש קשר"
                                                    name="ContactPersonPhone"
                                                    value={saleFormData.ContactPersonPhone}
                                                    onChange={handleSaleFormChange}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="תאריך מכירה"
                                                    name="SaleDate"
                                                    type="date"
                                                    value={saleFormData.SaleDate}
                                                    onChange={handleSaleFormChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                                                    קבצים מצורפים
                                                </Typography>
                                                <input
                                                    type="file"
                                                    multiple
                                                    onChange={handleSalesFileChange}
                                                />
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                                    {saleFormData.attachments?.map((att, idx) => (
                                                        <Box key={idx} sx={{ position: 'relative' }}>
                                                            <img
                                                                src={att.previewUrl}
                                                                width={80}
                                                                height={80}
                                                                style={{ objectFit: 'cover' }}
                                                                alt="preview"
                                                            />
                                                            <IconButton
                                                                size="small"
                                                                sx={{ position: 'absolute', top: 0, right: 0 }}
                                                                onClick={() =>
                                                                    setSaleFormData(prev => {
                                                                        const a = [...prev.attachments];
                                                                        a.splice(idx, 1);
                                                                        return { ...prev, attachments: a };
                                                                    })
                                                                }
                                                            >
                                                                <CloseIcon fontSize="small" />
                                                            </IconButton>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {/* ───── COLUMN 2 ───── */}
                                    <Grid item xs={12} md={4}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth margin="normal" size="small">
                                                    <InputLabel id="create-sale-leadsource-label">מקור ליד</InputLabel>
                                                    <Select
                                                        labelId="create-sale-leadsource-label"
                                                        label="מקור ליד"
                                                        name="LeadSource"
                                                        value={saleFormData.LeadSource ?? ''}
                                                        onChange={handleSaleFormChange}
                                                        sx={{ height: 44 }}
                                                    >
                                                        {LEAD_SOURCE_OPTIONS.map((opt) => (
                                                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="שם פרויקט"
                                                    name="ProjectName"
                                                    value={saleFormData.ProjectName}
                                                    onChange={handleSaleFormChange}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="סכום כולל"
                                                    name="TotalAmountInSale"
                                                    type="number"
                                                    value={saleFormData.TotalAmountInSale}
                                                    onChange={handleSaleFormChange}
                                                    fullWidth
                                                    required={saleFormData.LeadType === "מכירה"}
                                                    error={saleFormData.LeadType === "מכירה" && !saleFormData.TotalAmountInSale}
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="create-sale-progress-label">התקדמות</InputLabel>
                                                    <Select
                                                        labelId="create-sale-progress-label"
                                                        label="התקדמות"
                                                        name="Progress"
                                                        value={saleFormData.Progress ?? 30}
                                                        onChange={handleSaleFormChange}
                                                        sx={{ height: 44 }}
                                                    >
                                                        {PROGRESS_OPTIONS.map(opt => (
                                                            <MenuItem key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="בתוקף עד"
                                                    name="QuoteValidDate"
                                                    type="date"
                                                    value={saleFormData.QuoteValidDate}
                                                    onChange={handleSaleFormChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="כתובת"
                                                    name="Address"
                                                    value={saleFormData.Address}
                                                    onChange={handleSaleFormChange}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label="הערות"
                                                    name="Notes"
                                                    value={saleFormData.Notes}
                                                    onChange={handleSaleFormChange}
                                                    fullWidth
                                                    multiline
                                                    rows={8}
                                                    inputProps={{ dir: 'rtl' }}
                                                    InputProps={{
                                                        sx: {
                                                            '& .MuiInputBase-input': { textAlign: 'right' },
                                                            // ...existing code...
                                                            "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {/* ───── COLUMN 3: Quote Items ───── */}
                                    <Grid item xs={12} md={4}>
                                        <Typography variant="h6" mb={1}>
                                            פריטי הצעת מחיר
                                        </Typography>
                                        {saleFormData.items?.map((item, idx) => (
                                            <Grid container spacing={1} alignItems="center" key={idx} sx={{ mb: 1 }}>
                                                <Grid item xs={4}>
                                                    <TextField
                                                        label="Item #"
                                                        value={item.itemNumber}
                                                        onChange={e => handleItemChange(idx, "itemNumber", e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <TextField
                                                        label="Name"
                                                        value={item.itemName}
                                                        onChange={e => handleItemChange(idx, "itemName", e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <TextField
                                                        label="Qty"
                                                        type="number"
                                                        value={item.quantity}
                                                        onChange={e => handleItemChange(idx, "quantity", +e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                                    <IconButton onClick={() => handleRemoveItem(idx)}>
                                                        <CloseIcon fontSize="small" sx={{ color: textColor }} />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        ))}

                                        <Button size="small" onClick={handleAddItem}>
                                            + הוסף פריט
                                        </Button>
                                    </Grid>
                                    <Box mt={4}>
                                        <Typography variant="h6" mb={1}>
                                            כללי חלוקת הכנסות
                                        </Typography>
                                        {saleFormData.rev_share_rules?.map((pair, idx) => (
                                            <Grid
                                                container
                                                spacing={1}
                                                alignItems="center"
                                                key={idx}
                                                sx={{ mb: 1 }}
                                            >
                                                <Grid item xs={5}>
                                                    <TextField
                                                        label="Ratio (%)"
                                                        value={pair.ratio}
                                                        onChange={(e) =>
                                                            handleCreateRevShareRuleChange(idx, "ratio", e.target.value)
                                                        }
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <TextField
                                                        label="Threshold"
                                                        value={pair.threshold}
                                                        onChange={(e) =>
                                                            handleCreateRevShareRuleChange(idx, "threshold", e.target.value)
                                                        }
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <IconButton onClick={() => handleCreateRemoveRevShareRule(idx)}>
                                                        <CloseIcon style={{ color: textColor }} />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        ))}
                                        <Button size="small" onClick={handleCreateAddRevShareRule}>
                                            + הוסף כלל
                                        </Button>
                                    </Box>
                                </Grid>

                                <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                                    <Button onClick={handleCloseCreateSale}>ביטול</Button>
                                    <Button disabled={createProgressError} type="submit" variant="contained" color="primary">
                                        הוסף הצעה
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Modal>


                    {/* ADD EVENT MODAL */}
                    <Modal open={showAddModal} onClose={handleCloseAddModal}>
                        <Box
                            sx={{
                                position: isMobile ? 'fixed' : 'absolute',
                                ...(isMobile
                                    ? {
                                        inset: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        borderRadius: 0,
                                        p: 2,
                                    }
                                    : {
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        maxWidth: 1400,        // was 1000
                                        width: '92vw',         // add wider viewport width
                                        borderRadius: 2,
                                        p: 4,
                                        overflow: 'hidden',
                                        maxHeight: '92vh',     // was 90vh
                                    }),
                                backgroundColor: paperBg,
                                color: textColor,
                                p: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                overflowY: 'auto',
                            }}
                        >
                            <Typography variant="h5" mb={2}>הוסף ליד חדש</Typography>
                            <IconButton
                                aria-label="close"
                                onClick={handleCloseAddModal}
                                sx={{ position: 'absolute', right: 8, top: 8, color: textColor }}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Box component="form" onSubmit={handleAddEventSubmit}>
                                <Grid container spacing={2}>
                                    {/* Left column */}
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={1.5}>
                                            <Typography variant="h6">פרטי ליד</Typography>

                                            <FormControl fullWidth size="small">
                                                <InputLabel id="hotness-label">עדיפות</InputLabel>
                                                <Select
                                                    labelId="hotness-label"
                                                    label="Priority"
                                                    name="hotness"
                                                    sx={{ height: 44 }}
                                                    value={formData.hotness ?? 1}
                                                    onChange={(e) => setFormData(prev => ({ ...prev, hotness: Number(e.target.value) }))}
                                                >
                                                    <MenuItem value={2}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[2].color }} />
                                                            {HOT_MAP[2].label}
                                                        </Box>
                                                    </MenuItem>
                                                    <MenuItem value={1}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[1].color }} />
                                                            {HOT_MAP[1].label}
                                                        </Box>
                                                    </MenuItem>
                                                    <MenuItem value={0}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[0].color }} />
                                                            {HOT_MAP[0].label}
                                                        </Box>
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>

                                            <TextField
                                                label="סוכן ראשוני"
                                                name="lead_agent"
                                                variant="outlined"
                                                value={formData.lead_agent}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <FormControl variant="outlined">
                                                <InputLabel sx={{ color: textColor }} id="handling-label">סוכן מטפל</InputLabel>
                                                <Select
                                                    value={formData.handling_agent || ""}
                                                    onChange={handleAddEventChange}
                                                    displayEmpty
                                                    label="Handling Agent"
                                                    InputLabelProps={{ style: { color: textColor } }}
                                                    name="handling_agent"
                                                    sx={{ height: 44 }}
                                                    id="handling-label"
                                                >
                                                    {handling_agents.map((option) => (
                                                        <MenuItem key={option} value={option}>{option}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <FormControl variant="outlined">
                                                <InputLabel sx={{ color: textColor }} id="status-add-label">סטטוס</InputLabel>
                                                <Select
                                                    labelId="status-add-label"
                                                    label="סטטוס"
                                                    name="status"
                                                    value={formData.status || ""}
                                                    onChange={handleAddEventChange}
                                                    sx={{ height: 44 }}
                                                >
                                                    {STATUS_OPTIONS.map((opt) => (
                                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <FormControl variant="outlined">
                                                <InputLabel sx={{ color: textColor }} id="qualified-label">מורשה</InputLabel>
                                                <Select
                                                    value={formData.is_qualified || ""}
                                                    onChange={handleAddEventChange}
                                                    displayEmpty
                                                    label="Is Qualified"
                                                    name="is_qualified"
                                                    sx={{ height: 44 }}
                                                    id="qualified-label"
                                                >
                                                    {["Yes", "No"].map((option) => (
                                                        <MenuItem key={option} value={option}>{option}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <TextField
                                                label="תפקיד"
                                                name="job_title"
                                                variant="outlined"
                                                value={formData.job_title}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <TextField
                                                label="הערות"
                                                name="notes"
                                                variant="outlined"
                                                value={formData.notes}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                multiline
                                                rows={8}
                                                InputLabelProps={{ style: { color: textColor } }}
                                                inputProps={{ dir: 'rtl' }}
                                                InputProps={{
                                                    sx: {
                                                        '& .MuiInputBase-input': { textAlign: 'right' },
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <FormControl fullWidth margin="normal" size="small">
                                                <InputLabel id="add-lead-source-label">מקור ליד</InputLabel>
                                                <Select
                                                    labelId="add-lead-source-label"
                                                    label="מקור ליד"
                                                    name="lead_source"
                                                    value={formData.lead_source ?? ''}
                                                    onChange={handleAddEventChange}
                                                    sx={{ height: 44 }}
                                                >
                                                    {LEAD_SOURCE_OPTIONS.map((opt) => (
                                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <TextField
                                                label="פנייה אחרונה"
                                                name="last_contact"
                                                type="date"
                                                value={formData.last_contact}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <Box>
                                                <Typography>קבצים מצורפים</Typography>
                                                <input
                                                    type="file"
                                                    multiple
                                                    onChange={handleFileChange}
                                                    disabled={loadingFiles}
                                                    style={{ opacity: loading ? 0.5 : 1 }}
                                                />
                                                {loadingFiles && (
                                                    <CircularProgress
                                                        variant="indeterminate"
                                                        disableShrink
                                                        sx={(theme) => ({
                                                            color: '#1a90ff',
                                                            animationDuration: '550ms',
                                                            [`& .${circularProgressClasses.circle}`]: { strokeLinecap: 'round' },
                                                            ...theme.applyStyles('dark', { color: '#308fe8' }),
                                                        })}
                                                        size={40}
                                                        thickness={4}
                                                    />
                                                )}
                                            </Box>
                                        </Stack>
                                    </Grid>

                                    {/* Right column */}
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={1.5}>
                                            <Typography variant="h6">פרטי חברה</Typography>

                                            <TextField
                                                label="שם חברה"
                                                name="company_name"
                                                value={formData.company_name}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <TextField
                                                label="כתובת"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <TextField
                                                label="ח”פ/ת”ז"
                                                name="company_id"
                                                value={formData.company_id}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />
                                            <TextField
                                                label="כינוי"
                                                name="nickname"
                                                value={formData.nickname}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <Typography variant="h6">פרטי חניון</Typography>

                                            <TextField
                                                label="כתובת חניון"
                                                name="parking_address"
                                                value={formData.parking_address}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />
                                            <TextField
                                                label="שם חניון"
                                                name="parking_full_name"
                                                variant="outlined"
                                                value={formData.parking_full_name}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />
                                            <TextField
                                                label="מייל חניון"
                                                name="parking_email"
                                                variant="outlined"
                                                value={formData.parking_email}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />
                                            <TextField
                                                label="טלפון חניון"
                                                name="parking_phone_number"
                                                variant="outlined"
                                                value={formData.parking_phone_number}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />
                                            <TextField
                                                label="מספר נתיבים"
                                                name="lanes_number"
                                                value={formData.lanes_number}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <Typography variant="h6">איש קשר 1</Typography>

                                            <TextField
                                                label="שם"
                                                name="full_name"
                                                variant="outlined"
                                                value={formData.full_name}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <TextField
                                                label="מייל"
                                                name="email"
                                                variant="outlined"
                                                value={formData.email}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <TextField
                                                label="מס טלפון"
                                                name="phone_number"
                                                type="tel"
                                                value={formData.phone_number}
                                                onChange={handleAddEventChange}
                                                InputLabelProps={{ shrink: true, style: { color: textColor } }}
                                                fullWidth
                                                InputProps={{
                                                    sx: {
                                                        "& input:-webkit-autofill": {
                                                            boxShadow: "0 0 0 100px #1A2035 inset",
                                                            WebkitTextFillColor: "#fff",
                                                        },
                                                        color: textColor,
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                    },
                                                }}
                                            />

                                            <Typography variant="h6">איש קשר 2</Typography>

                                            <TextField
                                                label="שם משני"
                                                name="secondary_full_name"
                                                value={formData.secondary_full_name}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                            />
                                            <TextField
                                                label="מייל משני"
                                                name="secondary_email"
                                                value={formData.secondary_email}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                            />
                                            <TextField
                                                label="טלפון משני"
                                                name="secondary_phone_number"
                                                value={formData.secondary_phone_number}
                                                onChange={handleAddEventChange}
                                                fullWidth
                                                InputLabelProps={{ style: { color: textColor } }}
                                                InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                            />


                                        </Stack>
                                    </Grid>
                                </Grid>

                                <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                    <Button variant="outlined" onClick={handleCloseAddModal}>ביטול</Button>
                                    <Button disabled={loadingFiles} type="submit" variant="contained" color="primary">ליצור</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Modal>
                    {/* VIEW DETAILS MODAL */}

                    <Dialog
                        fullScreen={isMobile}
                        fullWidth
                        maxWidth="xl"                 // was "md"
                        scroll="paper"                // let content scroll within the dialog
                        TransitionComponent={Transition}
                        PaperProps={{
                            sx: {
                                borderRadius: isMobile ? 0 : 2,
                                backgroundColor: paperBg,
                                color: textColor,
                                width: { xs: '100vw', md: '92vw' },   // wider on desktop
                                maxWidth: 1600,                       // larger cap
                                height: { xs: '100vh', md: '92vh' },  // taller on desktop
                                maxHeight: '92vh',
                                display: 'flex',
                                flexDirection: 'column',
                            },
                        }}
                        open={showEditModal}
                        onClose={() => { setShowEditModal(false); setEditFormData(null); }}
                    >
                        <AppBar position="sticky" color="default" elevation={0} sx={{
                            backgroundColor: paperBg,  // use your paper background variable
                            color: textColor,
                        }}>
                            <Toolbar>
                                <Typography variant="h6" sx={{ flex: 1 }}>עריכת ליד</Typography>
                                <IconButton sx={{ color: textColor }} edge="end" onClick={() => { setShowEditModal(false); setEditFormData(null); }}>
                                    <CloseIcon htmlColor={textColor} />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        {editFormData && (
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        {/* Left Column: Basic Details */}
                                        {/*<Grid item xs={6} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>*/}
                                        <Typography variant="h6" sx={{ mt: 1 }}>פרטי ליד</Typography>
                                        <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                            <InputLabel id="hotness-label">עדיפות</InputLabel>
                                            <Select
                                                labelId="hotness-label"
                                                label="עדיפות"
                                                name="hotness"
                                                sx={{ height: 44 }}
                                                value={editFormData.hotness ?? 0}
                                                onChange={(e) => setEditFormData(prev => ({ ...prev, hotness: Number(e.target.value) }))}
                                            >
                                                <MenuItem value={2}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[2].color }} />
                                                        {HOT_MAP[2].label}
                                                    </Box>
                                                </MenuItem>
                                                <MenuItem value={1}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[1].color }} />
                                                        {HOT_MAP[1].label}
                                                    </Box>
                                                </MenuItem>
                                                <MenuItem value={0}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: HOT_MAP[0].color }} />
                                                        {HOT_MAP[0].label}
                                                    </Box>
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            label="סוכן ראשוני"
                                            name="lead_agent"
                                            variant="outlined"
                                            value={editFormData.lead_agent}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    "& input:-webkit-autofill": {
                                                        boxShadow: "0 0 0 100px #1A2035 inset",
                                                        WebkitTextFillColor: "#fff",
                                                    },
                                                    gap: 2,
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <FormControl variant="outlined">
                                            <InputLabel
                                                fullWidth
                                                sx={{
                                                    color: textColor,                     // default color
                                                }}
                                                id="event-type-label"
                                            >
                                                סוכן מטפל
                                            </InputLabel>
                                            <Select
                                                value={editFormData.handling_agent || ""}
                                                onChange={handleEditFormChange}
                                                displayEmpty
                                                label="Handling Agent"
                                                InputLabelProps={{ style: { color: textColor } }}
                                                name="handling_agent"
                                                style={{ textAlign: "left" }}
                                                sx={{ height: 44 }}
                                                id="event-type-select"
                                            >
                                                {handling_agents.map((option) => (
                                                    <MenuItem
                                                        key={option}
                                                        value={option} // Storing the entire object
                                                    >
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <FormControl variant="outlined">
                                            <InputLabel
                                                fullWidth
                                                sx={{ color: textColor }}
                                                id="status-add-label"
                                            >
                                                סטטוס
                                            </InputLabel>
                                            <Select
                                                labelId="status-add-label"
                                                label="סטטוס"
                                                name="status"
                                                value={editFormData.status || ""}
                                                onChange={handleEditFormChange}
                                                style={{ textAlign: "left" }}
                                                sx={{ height: 44 }}
                                                id="status-add-select"
                                            >
                                                {STATUS_OPTIONS.map((opt) => (
                                                    <MenuItem key={opt} value={opt}>
                                                        {opt}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl variant="outlined">
                                            <InputLabel
                                                fullWidth
                                                sx={{
                                                    color: textColor,                     // default color
                                                }}
                                                id="event-type-label"
                                            >
                                                מורשה
                                            </InputLabel>
                                            <Select
                                                value={editFormData.is_qualified || ""}
                                                onChange={handleEditFormChange}
                                                displayEmpty
                                                label="Is Qualified"
                                                name="is_qualified"
                                                style={{ textAlign: "left" }}
                                                sx={{ height: 44 }}
                                                id="event-type-select"
                                            >
                                                {["Yes", "No"].map((option) => (
                                                    <MenuItem
                                                        key={option}
                                                        value={option} // Storing the entire object
                                                    >
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            label="תפקיד"
                                            name="job_title"
                                            // type="datetime-local"
                                            // required
                                            value={editFormData.job_title || ""}
                                            onChange={handleEditFormChange}
                                            sx={{ mt: 2 }}
                                            InputLabelProps={{ shrink: true, style: { color: textColor } }}
                                            fullWidth
                                            InputProps={{
                                                sx: {
                                                    "& input:-webkit-autofill": {
                                                        boxShadow: "0 0 0 100px #1A2035 inset",
                                                        WebkitTextFillColor: "#fff",
                                                    },
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />

                                        <TextField
                                            label="הערות"
                                            name="notes"
                                            multiline
                                            rows={8}
                                            // required
                                            value={editFormData.notes || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            inputProps={{ dir: 'rtl' }}
                                            InputProps={{
                                                sx: {
                                                    '& .MuiInputBase-input': { textAlign: 'right' },
                                                    // ...existing code...
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <FormControl fullWidth margin="normal" size="small" sx={{ mt: 2 }}>
                                            <InputLabel id="edit-lead-source-label">מקור ליד</InputLabel>
                                            <Select
                                                labelId="edit-lead-source-label"
                                                label="מקור ליד"
                                                name="lead_source"
                                                value={editFormData.lead_source ?? ''}
                                                onChange={handleEditFormChange}
                                                sx={{ height: 44 }}
                                            >
                                                {LEAD_SOURCE_OPTIONS.map((opt) => (
                                                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            label="יצירת קשר אחרונה"
                                            name="last_contact"
                                            type="date"
                                            value={editFormData.last_contact}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />

                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                                                קבצים מצורפים
                                            </Typography>

                                            {/* If you want to allow re-uploading or adding more files */}
                                            <input
                                                type="file"
                                                multiple
                                                onChange={(e) => handleFileChange(e, true)}
                                                disabled={loadingFiles}
                                                style={{ opacity: loading ? 0.5 : 1 }}
                                            />

                                            {loadingFiles && (
                                                <CircularProgress
                                                    variant="indeterminate"
                                                    disableShrink
                                                    sx={(theme) => ({
                                                        color: '#1a90ff',
                                                        animationDuration: '550ms',
                                                        // display: "flex",
                                                        // justifyContent: "center",
                                                        // alignItems: "center",
                                                        // left: 0,
                                                        [`& .${circularProgressClasses.circle}`]: {
                                                            strokeLinecap: 'round',
                                                        },
                                                        ...theme.applyStyles('dark', {
                                                            color: '#308fe8',
                                                        }),
                                                    })}
                                                    size={40}
                                                    thickness={4}
                                                />
                                            )}

                                            {/* Display existing attachments */}
                                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
                                                {/* Render existing attachments */}
                                                {editFormData.attachments?.map((att, idx) => (
                                                    <Box key={`existing-${idx}`} sx={{ position: "relative", display: "inline-block" }}>
                                                        {att.url && att.type?.startsWith("image") ? (
                                                            <a href={att.url} download={att.fileName} style={{ display: "inline-block", cursor: "pointer" }}>
                                                                <img
                                                                    src={att.url}
                                                                    alt={att.fileName}
                                                                    style={{ width: 100, height: 100, objectFit: "cover" }}
                                                                />
                                                            </a>
                                                        ) : att.url && att.type?.startsWith("video") ? (
                                                            <a href={att.url} download={att.fileName} style={{ display: "inline-block", cursor: "pointer" }}>
                                                                <video
                                                                    src={att.url}
                                                                    style={{ width: 100, height: 100 }}
                                                                    controls
                                                                />
                                                            </a>
                                                        ) : (
                                                            <Button
                                                                component="a"
                                                                href={att.url}
                                                                download={att.fileName}
                                                                variant="text"
                                                                color="info"
                                                            >
                                                                {att.fileName}
                                                            </Button>
                                                        )}

                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleRemoveAttachment(idx, false)}
                                                            sx={{
                                                                position: "absolute",
                                                                top: -8,
                                                                right: -8,
                                                                backgroundColor: "rgba(255,255,255,0.8)",
                                                                "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                ))}

                                                {/* Render new attachments if any, with separate index handling */}
                                                {editFormData.newAttachments?.map((att, idx) => (
                                                    <Box
                                                        key={`new-${idx}`}
                                                        sx={{ position: "relative", display: "inline-block" }}
                                                    >
                                                        {att.previewUrl && att.type?.startsWith("image") ? (
                                                            <a
                                                                href={att.previewUrl}
                                                                download={att.name}
                                                                style={{ display: "inline-block", cursor: "pointer" }}
                                                            >
                                                                <img
                                                                    src={att.previewUrl}
                                                                    alt={att.name}
                                                                    style={{ width: 100, height: 100, objectFit: "cover" }}
                                                                />
                                                            </a>
                                                        ) : att.previewUrl && att.type?.startsWith("video") ? (
                                                            <a
                                                                href={att.previewUrl}
                                                                download={att.name}
                                                                style={{ display: "inline-block", cursor: "pointer" }}
                                                            >
                                                                <video
                                                                    src={att.previewUrl}
                                                                    style={{ width: 100, height: 100 }}
                                                                    controls
                                                                />
                                                            </a>
                                                        ) : (
                                                            <Button
                                                                component="a"
                                                                href={att.previewUrl}
                                                                download={att.name}
                                                                variant="text"
                                                                color="info"
                                                            >
                                                                {att.name}
                                                            </Button>
                                                        )}

                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleRemoveAttachment(idx, true)}
                                                            sx={{
                                                                position: "absolute",
                                                                top: -8,
                                                                right: -8,
                                                                backgroundColor: "rgba(255,255,255,0.8)",
                                                                "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                ))}


                                            </Box>
                                        </Grid>
                                    </Grid>

                                    {/* Right Column: Descriptions */}
                                    <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>


                                        <Typography variant="h6" sx={{ mt: 1 }}>פרטי חברה</Typography>
                                        <TextField
                                            label="שם חברה"
                                            name="company_name"
                                            value={editFormData.company_name}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    // mt: 2,
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <TextField
                                            label="כתובת"
                                            name="address"
                                            value={editFormData.address}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    // mt: 2,
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <TextField
                                            label="ח”פ/ת”ז "
                                            name="company_id"
                                            value={editFormData.company_id}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            sx={{ mt: 2 }}
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    // mt: 2,
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />

                                        <TextField
                                            label="כינוי"
                                            name="nickname"
                                            value={editFormData.nickname || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />

                                        <Typography variant="h6" sx={{ mt: 1 }}>פרטי חניון</Typography>
                                        <TextField
                                            label="כתובת חניון"
                                            name="parking_address"
                                            value={editFormData.parking_address || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                        />
                                        <TextField
                                            label="שם חניון"
                                            name="parking_full_name"
                                            value={editFormData.parking_full_name || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                        />
                                        <TextField
                                            label="מייל חניון"
                                            name="parking_email"
                                            value={editFormData.parking_email || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                        />
                                        <TextField
                                            label="טלפון חניון"
                                            name="parking_phone_number"
                                            value={editFormData.parking_phone_number || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                        />
                                        <TextField
                                            label="מספר נתיבים"
                                            name="lanes_number"
                                            value={editFormData.lanes_number}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    // mt: 2,
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <Typography variant="h6" sx={{ mt: 1 }}>איש קשר 1  </Typography>
                                        <TextField
                                            label="שם"
                                            name="full_name"
                                            variant="outlined"
                                            // required
                                            value={editFormData.full_name || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    "& input:-webkit-autofill": {
                                                        boxShadow: "0 0 0 100px #1A2035 inset",
                                                        WebkitTextFillColor: "#fff",
                                                    },
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <TextField
                                            label="מייל"
                                            name="email"
                                            variant="outlined"
                                            // type="email"
                                            value={editFormData.email || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    "& input:-webkit-autofill": {
                                                        boxShadow: "0 0 0 100px #1A2035 inset",
                                                        WebkitTextFillColor: "#fff",
                                                    },
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <TextField
                                            label="טלפון"
                                            name="phone_number"
                                            variant="outlined"
                                            type="tel"
                                            value={editFormData.phone_number || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                sx: {
                                                    "& input:-webkit-autofill": {
                                                        boxShadow: "0 0 0 100px #1A2035 inset",
                                                        WebkitTextFillColor: "#fff",
                                                    },
                                                    color: textColor,
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                },
                                            }}
                                        />
                                        <Typography variant="h6" sx={{ mt: 1 }}>איש קשר 2  </Typography>
                                        <TextField
                                            label="שם משני"
                                            name="secondary_full_name"
                                            value={editFormData.secondary_full_name || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                        />
                                        <TextField
                                            label="מייל משני"
                                            name="secondary_email"
                                            value={editFormData.secondary_email || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                        />
                                        <TextField
                                            label="טלפון משני"
                                            name="secondary_phone_number"
                                            value={editFormData.secondary_phone_number || ""}
                                            onChange={handleEditFormChange}
                                            fullWidth
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                        />


                                    </Grid>

                                    <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        <Typography variant="h6" >תגובות ליד</Typography>
                                        <Divider sx={{ borderColor: 'rgba(255,255,255,0.3)' }} />
                                        <Box
                                            sx={{
                                                p: 0,
                                                maxHeight: 360,              // adjust height
                                                overflowY: 'auto',
                                                pr: 0.5,
                                                '&::-webkit-scrollbar': { width: 6 },
                                                '&::-webkit-scrollbar-track': { background: 'transparent' },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#bbb',
                                                    borderRadius: 3,
                                                },
                                                '&:hover::-webkit-scrollbar-thumb': {
                                                    background: '#999',
                                                },
                                            }}
                                        >
                                            <CommentsList
                                                comments={leadComments}
                                                loading={leadCommentsLoading}
                                                emptyLabel="אין תגובות עדיין."
                                            />
                                        </Box>
                                        <Divider sx={{ borderColor: 'rgba(255,255,255,0.3)' }} />
                                        <Box sx={{ position: 'relative' }}>
                                            <TextField
                                                value={newLeadComment}
                                                onChange={handleNewLeadCommentChange}
                                                placeholder="הוסף תגובה (השתמש ב @ כדי להזכיר)..."
                                                multiline
                                                minRows={5}
                                                fullWidth
                                                size="medium"
                                                inputProps={{ dir: 'rtl' }}
                                                InputProps={{
                                                    sx: {
                                                        minHeight: 140,
                                                        fontSize: 16,
                                                        lineHeight: 1.6,
                                                    },
                                                }}
                                            />
                                            {mentionActive && mentionSuggestions.length > 0 && (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        left: 0,
                                                        right: 0,
                                                        zIndex: 10,
                                                        mt: 0.5,
                                                        bgcolor: (t) => t.palette.background.paper,
                                                        border: '1px solid',
                                                        borderColor: (t) => t.palette.divider,
                                                        borderRadius: 1,
                                                        maxHeight: 220,
                                                        overflowY: 'auto',
                                                        color: "#000"
                                                    }}
                                                >
                                                    {mentionSuggestions.map((sug, idx) => (
                                                        <Box
                                                            key={idx}
                                                            onClick={() => insertLeadMention(sug.email || sug.label)}
                                                            sx={{
                                                                px: 1, py: 0.75, cursor: 'pointer',
                                                                '&:hover': { bgcolor: 'action.hover' },
                                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                                            }}
                                                        >
                                                            <Typography variant="body2">{sug.label}</Typography>
                                                            {sug.email && (
                                                                <Typography variant="caption" sx={{ opacity: 0.8 }}>{sug.email}</Typography>
                                                            )}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            )}

                                        </Box>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                        >
                                            <ReturnScheduler />
                                            <Button
                                                variant="contained"
                                                size="small"
                                                disabled={!newLeadComment.trim()}
                                                onClick={handleAddLeadComment}
                                            >
                                                Add
                                            </Button>
                                        </Box>


                                    </Grid>
                                </Grid>
                            </DialogContent>

                        )}
                        <DialogActions
                            sx={{
                                px: 2,
                                py: 1.5,
                                position: 'sticky',
                                bottom: 0,
                                bgcolor: 'background.paper',
                                pb: `calc(12px + env(safe-area-inset-bottom))`, // iOS safe area
                                backgroundColor: paperBg,  // use your paper background variable
                                color: textColor,
                            }}
                        >
                            <Button variant="outlined" onClick={() => { setShowEditModal(false); setEditFormData(null); }}>
                                ביטול
                            </Button>
                            <Button type="submit" variant="contained" color="primary" onClick={handleEditEventSubmit}>
                                שמירה
                            </Button>

                        </DialogActions>
                    </Dialog>


                    <Modal open={showMediaModal} onClose={handleCloseMediaModal}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                backgroundColor: paperBg,
                                color: textColor,
                                p: 2,
                                borderRadius: 2,
                                width: "80%",
                                maxWidth: 800,
                                maxHeight: '90vh',     // ← cap its height at 90% of viewport
                                overflowY: 'auto',     // ← enable vertical scrolling
                                textAlign: "center",
                            }}
                        >
                            {mediaPreview.type?.includes("image") && (
                                <img
                                    src={mediaPreview.url}
                                    alt="Preview"
                                    style={{ maxWidth: "100%", maxHeight: "80vh" }}
                                />
                            )}

                            {mediaPreview.type?.includes("video") && (
                                <video
                                    src={mediaPreview.url}
                                    controls
                                    style={{ maxWidth: "100%", maxHeight: "80vh" }}
                                />
                            )}

                            <Box mt={2}>
                                <Button onClick={handleCloseMediaModal} variant="contained" color="secondary">
                                    Close
                                </Button>
                            </Box>
                        </Box>
                    </Modal>

                    <Modal open={showCreateCaseModal} onClose={() => setShowCreateCaseModal(false)}>
                        <Box
                            sx={{
                                position: "absolute", top: "50%", left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: paperBg, color: textColor, p: 3, borderRadius: 2,
                                width: "80vw", maxWidth: 800, maxHeight: "85vh", overflowY: "auto"
                            }}
                        >
                            <Typography variant="h6" mb={2}>יצירת תיק לקוח</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="שם תיק" name="CaseName" value={createCaseForm.CaseName}
                                        onChange={handleCreateCaseChange} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="שם חברה" name="CompanyName" value={createCaseForm.CompanyName}
                                        onChange={handleCreateCaseChange} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="כינוי" name="Nickname" value={createCaseForm.Nickname}
                                        onChange={handleCreateCaseChange} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="כתובת" name="Address" value={createCaseForm.Address}
                                        onChange={handleCreateCaseChange} fullWidth />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField label="איש קשר" name="ContactPersonName" value={createCaseForm.ContactPersonName}
                                        onChange={handleCreateCaseChange} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="טלפון איש קשר" name="ContactPersonPhone" value={createCaseForm.ContactPersonPhone}
                                        onChange={handleCreateCaseChange} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="אימייל איש קשר" name="ContactEmail" value={createCaseForm.ContactEmail}
                                        onChange={handleCreateCaseChange} fullWidth />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField label="איש קשר משני" name="SecondaryContactPersonName"
                                        value={createCaseForm.SecondaryContactPersonName} onChange={handleCreateCaseChange} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="טלפון איש קשר משני" name="SecondaryContactPersonPhone"
                                        value={createCaseForm.SecondaryContactPersonPhone} onChange={handleCreateCaseChange} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="אימייל איש קשר משני" name="SecondaryContactEmail"
                                        value={createCaseForm.SecondaryContactEmail} onChange={handleCreateCaseChange} fullWidth />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField label="תיאור תיק" name="CaseDescription" value={createCaseForm.CaseDescription}
                                        onChange={handleCreateCaseChange} fullWidth multiline rows={4} />
                                </Grid>
                            </Grid>

                            <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
                                <Button onClick={() => setShowCreateCaseModal(false)}>ביטול</Button>
                                <Button variant="contained" onClick={handleSubmitCreateCase}>צור תיק</Button>
                            </Box>
                        </Box>
                    </Modal>

                    {/* Create Project Modal */}
                    <Modal open={showCreateProjectModal} onClose={() => setShowCreateProjectModal(false)}>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%', left: '50%',
                                transform: 'translate(-50%, -50%)',
                                bgcolor: paperBg,
                                color: textColor,
                                p: 3,
                                borderRadius: 2,
                                width: '80vw',
                                maxWidth: 700,
                                direction: 'rtl',
                                textAlign: 'right',
                            }}
                        >
                            <Typography variant="h6" mb={2}>צור פרויקט</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label="שם פרויקט"
                                        name="ProjectName"
                                        value={createProjectForm.ProjectName}
                                        onChange={handleCreateProjectChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="שם חניון"
                                        name="ParkingFullName"
                                        value={createProjectForm.ParkingFullName}
                                        onChange={handleCreateProjectChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="מייל חניון"
                                        name="ParkingEmail"
                                        value={createProjectForm.ParkingEmail}
                                        onChange={handleCreateProjectChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="כתובת חניון"
                                        name="ParkingAddress"
                                        value={createProjectForm.ParkingAddress}
                                        onChange={handleCreateProjectChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="טלפון חניון"
                                        name="ParkingPhoneNumber"
                                        value={createProjectForm.ParkingPhoneNumber}
                                        onChange={handleCreateProjectChange}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>

                            <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
                                <Button onClick={() => setShowCreateProjectModal(false)}>ביטול</Button>
                                <Button variant="contained" onClick={handleSubmitCreateProject}>צור פרויקט</Button>
                            </Box>
                        </Box>
                    </Modal>

                    {/* // ─── Edit Case Modal ─── */}
                    <Modal open={showEditCaseModal} onClose={() => setShowEditCaseModal(false)}>
                        <Box sx={{
                            position: 'absolute', top: '50%', left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: paperBg, color: textColor, p: 3, borderRadius: 2,
                            width: '80vw', maxWidth: 800, maxHeight: '85vh', overflowY: 'auto'
                        }}>
                            <Typography variant="h6" mb={2}>עריכת תיק</Typography>
                            {editCaseForm && (
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="שם תיק" name="CaseName" value={editCaseForm.CaseName} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="שם חברה" name="CompanyName" value={editCaseForm.CompanyName} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="כינוי" name="Nickname" value={editCaseForm.Nickname} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="כתובת" name="Address" value={editCaseForm.Address} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="איש קשר" name="ContactPersonName" value={editCaseForm.ContactPersonName} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="טלפון איש קשר" name="ContactPersonPhone" value={editCaseForm.ContactPersonPhone} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="אימייל איש קשר" name="ContactEmail" value={editCaseForm.ContactEmail} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="איש קשר משני" name="SecondaryContactPersonName" value={editCaseForm.SecondaryContactPersonName} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="טלפון איש קשר משני" name="SecondaryContactPersonPhone" value={editCaseForm.SecondaryContactPersonPhone} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField label="אימייל איש קשר משני" name="SecondaryContactEmail" value={editCaseForm.SecondaryContactEmail} onChange={handleEditCaseChange} fullWidth />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="flex-end" gap={1}>
                                            <Button onClick={() => setShowEditCaseModal(false)}>ביטול</Button>
                                            <Button variant="contained" onClick={handleSubmitEditCase}>שמירה</Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}
                        </Box>
                    </Modal>

                    {/* // ─── Edit Project Modal ─── */}
                    <Modal open={showEditProjectModal} onClose={() => setShowEditProjectModal(false)}>
                    <Box
                        sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: paperBg,
                        color: textColor,
                        p: { xs: 2, md: 4 },
                        borderRadius: 2,
                        width: { xs: '98vw', md: 800 },
                        maxWidth: 800,
                        maxHeight: '98vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        direction: 'rtl',
                        textAlign: 'right',
                        }}
                    >
                        <Typography variant="h6" mb={2}>עריכת פרויקט</Typography>
                        {editProjectForm && (
                        <Box component="form" onSubmit={e => { e.preventDefault(); handleSubmitEditProject(); }}>
                            <Grid container spacing={3}>
                            {/* --- Project Info --- */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" fontWeight={600} mb={1}>פרטי פרויקט</Typography>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="שם פרויקט"
                                name="ProjectName"
                                value={editProjectForm.ProjectName}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="שם חניון"
                                name="ParkingFullName"
                                value={editProjectForm.ParkingFullName}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="מייל חניון"
                                name="ParkingEmail"
                                value={editProjectForm.ParkingEmail}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="כתובת חניון"
                                name="ParkingAddress"
                                value={editProjectForm.ParkingAddress}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="טלפון חניון"
                                name="ParkingPhoneNumber"
                                value={editProjectForm.ParkingPhoneNumber}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                />
                            </Grid>

                            {/* --- Parking Quantities --- */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" fontWeight={600} mt={2} mb={1}>חניות</Typography>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="כמות חניות מזדמנים"
                                name="ParkingCasualQty"
                                type="number"
                                value={editProjectForm.ParkingCasualQty || 0}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                inputProps={{ min: 0 }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="כמות חניות מנויים"
                                name="ParkingSubscriberQty"
                                type="number"
                                value={editProjectForm.ParkingSubscriberQty || 0}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                inputProps={{ min: 0 }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label="כמות חניות נכים"
                                name="ParkingDisabledQty"
                                type="number"
                                value={editProjectForm.ParkingDisabledQty || 0}
                                onChange={handleEditProjectChange}
                                fullWidth
                                margin="dense"
                                inputProps={{ min: 0 }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                label='סה"כ חניות (מחושב)'
                                value={
                                    Number(editProjectForm.ParkingCasualQty || 0) +
                                    Number(editProjectForm.ParkingSubscriberQty || 0) +
                                    Number(editProjectForm.ParkingDisabledQty || 0)
                                }
                                InputProps={{ readOnly: true }}
                                fullWidth
                                margin="dense"
                                />
                            </Grid>

                            {/* --- Pricing --- */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" fontWeight={600} mt={2} mb={1}>מחירון</Typography>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>
                            <Grid container spacing={2}>
                            {/* Subscriber Pricing Recommendation */}
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" flexDirection="column" gap={2}>
                                <FormControl fullWidth margin="dense">
                                    <InputLabel>המלצה למחירון מנויים</InputLabel>
                                    <Select
                                    name="SubscriberPricingRecommendation"
                                    value={editProjectForm.SubscriberPricingRecommendation || "none"}
                                    onChange={handleEditProjectChange}
                                    label="המלצה למחירון מנויים"
                                    >
                                    <MenuItem value="none">אין</MenuItem>
                                    <MenuItem value="company_decision">החלטת חברה</MenuItem>
                                    <MenuItem value="price">מחיר</MenuItem>
                                    </Select>
                                </FormControl>
                                {editProjectForm.SubscriberPricingRecommendation === "price" && (
                                    <TextField
                                    label="מחיר מנוי"
                                    name="SubscriberRecommendedPrice"
                                    type="number"
                                    value={editProjectForm.SubscriberRecommendedPrice || "none"}
                                    onChange={handleEditProjectChange}
                                    margin="dense"
                                    inputProps={{ min: 0 }}
                                    />
                                )}
                                </Box>
                            </Grid>

                            {/* Casual Pricing Recommendation */}
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" flexDirection="column" gap={2}>
                                <FormControl fullWidth margin="dense">
                                    <InputLabel>המלצה למחירון מזדמנים</InputLabel>
                                    <Select
                                    name="CasualPricingRecommendation"
                                    value={editProjectForm.CasualPricingRecommendation || "none"}
                                    onChange={handleEditProjectChange}
                                    label="המלצה למחירון מזדמנים"
                                    >
                                    <MenuItem value="none">אין</MenuItem>
                                    <MenuItem value="company_decision">החלטת חברה</MenuItem>
                                    <MenuItem value="price">מחיר</MenuItem>
                                    </Select>
                                </FormControl>
                                {editProjectForm.CasualPricingRecommendation === "price" && (
                                    <TextField
                                    label="מחיר מזדמן"
                                    name="CasualRecommendedPrice"
                                    type="number"
                                    value={editProjectForm.CasualRecommendedPrice || ""}
                                    onChange={handleEditProjectChange}
                                    margin="dense"
                                    inputProps={{ min: 0 }}

                                    />
                                )}
                                </Box>
                            </Grid>
                            </Grid>

                            {/* --- Actions --- */}
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                <Button onClick={() => setShowEditProjectModal(false)}>ביטול</Button>
                                <Button variant="contained" type="submit">שמירה</Button>
                                </Box>
                            </Grid>
                            </Grid>
                        </Box>
                        )}
                    </Box>
                    </Modal>

                    <Modal open={showChecklistModal} onClose={() => setShowChecklistModal(false)}>
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: paperBg,           // use your themed background
                            color: textColor,           // use your themed text color
                            p: 4,
                            borderRadius: 2,
                            minWidth: 350,
                            boxShadow: 8,
                            maxWidth: 500,
                            width: '95vw',
                        }}>
                            <Typography variant="h6" mb={2}>צ'קליסט מכירה</Typography>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={saleChecklist.ChargePermission}
                                            onChange={e => setSaleChecklist(c => ({ ...c, ChargePermission: e.target.checked }))}
                                            disabled={saleChecklist.ApprovedForExecution}
                                        />
                                    }
                                    label="הרשאה לחיוב"
                                />
                                <Collapse in={editSaleFormData?.LeadType === 'מכירה' && !saleChecklist.ApprovedForExecution}>
                                    <TextField
                                        label="מקדמה (50%)"
                                        type="number"
                                        value={saleChecklist.AdvanceAmount}
                                        onChange={e => setSaleChecklist(c => ({ ...c, AdvanceAmount: e.target.value }))}
                                        fullWidth
                                        margin="dense"
                                    />
                                </Collapse>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={saleChecklist.DepositRequired}
                                            onChange={e => setSaleChecklist(c => ({ ...c, DepositRequired: e.target.checked }))}
                                            disabled={saleChecklist.ApprovedForExecution}
                                        />
                                    }
                                    label="פיקדון"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={saleChecklist.ClearingAgreementSigned}
                                            onChange={e => setSaleChecklist(c => ({ ...c, ClearingAgreementSigned: e.target.checked }))}
                                            disabled={saleChecklist.ApprovedForExecution}
                                        />
                                    }
                                    label="הסכם סליקה חתום"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={saleChecklist.ParkingCreatedInFinance}
                                            onChange={e => setSaleChecklist(c => ({ ...c, ParkingCreatedInFinance: e.target.checked }))}
                                            disabled={saleChecklist.ApprovedForExecution}
                                        />
                                    }
                                    label="הקמת חניון במסטר פייננס"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={saleChecklist.MeirApproved}
                                            onChange={e => setSaleChecklist(c => ({ ...c, MeirApproved: e.target.checked }))}
                                            disabled={saleChecklist.ApprovedForExecution}
                                        />
                                    }
                                    label="חתימה של מאיר מאושר לביצוע"
                                />
                                <Button
                                    variant="outlined"
                                    sx={{ my: 1 }}
                                    disabled={saleChecklist.FinanceRowCreated}
                                    onClick={handleCreateFinanceRow}
                                >
                                    צור שורה בפייננס
                                </Button>
                                <Divider sx={{ my: 2 }} />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={saleChecklist.ApprovedForExecution}
                                            disabled={
                                                !saleChecklist.ChargePermission ||
                                                !saleChecklist.DepositRequired ||
                                                !saleChecklist.ClearingAgreementSigned ||
                                                !saleChecklist.ParkingCreatedInFinance ||
                                                !saleChecklist.MeirApproved ||
                                                saleChecklist.ApprovedForExecution
                                            }
                                            onChange={e => setSaleChecklist(c => ({ ...c, ApprovedForExecution: e.target.checked }))}
                                        />
                                    }
                                    label="מאושר לביצוע"
                                />
                            </FormGroup>

                            <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
                                <Button onClick={() => setShowChecklistModal(false)}>סגור</Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveChecklist}
                                >
                                    שמור
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </Box>}
        </DashboardLayout>
    )
};

export default MasterSales;
